
/* ===== BEGIN assets/me-product.js ===== */
document.addEventListener('DOMContentLoaded', () => {
  'use strict';

  /*
  =====================================================
  Shared helpers
  =====================================================
  */

  function escapeHtml(value) {
    return String(value)
      .replaceAll('&', '&amp;')
      .replaceAll('<', '&lt;')
      .replaceAll('>', '&gt;')
      .replaceAll('"', '&quot;')
      .replaceAll("'", '&#039;');
  }

  function normalizeQuantity(value) {
    const parsedValue = Number.parseInt(value, 10);

    if (!Number.isFinite(parsedValue) || parsedValue < 1) {
      return 1;
    }

    return parsedValue;
  }

  /*
  =====================================================
  Product gallery
  =====================================================
  */

  const mainImageWrapper = document.querySelector(
    '.me-main-product__image-main'
  );

  const galleryThumbs = document.querySelectorAll(
    '[data-me-product-thumb]'
  );

  if (mainImageWrapper && galleryThumbs.length) {
    galleryThumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => {
        const newSource = thumb.getAttribute(
          'data-me-product-thumb'
        );

        const mainImage = mainImageWrapper.querySelector('img');

        if (!mainImage || !newSource) return;

        mainImage.src = newSource;
        mainImage.srcset = '';
      });
    });
  }

  /*
  =====================================================
  Product-family color cards
  =====================================================
  */

  const catalog = window.MECatalog;

  const colorBlock = document.querySelector(
    '[data-me-family]'
  );

  const colorContainer = document.querySelector(
    '[data-me-catalog-colors]'
  );

  if (catalog && colorBlock && colorContainer) {
    const familyKey = colorBlock.dataset.meFamily;
    const currentHandle = colorBlock.dataset.meCurrentHandle;

    const family =
      catalog.families &&
      catalog.families[familyKey];

    if (
      family &&
      Array.isArray(family.colors) &&
      family.colors.length
    ) {
      colorContainer.innerHTML = family.colors
        .map((color) => {
          const activeClass =
            color.handle === currentHandle
              ? 'is-active'
              : '';

          const productUrl = `/products/${color.handle}`;
          const productJsonUrl = `${productUrl}.js`;

          return `
            <a
              href="${productUrl}"
              class="me-af-color-card ${activeClass}"
              data-me-product-json="${productJsonUrl}"
            >
              <span class="me-af-color-card__image">
                <span class="me-af-color-card__placeholder"></span>
              </span>

              <span class="me-af-color-card__name">
                ${escapeHtml(color.name)}
              </span>

              <span class="me-af-color-card__status">
                Checking stock...
              </span>
            </a>
          `;
        })
        .join('');

      const colorCards = document.querySelectorAll(
        '[data-me-product-json]'
      );

      colorCards.forEach(async (card) => {
        try {
          const response = await fetch(
            card.dataset.meProductJson
          );

          if (!response.ok) return;

          const productData = await response.json();

          const image =
            productData.featured_image ||
            productData.images?.[0];

          if (image) {
            const imageWrapper = card.querySelector(
              '.me-af-color-card__image'
            );

            if (imageWrapper) {
              imageWrapper.innerHTML = `
                <img
                  src="${image}"
                  alt="${escapeHtml(productData.title)}"
                  loading="lazy"
                >
              `;
            }
          }

          const variants = Array.isArray(productData.variants)
            ? productData.variants
            : [];

          const availableVariants = variants.filter(
            (variant) => variant.available
          );

          const totalInventory = variants.reduce(
            (total, variant) => {
              if (
                typeof variant.inventory_quantity ===
                'number'
              ) {
                return (
                  total +
                  Math.max(
                    variant.inventory_quantity,
                    0
                  )
                );
              }

              return total;
            },
            0
          );

          const statusElement = card.querySelector(
            '.me-af-color-card__status'
          );

          if (!statusElement) return;

          statusElement.classList.remove(
            'is-stock',
            'is-low',
            'is-backorder'
          );

          if (!availableVariants.length) {
            statusElement.textContent =
              '● Backorder Available';

            statusElement.classList.add(
              'is-backorder'
            );
          } else if (
            totalInventory > 0 &&
            totalInventory < 20
          ) {
            statusElement.textContent =
              '● Low Stock';

            statusElement.classList.add(
              'is-low'
            );
          } else {
            statusElement.textContent =
              '● In Stock';

            statusElement.classList.add(
              'is-stock'
            );
          }
        } catch (error) {
          console.warn(
            'Could not load color product:',
            error
          );
        }
      });
    }
  }

  /*
  =====================================================
  Size picker
  =====================================================
  */

  const sizeButtons = document.querySelectorAll(
    '[data-me-size-button]'
  );

  const selectedSizeLabel = document.querySelector(
    '[data-me-selected-size]'
  );

  const variantIdInput = document.querySelector(
    '[data-me-variant-id]'
  );

  const productPrice = document.querySelector(
    '[data-me-product-price]'
  );

  const addToCartButton = document.querySelector(
    '.me-main-product__button'
  );

  sizeButtons.forEach((button) => {
    button.addEventListener('click', (event) => {
      event.preventDefault();

      if (button.disabled) return;

      const variantId =
        button.dataset.variantId;

      const variantTitle =
        button.dataset.variantTitle;

      const variantPrice =
        button.dataset.variantPrice;

      const variantAvailable =
        button.dataset.variantAvailable === 'true';

      sizeButtons.forEach((item) => {
        item.classList.remove('is-active');
        item.setAttribute(
          'aria-pressed',
          'false'
        );
      });

      button.classList.add('is-active');
      button.setAttribute(
        'aria-pressed',
        'true'
      );

      if (variantIdInput && variantId) {
        variantIdInput.value = variantId;
      }

      if (selectedSizeLabel && variantTitle) {
        selectedSizeLabel.textContent =
          `Selected: ${variantTitle}`;
      }

      if (productPrice && variantPrice) {
        productPrice.textContent =
          variantPrice;
      }

      if (addToCartButton) {
        addToCartButton.disabled =
          !variantAvailable;

        addToCartButton.textContent =
          variantAvailable
            ? 'Add to Cart'
            : 'Unavailable';
      }

      if (
        variantId &&
        window.history?.replaceState
      ) {
        const url = new URL(
          window.location.href
        );

        url.searchParams.set(
          'variant',
          variantId
        );

        window.history.replaceState(
          {},
          '',
          url.toString()
        );
      }
    });
  });

  /*
  =====================================================
  Quantity picker
  =====================================================
  */

  const quantityInput = document.querySelector(
    '[data-me-quantity-input]'
  );

  const decreaseQuantityButton =
    document.querySelector(
      '[data-me-quantity-minus]'
    );

  const increaseQuantityButton =
    document.querySelector(
      '[data-me-quantity-plus]'
    );

  if (
    decreaseQuantityButton &&
    quantityInput
  ) {
    decreaseQuantityButton.addEventListener(
      'click',
      (event) => {
        event.preventDefault();

        const currentValue =
          normalizeQuantity(
            quantityInput.value
          );

        quantityInput.value = Math.max(
          1,
          currentValue - 1
        );

        quantityInput.dispatchEvent(
          new Event('change', {
            bubbles: true
          })
        );
      }
    );
  }

  if (
    increaseQuantityButton &&
    quantityInput
  ) {
    increaseQuantityButton.addEventListener(
      'click',
      (event) => {
        event.preventDefault();

        const currentValue =
          normalizeQuantity(
            quantityInput.value
          );

        quantityInput.value =
          currentValue + 1;

        quantityInput.dispatchEvent(
          new Event('change', {
            bubbles: true
          })
        );
      }
    );
  }

  if (quantityInput) {
    quantityInput.addEventListener(
      'change',
      () => {
        quantityInput.value =
          normalizeQuantity(
            quantityInput.value
          );
      }
    );
  }

  /*
  =====================================================
  Artwork upload elements
  =====================================================
  */

  const artworkInput = document.querySelector(
    '[data-me-artwork-input]'
  );

  const uploadZone = document.querySelector(
    '[data-me-upload-zone]'
  );

  const artworkResult = document.querySelector(
    '[data-me-artwork-result]'
  );

  const artworkPreview = document.querySelector(
    '[data-me-artwork-preview]'
  );

  const artworkName = document.querySelector(
    '[data-me-artwork-name]'
  );

  const artworkDimensions = document.querySelector(
    '[data-me-artwork-dimensions]'
  );

  const removeArtworkButton = document.querySelector(
    '[data-me-remove-artwork]'
  );

  const validationBox = document.querySelector(
    '[data-me-artwork-validation]'
  );

  const qualityBox = document.querySelector(
    '[data-me-print-quality]'
  );

  const optimizationBox = document.querySelector(
    '[data-me-artwork-optimization]'
  );

  const optimizationHeading = document.querySelector(
    '[data-me-optimization-heading]'
  );

  const optimizationMessage = document.querySelector(
    '[data-me-optimization-message]'
  );

  const optimizationProperty = document.querySelector(
    '[data-me-optimization-property]'
  );

  const reviewStatusProperty = document.querySelector(
    '[data-me-review-status-property]'
  );

  const placementButtons = document.querySelectorAll(
    '[data-me-placement-button]'
  );

  const placementValueInput = document.querySelector(
    '[data-me-placement-value]'
  );

  let currentArtwork = null;
  let selectedPrintWidth = 4;

  /*
  =====================================================
  Placement controls
  =====================================================
  */

  placementButtons.forEach((button) => {
    button.addEventListener(
      'click',
      (event) => {
        event.preventDefault();
        event.stopPropagation();

        const placementName =
          button.dataset.placementName ||
          'Left Chest';

        const printWidth = Number(
          button.dataset.printWidth
        );

        placementButtons.forEach((item) => {
          item.classList.remove(
            'is-active'
          );

          item.setAttribute(
            'aria-pressed',
            'false'
          );
        });

        button.classList.add(
          'is-active'
        );

        button.setAttribute(
          'aria-pressed',
          'true'
        );

        if (placementValueInput) {
          placementValueInput.value =
            placementName;
        }

        if (
          Number.isFinite(printWidth) &&
          printWidth > 0
        ) {
          selectedPrintWidth =
            printWidth;
        }

        if (currentArtwork) {
          updateEffectiveDpi(
            currentArtwork.width,
            currentArtwork.height,
            selectedPrintWidth
          );
        }
      }
    );
  });

  /*
  =====================================================
  Artwork input
  =====================================================
  */

  if (artworkInput) {
    artworkInput.addEventListener(
      'change',
      () => {
        const file =
          artworkInput.files?.[0];

        if (!file) {
          resetArtwork();
          return;
        }

        validateArtwork(file);
      }
    );
  }

  if (removeArtworkButton) {
    removeArtworkButton.addEventListener(
      'click',
      resetArtwork
    );
  }

  /*
  =====================================================
  Drag and drop
  =====================================================
  */

  if (uploadZone && artworkInput) {
    ['dragenter', 'dragover'].forEach(
      (eventName) => {
        uploadZone.addEventListener(
          eventName,
          (event) => {
            event.preventDefault();

            uploadZone.classList.add(
              'is-dragging'
            );
          }
        );
      }
    );

    ['dragleave', 'drop'].forEach(
      (eventName) => {
        uploadZone.addEventListener(
          eventName,
          (event) => {
            event.preventDefault();

            uploadZone.classList.remove(
              'is-dragging'
            );
          }
        );
      }
    );

    uploadZone.addEventListener(
      'drop',
      (event) => {
        const file =
          event.dataTransfer?.files?.[0];

        if (!file) return;

        try {
          const transfer =
            new DataTransfer();

          transfer.items.add(file);
          artworkInput.files =
            transfer.files;
        } catch (error) {
          console.warn(
            'Could not assign dropped file:',
            error
          );
        }

        validateArtwork(file);
      }
    );
  }

  /*
  =====================================================
  Validate artwork
  =====================================================
  */

  function validateArtwork(file) {
    const maximumBytes =
      25 * 1024 * 1024;

    const isPng =
      file.type === 'image/png' ||
      file.name
        .toLowerCase()
        .endsWith('.png');

    showValidation();

    setValidationStatus(
      '[data-me-validation-format]',
      isPng ? 'success' : 'error',
      isPng
        ? 'PNG file detected.'
        : 'Please upload a PNG file.'
    );

    if (!isPng) {
      setSummary(
        'error',
        'This file cannot be used. Please upload a PNG.'
      );

      if (artworkInput) {
        artworkInput.value = '';
      }

      return;
    }

    if (file.size > maximumBytes) {
      setSummary(
        'error',
        'This file is larger than 25 MB. Please upload a smaller PNG.'
      );

      if (artworkInput) {
        artworkInput.value = '';
      }

      return;
    }

    if (
      currentArtwork &&
      currentArtwork.objectUrl
    ) {
      URL.revokeObjectURL(
        currentArtwork.objectUrl
      );
    }

    const objectUrl =
      URL.createObjectURL(file);

    const image = new Image();

    image.onload = () => {
      const width =
        image.naturalWidth;

      const height =
        image.naturalHeight;

      currentArtwork = {
        file,
        width,
        height,
        objectUrl
      };

      if (artworkPreview) {
        artworkPreview.src =
          objectUrl;
      }

      if (artworkName) {
        artworkName.textContent =
          file.name;
      }

      if (artworkDimensions) {
        artworkDimensions.textContent =
          `${width.toLocaleString()} × ` +
          `${height.toLocaleString()} pixels`;
      }

      if (artworkResult) {
        artworkResult.hidden =
          false;
      }

      if (uploadZone) {
        uploadZone.classList.add(
          'has-file'
        );
      }

      const dimensionsPass =
        width >= 1200 &&
        height >= 1000;

      setValidationStatus(
        '[data-me-validation-dimensions]',
        dimensionsPass
          ? 'success'
          : 'warning',
        `${width.toLocaleString()} × ` +
          `${height.toLocaleString()} pixels`
      );

      detectTransparency(
        image,
        width,
        height
      );

      updateEffectiveDpi(
        width,
        height,
        selectedPrintWidth
      );
    };

    image.onerror = () => {
      setSummary(
        'error',
        'This PNG could not be read. Please try another file.'
      );

      if (artworkInput) {
        artworkInput.value = '';
      }

      URL.revokeObjectURL(
        objectUrl
      );
    };

    image.src = objectUrl;
  }

  /*
  =====================================================
  Transparency detection
  =====================================================
  */

  async function removeLightBackground(file) {
    const url = URL.createObjectURL(file);
    try {
      const image = await new Promise((resolve, reject) => {
        const candidate = new Image();
        candidate.onload = () => resolve(candidate);
        candidate.onerror = reject;
        candidate.src = url;
      });
      const maxDimension = 2400;
      const scale = Math.min(1, maxDimension / Math.max(image.naturalWidth, image.naturalHeight));
      const width = Math.max(1, Math.round(image.naturalWidth * scale));
      const height = Math.max(1, Math.round(image.naturalHeight * scale));
      const canvas = document.createElement('canvas');
      canvas.width = width;
      canvas.height = height;
      const context = canvas.getContext('2d', { willReadFrequently: true });
      context.drawImage(image, 0, 0, width, height);
      const imageData = context.getImageData(0, 0, width, height);
      const pixels = imageData.data;
      const threshold = 238;
      const softness = 28;
      for (let i = 0; i < pixels.length; i += 4) {
        const r = pixels[i], g = pixels[i + 1], b = pixels[i + 2];
        const min = Math.min(r, g, b);
        const max = Math.max(r, g, b);
        const neutral = max - min < 24;
        if (neutral && min >= threshold) {
          const distance = Math.max(0, 255 - min);
          pixels[i + 3] = Math.min(pixels[i + 3], Math.round((distance / softness) * 255));
        }
      }
      context.putImageData(imageData, 0, 0);
      const blob = await new Promise((resolve) => canvas.toBlob(resolve, 'image/png', 1));
      if (!blob) return file;
      const base = file.name.replace(/\.png$/i, '');
      return new File([blob], `${base}-background-removed.png`, { type: 'image/png' });
    } finally {
      URL.revokeObjectURL(url);
    }
  }

  function detectTransparency(
    image,
    width,
    height
  ) {
    try {
      const canvas =
        document.createElement(
          'canvas'
        );

      const context =
        canvas.getContext(
          '2d',
          {
            willReadFrequently: true
          }
        );

      if (!context) {
        setValidationStatus(
          '[data-me-validation-transparency]',
          'warning',
          'Transparency could not be checked automatically.'
        );

        return;
      }

      const sampleWidth =
        Math.min(width, 600);

      const sampleHeight =
        Math.max(
          1,
          Math.round(
            height *
              (sampleWidth / width)
          )
        );

      canvas.width =
        sampleWidth;

      canvas.height =
        sampleHeight;

      context.clearRect(
        0,
        0,
        sampleWidth,
        sampleHeight
      );

      context.drawImage(
        image,
        0,
        0,
        sampleWidth,
        sampleHeight
      );

      const pixels =
        context.getImageData(
          0,
          0,
          sampleWidth,
          sampleHeight
        ).data;

      let transparentPixelFound =
        false;

      for (
        let index = 3;
        index < pixels.length;
        index += 4
      ) {
        if (pixels[index] < 250) {
          transparentPixelFound =
            true;

          break;
        }
      }

      setValidationStatus(
        '[data-me-validation-transparency]',
        transparentPixelFound
          ? 'success'
          : 'warning',
        transparentPixelFound
          ? 'Transparent background detected.'
          : 'No transparent background detected. The artwork may print with a solid background.'
      );
    } catch (error) {
      console.warn(
        'Transparency check failed:',
        error
      );

      setValidationStatus(
        '[data-me-validation-transparency]',
        'warning',
        'Transparency could not be checked automatically.'
      );
    }
  }

  /*
  =====================================================
  Print quality helpers
  =====================================================
  */

  function getPrintQuality(dpi) {
    if (dpi >= 300) {
      return {
        rating: 'Excellent',
        status: 'success',
        stars: 5
      };
    }

    if (dpi >= 250) {
      return {
        rating: 'Very Good',
        status: 'success',
        stars: 4
      };
    }

    if (dpi >= 200) {
      return {
        rating: 'Good',
        status: 'warning',
        stars: 3
      };
    }

    if (dpi >= 150) {
      return {
        rating: 'Fair',
        status: 'warning',
        stars: 2
      };
    }

    return {
      rating: 'Low Resolution',
      status: 'error',
      stars: 1
    };
  }

  function updateEffectiveDpi(
    width,
    height,
    suppliedPrintWidth
  ) {
    try {
      let printWidth = Number(
        suppliedPrintWidth
      );

      if (
        !Number.isFinite(printWidth) ||
        printWidth <= 0
      ) {
        printWidth =
          selectedPrintWidth;
      }

      if (
        !Number.isFinite(printWidth) ||
        printWidth <= 0
      ) {
        printWidth = 4;
      }

      if (
        !Number.isFinite(width) ||
        width <= 0
      ) {
        return;
      }

      const effectiveDpi =
        Math.round(
          width / printWidth
        );

      const quality =
        getPrintQuality(
          effectiveDpi
        );

      setValidationStatus(
        '[data-me-validation-dpi]',
        quality.status,
        `${effectiveDpi} effective DPI at approximately ${printWidth} inches wide.`
      );

      if (
        quality.status ===
        'success'
      ) {
        setSummary(
          'success',
          'Artwork quality looks suitable for the selected print location.'
        );
      } else if (
        quality.status ===
        'warning'
      ) {
        setSummary(
          'warning',
          'The artwork may be usable, but review the print-quality recommendations below.'
        );
      } else {
        setSummary(
          'error',
          'A higher-resolution PNG is recommended for this print location.'
        );
      }

      updatePrintQualityReport(
        width,
        printWidth
      );

      updateArtworkOptimization(
        effectiveDpi,
        printWidth
      );
    } catch (error) {
      console.warn(
        'DPI and artwork-quality calculation failed:',
        error
      );
    }
  }

  function updatePrintQualityReport(
    imageWidth,
    currentPrintWidth
  ) {
    if (!qualityBox) return;

    const currentDpi =
      Math.round(
        imageWidth /
          currentPrintWidth
      );

    const currentQuality =
      getPrintQuality(
        currentDpi
      );

    const starsElement =
      qualityBox.querySelector(
        '[data-me-quality-stars]'
      );

    const ratingElement =
      qualityBox.querySelector(
        '[data-me-quality-rating]'
      );

    const dpiElement =
      qualityBox.querySelector(
        '[data-me-quality-current-dpi]'
      );

    const recommendedElement =
      qualityBox.querySelector(
        '[data-me-quality-recommended]'
      );

    const warningsElement =
      qualityBox.querySelector(
        '[data-me-quality-warnings]'
      );

    const placements = [
      {
        name: 'Left Chest',
        width: 4
      },
      {
        name: 'Hat Logo',
        width: 3.5
      },
      {
        name: 'Left Sleeve',
        width: 3.5
      },
      {
        name: 'Right Sleeve',
        width: 3.5
      },
      {
        name: 'Full Front',
        width: 11
      },
      {
        name: 'Full Back',
        width: 11
      }
    ];

    const recommended = [];
    const warnings = [];

    placements.forEach(
      (placement) => {
        const placementDpi =
          Math.round(
            imageWidth /
              placement.width
          );

        if (
          placementDpi >= 250
        ) {
          recommended.push({
            ...placement,
            dpi: placementDpi
          });
        } else {
          warnings.push({
            ...placement,
            dpi: placementDpi
          });
        }
      }
    );

    if (starsElement) {
      starsElement.textContent =
        '★'.repeat(
          currentQuality.stars
        ) +
        '☆'.repeat(
          5 -
            currentQuality.stars
        );
    }

    if (ratingElement) {
      ratingElement.textContent =
        currentQuality.rating;
    }

    if (dpiElement) {
      dpiElement.textContent =
        `${currentDpi} Effective DPI`;
    }

    qualityBox.classList.remove(
      'is-success',
      'is-warning',
      'is-error'
    );

    qualityBox.classList.add(
      `is-${currentQuality.status}`
    );

    if (recommendedElement) {
      recommendedElement.innerHTML =
        recommended.length
          ? recommended
              .map(
                (item) => `
                  <div class="me-print-quality__recommendation">
                    <span>✓</span>

                    <span>
                      ${escapeHtml(item.name)}
                      <small>${item.dpi} DPI</small>
                    </span>
                  </div>
                `
              )
              .join('')
          : `
              <div class="me-print-quality__recommendation is-empty">
                A higher-resolution image is recommended for all listed placements.
              </div>
            `;
    }

    if (warningsElement) {
      warningsElement.innerHTML =
        warnings
          .map(
            (item) => `
              <div class="me-print-quality__warning">
                <span>⚠</span>

                <span>
                  ${escapeHtml(item.name)}
                  will reduce quality to
                  <strong>${item.dpi} DPI</strong>.
                </span>
              </div>
            `
          )
          .join('');
    }

    qualityBox.hidden = false;
  }

  /*
  =====================================================
  Artwork optimization/review notice
  =====================================================
  */

  function updateArtworkOptimization(
    effectiveDpi,
    printWidth
  ) {
    if (!optimizationBox) return;

    const optimizationIcon =
      optimizationBox.querySelector(
        '.me-artwork-optimization__icon'
      );

    optimizationBox.hidden =
      false;

    optimizationBox.classList.remove(
      'is-standard',
      'is-optimization',
      'is-review'
    );

    if (effectiveDpi >= 300) {
      optimizationBox.classList.add(
        'is-standard'
      );

      if (optimizationIcon) {
        optimizationIcon.textContent =
          '✓';
      }

      if (optimizationHeading) {
        optimizationHeading.textContent =
          'Artwork Quality Review Included';
      }

      if (optimizationMessage) {
        optimizationMessage.textContent =
          `This artwork is approximately ${effectiveDpi} DPI at ${printWidth} inches wide and should produce excellent print quality.`;
      }

      if (optimizationProperty) {
        optimizationProperty.value =
          'Not required — artwork meets recommended quality';
      }

      if (reviewStatusProperty) {
        reviewStatusProperty.value =
          'Standard review';
      }

      return;
    }

    if (effectiveDpi >= 150) {
      optimizationBox.classList.add(
        'is-optimization'
      );

      if (optimizationIcon) {
        optimizationIcon.textContent =
          '✦';
      }

      if (optimizationHeading) {
        optimizationHeading.textContent =
          'Automatic Artwork Optimization Included';
      }

      if (optimizationMessage) {
        optimizationMessage.textContent =
          `This artwork is approximately ${effectiveDpi} DPI at ${printWidth} inches wide. We will optimize it when possible before production.`;
      }

      if (optimizationProperty) {
        optimizationProperty.value =
          'Automatic optimization included';
      }

      if (reviewStatusProperty) {
        reviewStatusProperty.value =
          'Optimization review required';
      }

      return;
    }

    optimizationBox.classList.add(
      'is-review'
    );

    if (optimizationIcon) {
      optimizationIcon.textContent =
        '!';
    }

    if (optimizationHeading) {
      optimizationHeading.textContent =
        'Artwork Review Required';
    }

    if (optimizationMessage) {
      optimizationMessage.textContent =
        `This artwork is approximately ${effectiveDpi} DPI at ${printWidth} inches wide and may appear blurry. We will review it and contact you only if a better file is required.`;
    }

    if (optimizationProperty) {
      optimizationProperty.value =
        'Optimization attempted when possible';
    }

    if (reviewStatusProperty) {
      reviewStatusProperty.value =
        'Manual review required';
    }
  }

  /*
  =====================================================
  Validation UI helpers
  =====================================================
  */

  function showValidation() {
    if (validationBox) {
      validationBox.hidden =
        false;
    }
  }

  function setValidationStatus(
    selector,
    status,
    message
  ) {
    const item =
      document.querySelector(
        selector
      );

    if (!item) return;

    const icon =
      item.querySelector(
        '.me-artwork-validation__icon'
      );

    const text =
      item.querySelector(
        '.me-artwork-validation__text'
      );

    item.classList.remove(
      'is-success',
      'is-warning',
      'is-error'
    );

    item.classList.add(
      `is-${status}`
    );

    if (icon) {
      icon.textContent =
        status === 'success'
          ? '✓'
          : status === 'error'
            ? '!'
            : '⚠';
    }

    if (text) {
      text.textContent =
        message;
    }
  }

  function setSummary(
    status,
    message
  ) {
    const summary =
      document.querySelector(
        '[data-me-validation-summary]'
      );

    if (!summary) return;

    summary.classList.remove(
      'is-success',
      'is-warning',
      'is-error'
    );

    summary.classList.add(
      `is-${status}`
    );

    summary.textContent =
      message;
  }

  /*
  =====================================================
  Reset artwork
  =====================================================
  */

  function resetArtwork() {
    if (
      currentArtwork &&
      currentArtwork.objectUrl
    ) {
      URL.revokeObjectURL(
        currentArtwork.objectUrl
      );
    }

    currentArtwork = null;

    if (artworkInput) {
      artworkInput.value = '';
    }

    if (artworkPreview) {
      artworkPreview.src = '';
    }

    if (artworkResult) {
      artworkResult.hidden =
        true;
    }

    if (validationBox) {
      validationBox.hidden =
        true;
    }

    if (qualityBox) {
      qualityBox.hidden =
        true;
    }

    if (optimizationBox) {
      optimizationBox.hidden =
        true;

      optimizationBox.classList.remove(
        'is-standard',
        'is-optimization',
        'is-review'
      );
    }

    if (optimizationProperty) {
      optimizationProperty.value =
        'Not required';
    }

    if (reviewStatusProperty) {
      reviewStatusProperty.value =
        'Standard review';
    }

    if (uploadZone) {
      uploadZone.classList.remove(
        'has-file',
        'is-dragging'
      );
    }
  }
});
/* ===== END assets/me-product.js ===== */


/* ===== BEGIN assets/me-color-designer.js ===== */
document.addEventListener('DOMContentLoaded', () => {
  'use strict';

  const designer = document.querySelector(
    '[data-me-designer]'
  );

  const colorSection = document.querySelector(
    '[data-me-designer-colors]'
  );

  const sizePicker = document.querySelector(
    '[data-me-size-picker]'
  );

  const productForm = document.querySelector(
    '.me-main-product__form'
  );

  if (!designer || !productForm) return;

  const swatchContainer = colorSection?.querySelector(
    '[data-me-designer-color-swatches]'
  );

  const selectedColorLabel = colorSection?.querySelector(
    '[data-me-selected-color]'
  );

  const selectedStockLabel = colorSection?.querySelector(
    '[data-me-selected-color-stock]'
  );

  const colorMessage = colorSection?.querySelector(
    '[data-me-color-message]'
  );

  const sizeGrid = sizePicker?.querySelector(
    '[data-me-size-grid]'
  );

  const selectedSizeLabel = sizePicker?.querySelector(
    '[data-me-selected-size]'
  );

  const sizeMessage = sizePicker?.querySelector(
    '[data-me-size-message]'
  );

  const sizePropertyInput = sizePicker?.querySelector(
    '[data-me-size-property]'
  );

  const variantIdInput = productForm.querySelector(
    '[data-me-variant-id]'
  );

  const productPrice = document.querySelector(
    '[data-me-product-price]'
  );

  const designerTitle = designer.querySelector(
    '.me-designer__brand h2'
  );

  const initialProductScript = document.querySelector(
    '[data-me-initial-product-json]'
  );

  const catalog = window.MECatalog;

  const familyKey =
    colorSection?.dataset.meFamily || '';

  const family =
    catalog?.families?.[familyKey] || null;

  let currentHandle =
    colorSection?.dataset.meCurrentHandle || '';

  let currentProduct = readInitialProduct();
  window.MomentsCurrentProduct = currentProduct;
  let selectedColorName = '';
  let selectedSizeValue = '';
  let selectedVariant = null;

  const registrySizes = window.MEApparelEngine?.config?.sizes || [];

  const fallbackSizes = String(
    sizePicker?.dataset.meFallbackSizes || registrySizes.join('|') || ''
  )
    .split('|')
    .map((size) => size.trim())
    .filter(Boolean);

  const colorStyles = {
    black: '#171717',
    white: '#f8f7f2',
    turquoise: '#17a9c6',
    teal: '#168d8b',
    'sports-grey': '#b8b8b5',
    'sports-gray': '#b8b8b5',
    royal: '#2650a0',
    red: '#d91e32',
    purple: '#693878',
    'pacific-blue': '#91d5d4',
    orange: '#ff633e',
    navy: '#172451',
    'pure-navy': '#172451',
    'dark-navy': '#111827',
    'moss-green': '#28513c',
    green: '#2d7048',
    mint: '#b7ded2',
    'hot-pink': '#ff527b',
    gold: '#f1aa00',
    yellow: '#ffd239',
    dust: '#e9dfd0',
    charcoal: '#424242',

    'charcoal-heather':
      'linear-gradient(135deg, #333 0%, #595959 48%, #3a3a3a 100%)',

    'dark-heather':
      'linear-gradient(135deg, #303030 0%, #505050 48%, #353535 100%)',

    'grey-heather':
      'linear-gradient(135deg, #929292 0%, #b8b8b8 48%, #989898 100%)',

    'gray-heather':
      'linear-gradient(135deg, #929292 0%, #b8b8b8 48%, #989898 100%)',

    burgundy: '#762135',
    maroon: '#641f30',
    'baby-pink': '#f2cbd3',
    coral: '#ef786b',
    pink: '#f3b5c5',
    'royal-am': '#2650a0',
    'dust-pm': '#e3dacb',
    'neon-yellow': '#d7ff2f',
    'neon-orange': '#ff5a1f',

    camo:
      'linear-gradient(135deg, #3c4b31 0%, #786f4a 35%, #263d2b 70%, #665f43 100%)',
    'decadent-chocolate': '#4b2c24',
    'texas-orange': '#c95a1d',
    sand: '#d9c7aa',
    'sawana-brown': '#8a674c',
    'lime-green': '#82c341',
    lavender: '#c7a6d8',
    rust: '#a94f2d',
    peach: '#f3c3a5',
    mustard: '#c89b2f',
    'kelly-green': '#16854b',
    'military-green': '#5b6346',
    'royal-blue': '#2650a0',
    'sports-grey': '#b8b8b5',
    'pure-navy': '#172451'
  };

  function readInitialProduct() {
    if (!initialProductScript) return null;

    try {
      return JSON.parse(
        initialProductScript.textContent
      );
    } catch (error) {
      console.warn(
        'Unable to read initial product JSON.',
        error
      );

      return null;
    }
  }

  function slugify(value) {
    return String(value || '')
      .trim()
      .toLowerCase()
      .replace(/&/g, 'and')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-|-$/g, '');
  }

  function normalizeOptionName(value) {
    return String(value || '')
      .trim()
      .toLowerCase();
  }

  function escapeHtml(value) {
    return String(value || '')
      .replaceAll('&', '&amp;')
      .replaceAll('<', '&lt;')
      .replaceAll('>', '&gt;')
      .replaceAll('"', '&quot;')
      .replaceAll("'", '&#039;');
  }

  function formatMoney(cents) {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD'
    }).format((Number(cents) || 0) / 100);
  }

  function getProductOptions(productData) {
    if (!productData) return [];

    if (!Array.isArray(productData.options)) {
      return [];
    }

    return productData.options.map((option) => {
      if (typeof option === 'string') {
        return option;
      }

      return option?.name || '';
    });
  }

  function findOptionIndex(
    productData,
    acceptedNames
  ) {
    const options =
      getProductOptions(productData);

    return options.findIndex((optionName) =>
      acceptedNames.includes(
        normalizeOptionName(optionName)
      )
    );
  }

  function getSizeOptionIndex(productData) {
    return findOptionIndex(productData, [
      'size',
      'shirt size',
      'garment size',
      'apparel size'
    ]);
  }

  function getColorOptionIndex(productData) {
    return findOptionIndex(productData, [
      'color',
      'colour',
      'shirt color',
      'garment color'
    ]);
  }

  function getVariantOptions(variant) {
    if (Array.isArray(variant?.options)) {
      return variant.options;
    }

    return [
      variant?.option1,
      variant?.option2,
      variant?.option3
    ];
  }

  function getVariantOption(
    variant,
    optionIndex
  ) {
    if (optionIndex < 0) return '';

    return (
      getVariantOptions(variant)[optionIndex] ||
      ''
    );
  }

  function getVariants(productData) {
    return Array.isArray(productData?.variants)
      ? productData.variants
      : [];
  }

  function inferColorFromTitle(productData) {
    const title =
      String(productData?.title || '').trim();

    if (!title.includes(' - ')) {
      return '';
    }

    return title
      .split(' - ')
      .pop()
      .trim();
  }

  function findFamilyColorByHandle(handle) {
    if (!family?.colors?.length) return null;

    return family.colors.find(
      (color) => color.handle === handle
    ) || null;
  }

  function normalizeImageSource(source) {
    if (!source) return '';

    if (typeof source === 'string') {
      return source;
    }

    return (
      source.src ||
      source.url ||
      source.originalSrc ||
      ''
    );
  }

  function getCatalogColorImage(handle) {
    return normalizeImageSource(
      findFamilyColorByHandle(handle)?.image || ''
    );
  }

  function resolveInitialColor() {
    const familyColor =
      findFamilyColorByHandle(currentHandle);

    if (familyColor?.name) {
      return familyColor.name;
    }

    const titleColor =
      inferColorFromTitle(currentProduct);

    if (titleColor) {
      return titleColor;
    }

    const labelText = String(
      selectedColorLabel?.textContent || ''
    )
      .replace(/^Selected:\s*/i, '')
      .trim();

    if (
      labelText &&
      !labelText
        .toLowerCase()
        .includes('premium tee')
    ) {
      return labelText;
    }

    return '';
  }

  function updateColorDisplay() {
    if (!selectedColorLabel) return;

    selectedColorLabel.textContent =
      selectedColorName
        ? `Selected: ${selectedColorName}`
        : 'Select a color';
  }

  function getAvailableSizes(
    productData,
    colorName
  ) {
    const sizeIndex =
      getSizeOptionIndex(productData);

    if (sizeIndex < 0) return [];

    const colorIndex =
      getColorOptionIndex(productData);

    const sizes = new Map();

    getVariants(productData).forEach(
      (variant) => {
        if (
          colorIndex >= 0 &&
          colorName &&
          slugify(getVariantOption(
            variant,
            colorIndex
          )) !== slugify(colorName)
        ) {
          return;
        }

        const size = getVariantOption(
          variant,
          sizeIndex
        );

        if (!size) return;

        const existing = sizes.get(size);

        sizes.set(size, {
          value: size,

          available:
            Boolean(existing?.available) ||
            Boolean(variant.available)
        });
      }
    );

    return Array.from(sizes.values());
  }

  function findMatchingVariant({
    productData,
    colorName,
    sizeValue,
    requireAvailable = false
  }) {
    const sizeIndex =
      getSizeOptionIndex(productData);

    const colorIndex =
      getColorOptionIndex(productData);

    return getVariants(productData).find(
      (variant) => {
        if (
          requireAvailable &&
          !variant.available
        ) {
          return false;
        }

        if (
          colorIndex >= 0 &&
          colorName &&
          slugify(getVariantOption(
            variant,
            colorIndex
          )) !== slugify(colorName)
        ) {
          return false;
        }

        if (
          sizeIndex >= 0 &&
          sizeValue &&
          getVariantOption(
            variant,
            sizeIndex
          ) !== sizeValue
        ) {
          return false;
        }

        return true;
      }
    ) || null;
  }

  function getDefaultAvailableVariant(
    productData
  ) {
    return (
      getVariants(productData).find(
        (variant) => variant.available
      ) ||
      getVariants(productData)[0] ||
      null
    );
  }

  function updateSelectedSizeDisplay() {
    if (selectedSizeLabel) {
      selectedSizeLabel.textContent =
        selectedSizeValue
          ? `Selected: ${selectedSizeValue}`
          : 'Size selection required';
    }

    if (sizeMessage) {
      if (selectedSizeValue) {
        sizeMessage.textContent =
          `Selected size: ${selectedSizeValue}`;

        sizeMessage.classList.remove(
          'is-required'
        );

        sizeMessage.classList.add(
          'is-complete'
        );
      } else {
        const multiSizeSelected = document.querySelector('[data-me-order-mode="multiple"]')?.checked
          || document.querySelector('[data-me-order-mode][value="multiple"]')?.checked
          || document.querySelector('[data-me-order-type="multiple"]')?.checked;

        sizeMessage.textContent = multiSizeSelected
          ? 'Enter at least one size quantity to continue.'
          : 'Select a garment size to continue.';

        sizeMessage.classList.remove(
          'is-complete'
        );

        sizeMessage.classList.add(
          'is-required'
        );
      }
    }
  }

  function updateSizeProperty() {
    if (!sizePropertyInput) return;

    sizePropertyInput.value =
      selectedSizeValue || '';
  }

  function renderFallbackSizes() {
    if (!sizeGrid || !fallbackSizes.length) {
      return;
    }

    if (
      selectedSizeValue &&
      !fallbackSizes.includes(selectedSizeValue)
    ) {
      selectedSizeValue = '';
    }

    sizeGrid.hidden = false;

    sizeGrid.innerHTML = fallbackSizes
      .map((size) => {
        const active =
          size === selectedSizeValue;

        return `
          <button
            type="button"
            class="me-size-picker__button ${
              active ? 'is-active' : ''
            }"
            data-me-size-button
            data-size-value="${escapeHtml(size)}"
            data-me-fallback-size
            aria-pressed="${active ? 'true' : 'false'}"
          >
            <span>${escapeHtml(size)}</span>
          </button>
        `;
      })
      .join('');

    updateSelectedSizeDisplay();
    updateSizeProperty();

    selectedVariant =
      getDefaultAvailableVariant(
        currentProduct
      );

    applyVariant(selectedVariant);
    dispatchSelectionState();
  }

  function renderNativeSizes(productData) {
    if (!sizeGrid) return;

    const sizes = getAvailableSizes(
      productData,
      selectedColorName
    );

    const selectedSizeRecord =
      sizes.find(
        (size) =>
          size.value === selectedSizeValue &&
          size.available
      );

    if (
      selectedSizeValue &&
      !selectedSizeRecord
    ) {
      selectedSizeValue = '';
    }

    sizeGrid.hidden = false;

    sizeGrid.innerHTML = sizes
      .map((size) => {
        const active =
          size.value === selectedSizeValue;

        return `
          <button
            type="button"
            class="me-size-picker__button ${
              active ? 'is-active' : ''
            }"
            data-me-size-button
            data-size-value="${escapeHtml(size.value)}"
            aria-pressed="${active ? 'true' : 'false'}"
            ${size.available ? '' : 'disabled'}
          >
            <span>${escapeHtml(size.value)}</span>

            ${
              size.available
                ? ''
                : '<small>Unavailable</small>'
            }
          </button>
        `;
      })
      .join('');

    updateSelectedSizeDisplay();
    updateSizeProperty();

    if (selectedSizeValue) {
      selectedVariant =
        findMatchingVariant({
          productData,
          colorName: selectedColorName,
          sizeValue: selectedSizeValue,
          requireAvailable: true
        }) ||
        findMatchingVariant({
          productData,
          colorName: selectedColorName,
          sizeValue: selectedSizeValue
        });
    } else {
      /*
       * Keep the preview on the chosen color before a size is selected.
       * Previously this used the product's first available variant, which
       * caused 2011/2013 to jump back to Black or Sports Grey.
       */
      selectedVariant =
        findMatchingVariant({
          productData,
          colorName: selectedColorName,
          sizeValue: '',
          requireAvailable: true
        }) ||
        findMatchingVariant({
          productData,
          colorName: selectedColorName,
          sizeValue: ''
        }) ||
        getDefaultAvailableVariant(productData);
    }

    applyVariant(selectedVariant);
    dispatchSelectionState();
  }

  function rebuildSizePicker(productData) {
    if (!sizePicker) return;

    const sizeIndex =
      getSizeOptionIndex(productData);

    if (sizeIndex >= 0) {
      renderNativeSizes(productData);
      return;
    }

    if (fallbackSizes.length) {
      renderFallbackSizes();
      return;
    }

    selectedSizeValue = '';

    if (sizeGrid) {
      sizeGrid.innerHTML = '';
      sizeGrid.hidden = true;
    }

    updateSelectedSizeDisplay();
    updateSizeProperty();

    selectedVariant =
      getDefaultAvailableVariant(
        productData
      );

    applyVariant(selectedVariant);
    dispatchSelectionState();
  }

  function selectSize(sizeValue) {
    if (!sizeValue) return;

    selectedSizeValue = sizeValue;

    sizeGrid
      ?.querySelectorAll(
        '[data-me-size-button]'
      )
      .forEach((button) => {
        const active =
          button.dataset.sizeValue ===
          sizeValue;

        button.classList.toggle(
          'is-active',
          active
        );

        button.setAttribute(
          'aria-pressed',
          active ? 'true' : 'false'
        );
      });

    updateSelectedSizeDisplay();
    updateSizeProperty();

    const nativeSizeIndex =
      getSizeOptionIndex(currentProduct);

    if (nativeSizeIndex >= 0) {
      selectedVariant =
        findMatchingVariant({
          productData: currentProduct,
          colorName: selectedColorName,
          sizeValue,
          requireAvailable: true
        }) ||
        findMatchingVariant({
          productData: currentProduct,
          colorName: selectedColorName,
          sizeValue
        });
    } else {
      selectedVariant =
        getDefaultAvailableVariant(
          currentProduct
        );
    }

    applyVariant(selectedVariant);
    dispatchSelectionState();
  }

  function applyVariant(variant) {
    if (!variant) return;

    if (variantIdInput) {
      variantIdInput.value =
        String(variant.id);
    }

    if (productPrice) {
      productPrice.textContent =
        formatMoney(variant.price);
    }

    designer.dataset.meBasePriceCents =
      String(variant.price || 0);

    updateStockStatus(
      Boolean(variant.available)
    );

    window.dispatchEvent(
      new CustomEvent(
        'me:designer-variant-changed',
        {
          detail: {
            variantId: variant.id,
            priceCents: variant.price,
            available:
              Boolean(variant.available),
            color: selectedColorName,
            size: selectedSizeValue,
            sizeSelected:
              Boolean(selectedSizeValue)
          }
        }
      )
    );
  }

  function updateStockStatus(available) {
    if (!selectedStockLabel) return;

    selectedStockLabel.classList.remove(
      'is-stock',
      'is-backorder'
    );

    if (available) {
      selectedStockLabel.textContent =
        '● In Stock';

      selectedStockLabel.classList.add(
        'is-stock'
      );
    } else {
      selectedStockLabel.textContent =
        '● Unavailable';

      selectedStockLabel.classList.add(
        'is-backorder'
      );
    }
  }

  function dispatchSelectionState() {
    window.dispatchEvent(
      new CustomEvent(
        'me:variant-selection-state',
        {
          detail: {
            color: selectedColorName,
            colorSelected:
              Boolean(selectedColorName),
            size: selectedSizeValue,
            sizeSelected:
              Boolean(selectedSizeValue),
            variantId:
              selectedVariant?.id || null,
            available:
              Boolean(selectedVariant?.available)
          }
        }
      )
    );
  }

  function getColorStyle(colorName) {
    const slug = slugify(colorName);

    if (colorStyles[slug]) {
      return (
        `background:${colorStyles[slug]};`
      );
    }

    if (slug.includes('heather')) {
      return `
        background:
          linear-gradient(
            135deg,
            #686868 0%,
            #989898 48%,
            #626262 100%
          );
      `;
    }

    return 'background:#d6d0c7;';
  }

  function renderFamilySwatches() {
    if (
      !swatchContainer ||
      !family?.colors?.length
    ) {
      updateColorDisplay();
      dispatchSelectionState();
      return;
    }

    swatchContainer.innerHTML =
      family.colors
        .map((color) => {
          const sharedHandle = Boolean(family?.variantMode || color.variantMode);
          const active = sharedHandle
            ? slugify(color.name) === slugify(selectedColorName)
            : color.handle === currentHandle;

          return `
            <button
              type="button"
              class="me-designer-color-swatch ${
                active ? 'is-active' : ''
              }"
              data-me-designer-color
              data-color-name="${escapeHtml(color.name)}"
              data-color-handle="${escapeHtml(color.handle)}"
              data-product-url="/products/${escapeHtml(color.handle)}"
              aria-label="${escapeHtml(color.name)}"
              aria-pressed="${active ? 'true' : 'false'}"
            >
              <span
                class="me-designer-color-swatch__circle"
                style="${getColorStyle(color.name)}"
              ></span>

              <span class="me-designer-color-swatch__check">
                ✓
              </span>

              <span class="me-designer-color-swatch__tooltip">
                ${escapeHtml(color.name)}
              </span>
            </button>
          `;
        })
        .join('');

    swatchContainer
      .querySelectorAll(
        '[data-me-designer-color]'
      )
      .forEach((button) => {
        button.addEventListener(
          'click',
          () => {
            loadColorProduct({
              handle:
                button.dataset.colorHandle,
              colorName:
                button.dataset.colorName
            });
          }
        );
      });

    updateColorDisplay();
  }

  async function loadColorProduct({
    handle,
    colorName
  }) {
    if (!handle) return;

    const requestToken = `${handle}-${Date.now()}`;
    colorSection.dataset.meColorRequestToken = requestToken;

    setColorLoading(true);

    const preservedSize = selectedSizeValue;
    const catalogFrontImage = getCatalogColorImage(handle);

    /*
     * Update the visible selection immediately. The supplier-confirmed
     * catalog image is available locally, so the preview should not wait
     * for Shopify product JSON before responding to the customer.
     */
    currentHandle = handle;
    selectedColorName = colorName;
    selectedSizeValue = preservedSize;

    updateActiveSwatch(handle);
    updateColorDisplay();

    if (colorSection) {
      colorSection.dataset.meCurrentHandle = handle;
    }

    if (catalogFrontImage) {
      updateProductMedia(
        {
          images: [catalogFrontImage],
          featured_image: catalogFrontImage
        },
        catalogFrontImage
      );
    }

    const controller = new AbortController();
    const timeoutId = window.setTimeout(() => {
      controller.abort();
    }, 8000);

    try {
      const root = window.Shopify?.routes?.root || '/';
      const response = await fetch(
        `${root}products/${encodeURIComponent(handle)}.js`,
        {
          signal: controller.signal,
          headers: {
            Accept: 'application/json'
          }
        }
      );

      if (!response.ok) {
        throw new Error(
          'The selected color preview loaded, but its product details are currently unavailable.'
        );
      }

      const productData = await response.json();

      /* Ignore a stale response if the shopper clicked another color. */
      if (
        colorSection.dataset.meColorRequestToken !== requestToken
      ) {
        return;
      }

      currentProduct = productData;
      window.MomentsCurrentProduct = productData;
      selectedSizeValue = preservedSize;

      designer.dataset.meProductTitle = productData.title;

      if (designerTitle) {
        designerTitle.textContent = `Personalize ${productData.title}`;
      }

      rebuildSizePicker(productData);
      updateProductMedia(productData, catalogFrontImage);

      window.dispatchEvent(
        new CustomEvent(
          'me:designer-color-changed',
          {
            detail: {
              handle,
              colorName,
              product: productData,
              preservedSize: selectedSizeValue
            }
          }
        )
      );

      dispatchSelectionState();
    } catch (error) {
      if (
        colorSection.dataset.meColorRequestToken !== requestToken
      ) {
        return;
      }

      /*
       * Never leave the designer frozen. The confirmed catalog image has
       * already been applied, so keep the preview usable and show a brief
       * message only when product data could not be refreshed.
       */
      if (colorMessage) {
        colorMessage.textContent =
          error?.name === 'AbortError'
            ? 'Color preview loaded. Product details took too long to refresh; please select the size again if needed.'
            : error.message ||
              'Color preview loaded. Product details could not be refreshed.';
      }

      window.setTimeout(() => {
        if (
          colorMessage &&
          colorSection.dataset.meColorRequestToken === requestToken
        ) {
          colorMessage.textContent = '';
        }
      }, 5000);
    } finally {
      window.clearTimeout(timeoutId);

      if (
        colorSection.dataset.meColorRequestToken === requestToken
      ) {
        setColorLoading(false);
      }
    }
  }

  function updateActiveSwatch(handle, colorName = selectedColorName) {
    swatchContainer
      ?.querySelectorAll(
        '[data-me-designer-color]'
      )
      .forEach((button) => {
        const sharedHandle = Boolean(family?.variantMode);
        const active = sharedHandle
          ? slugify(button.dataset.colorName) === slugify(colorName)
          : button.dataset.colorHandle === handle;

        button.classList.toggle(
          'is-active',
          active
        );

        button.setAttribute(
          'aria-pressed',
          active ? 'true' : 'false'
        );
      });
  }

  function resolveVariantImage(productData, variant) {
    if (!variant) return '';

    const direct = normalizeImageSource(
      variant.featured_image || variant.featured_media?.preview_image
    );

    if (direct) return direct;

    const media = Array.isArray(productData?.media)
      ? productData.media
      : [];

    const mediaId =
      variant.featured_media?.id || variant.featured_media_id;

    if (mediaId) {
      const match = media.find((item) => String(item?.id) === String(mediaId));
      const source = normalizeImageSource(match?.preview_image || match);
      if (source) return source;
    }

    const imageId = variant.image_id || variant.featured_image?.id;
    const imageObjects = Array.isArray(productData?.images)
      ? productData.images
      : [];

    if (imageId) {
      const match = imageObjects.find((item) =>
        typeof item === 'object' && String(item?.id) === String(imageId)
      );
      const source = normalizeImageSource(match);
      if (source) return source;
    }

    return '';
  }

  function updateProductMedia(
    productData,
    catalogFrontImage = ''
  ) {
    const images = Array.isArray(productData?.images)
      ? productData.images
          .map(normalizeImageSource)
          .filter(Boolean)
      : [];

    const productFeaturedImage =
      normalizeImageSource(
        productData?.featured_image
      );

    const colorVariant =
      findMatchingVariant({
        productData,
        colorName: selectedColorName,
        sizeValue: selectedSizeValue,
        requireAvailable: true
      }) ||
      findMatchingVariant({
        productData,
        colorName: selectedColorName,
        sizeValue: selectedSizeValue
      }) ||
      findMatchingVariant({
        productData,
        colorName: selectedColorName,
        sizeValue: '',
        requireAvailable: true
      }) ||
      findMatchingVariant({
        productData,
        colorName: selectedColorName,
        sizeValue: ''
      });

    const variantFrontImage = resolveVariantImage(productData, colorVariant);

    /*
     * Products such as 2011 and 2013 keep every color as a variant under
     * one handle. Their selected variant image must take priority over the
     * product-level featured image. Separate-color products can still use
     * their catalog image mapping as a fallback.
     */
    const frontImage =
      variantFrontImage ||
      normalizeImageSource(catalogFrontImage) ||
      productFeaturedImage ||
      images[0] ||
      '';

    const backImage =
      images[1] || frontImage;

    const leftSleeveImage =
      images[2] || frontImage;

    const rightSleeveImage =
      images[3] || frontImage;

    window.dispatchEvent(
      new CustomEvent(
        'me:product-media-changed',
        {
          detail: {
            frontImage,
            backImage,
            leftSleeveImage,
            rightSleeveImage
          }
        }
      )
    );
  }

  function setColorLoading(loading) {
    colorSection?.classList.toggle(
      'is-loading',
      loading
    );

    if (colorMessage) {
      colorMessage.textContent = loading
        ? 'Loading selected color…'
        : '';
    }
  }

  sizePicker?.addEventListener(
    'click',
    (event) => {
      const button = event.target.closest(
        '[data-me-size-button]'
      );

      if (!button || button.disabled) {
        return;
      }

      selectSize(
        button.dataset.sizeValue || ''
      );
    }
  );

  selectedColorName =
    resolveInitialColor();

  renderFamilySwatches();
  updateColorDisplay();

  if (currentProduct) {
    rebuildSizePicker(currentProduct);
  }

  dispatchSelectionState();
});
/* ===== END assets/me-color-designer.js ===== */


/* ===== BEGIN assets/me-live-preview.js ===== */
document.addEventListener('DOMContentLoaded', () => {
  'use strict';

  const preview = document.querySelector(
    '[data-me-live-preview]'
  );

  if (!preview) return;

  const stage = preview.querySelector(
    '[data-me-preview-stage]'
  );

  const coordinateCanvas = preview.querySelector(
    '[data-me-preview-coordinate-canvas]'
  );

  const productImage = preview.querySelector(
    '[data-me-preview-product-image]'
  );

  const artworkImage = preview.querySelector(
    '[data-me-preview-artwork]'
  );

  const boundary = preview.querySelector(
    '[data-me-preview-boundary]'
  );

  const nameNumberPreview = preview.querySelector('[data-me-preview-name-number]');
  const namePreview = preview.querySelector('[data-me-preview-name]');
  const numberPreview = preview.querySelector('[data-me-preview-number]');
  const unavailableState = preview.querySelector('[data-me-preview-unavailable]');

  const emptyState = preview.querySelector(
    '[data-me-preview-empty]'
  );

  const placementLabel = preview.querySelector(
    '[data-me-preview-placement-label]'
  );

  const guideName = preview.querySelector(
    '[data-me-preview-guide-name]'
  );

  const guideDimensions = preview.querySelector(
    '[data-me-preview-guide-dimensions]'
  );

  const guidePlacement = preview.querySelector(
    '[data-me-preview-guide-placement]'
  );

  const previewStatus = preview.querySelector(
    '[data-me-preview-status]'
  );

  const customerGroup =
    preview.dataset.meCustomerGroup ===
    'youth'
      ? 'youth'
      : 'adult';

  let placementCalibration = {};
  const calibrationNode = preview.querySelector('[data-me-placement-calibration]');
  if (calibrationNode) {
    try {
      placementCalibration = JSON.parse(calibrationNode.textContent || '{}') || {};
    } catch (error) {
      console.warn('Moments Etched: placement calibration could not be read.', error);
    }
  }

  preview.dataset.meCalibrationLoaded = Object.keys(placementCalibration).length ? 'true' : 'false';
  requestAnimationFrame(syncCalibrationCoordinateCanvas);

  function syncCalibrationCoordinateCanvas() {
    if (!stage || !coordinateCanvas) return;
    const calibrated = preview.dataset.meCalibrationFound === 'true';

    if (!calibrated) {
      coordinateCanvas.style.left = '0';
      coordinateCanvas.style.top = '0';
      coordinateCanvas.style.width = '100%';
      coordinateCanvas.style.height = '100%';
      coordinateCanvas.style.transform = 'none';
      preview.dataset.meCalibrationCanvas = 'stage';
      return;
    }

    // The Theme Editor workspace was calibrated on an effective 10:7 stage
    // (roughly 800 x 560). Fit that virtual stage inside the responsive
    // customer preview without stretching it, then apply the saved X/Y/W/H
    // percentages inside that exact coordinate system.
    const referenceRatio = 10 / 7;
    const stageWidth = stage.clientWidth;
    const stageHeight = stage.clientHeight;
    if (!stageWidth || !stageHeight) return;

    let canvasWidth = stageWidth;
    let canvasHeight = canvasWidth / referenceRatio;
    if (canvasHeight > stageHeight) {
      canvasHeight = stageHeight;
      canvasWidth = canvasHeight * referenceRatio;
    }

    coordinateCanvas.style.left = '50%';
    coordinateCanvas.style.top = '50%';
    coordinateCanvas.style.width = `${canvasWidth}px`;
    coordinateCanvas.style.height = `${canvasHeight}px`;
    coordinateCanvas.style.transform = 'translate(-50%, -50%)';
    preview.dataset.meCalibrationCanvas = 'theme-editor-10x7';
  }

  function applyPlacementCalibration(placementName) {
    syncCalibrationCoordinateCanvas();
    if (!boundary) return;
    const calibration = placementCalibration[placementName];
    if (!calibration) {
      boundary.style.removeProperty('top');
      boundary.style.removeProperty('left');
      boundary.style.removeProperty('right');
      boundary.style.removeProperty('width');
      boundary.style.removeProperty('height');
      boundary.style.removeProperty('aspect-ratio');
      boundary.style.removeProperty('transform');
      return;
    }

    const x = Number(calibration.x);
    const y = Number(calibration.y);
    const w = Number(calibration.w);
    const h = Number(calibration.h);
    if (![x,y,w,h].every(Number.isFinite)) return;

    // Calibrated geometry is production data. Use inline !important so legacy
    // stabilization CSS can never silently override Theme Editor calibration.
    boundary.style.setProperty('top', `${y}%`, 'important');
    boundary.style.setProperty('left', `${x}%`, 'important');
    boundary.style.setProperty('right', 'auto', 'important');
    boundary.style.setProperty('width', `${w}%`, 'important');
    boundary.style.setProperty('height', `${h}%`, 'important');
    boundary.style.setProperty('aspect-ratio', 'auto', 'important');
    boundary.style.setProperty('max-width', 'none', 'important');
    boundary.style.setProperty('max-height', 'none', 'important');

    let rotation = '';
    if (placementName === 'Left Sleeve') rotation = ' rotate(-10deg)';
    if (placementName === 'Right Sleeve') rotation = ' rotate(10deg)';
    boundary.style.setProperty('transform', `translateX(-50%)${rotation}`, 'important');
    preview.dataset.meCalibrationApplied = placementName;
  }

  function applyProductFraming(viewName = 'front') {
    if (!stage || !productImage) return;
    const isBack = viewName === 'back' || viewName === 'neckLabel';
    const prefix = isBack ? 'back' : 'front';
    const x = Number(stage.dataset[`me${prefix[0].toUpperCase() + prefix.slice(1)}FrameX`] || 50);
    const y = Number(stage.dataset[`me${prefix[0].toUpperCase() + prefix.slice(1)}FrameY`] || 50);
    const scale = Number(stage.dataset[`me${prefix[0].toUpperCase() + prefix.slice(1)}FrameScale`] || 100);
    const safeX = Number.isFinite(x) ? x : 50;
    const safeY = Number.isFinite(y) ? y : 50;
    const zoom = Number.isFinite(scale) ? scale / 100 : 1;
    const calibrated = preview.dataset.meCalibrationFound === 'true';

    productImage.style.transformOrigin = '50% 50%';

    if (calibrated) {
      // v15.4.5.5 — Theme Editor calibration is measured against a garment image
      // positioned at X/Y with an 86% x 86% contain box. Reproduce that exact
      // coordinate model in the customer studio so saved placement values map 1:1.
      productImage.style.position = 'absolute';
      productImage.style.left = `${safeX}%`;
      productImage.style.top = `${safeY}%`;
      productImage.style.width = '86%';
      productImage.style.height = '86%';
      productImage.style.maxWidth = 'none';
      productImage.style.maxHeight = 'none';
      productImage.style.objectFit = 'contain';
      productImage.style.transform = `translate(-50%, -50%) scale(${zoom})`;
      preview.dataset.meCalibrationFrame = 'theme-editor-86';
      return;
    }

    const dx = safeX - 50;
    const dy = safeY - 50;
    productImage.style.position = '';
    productImage.style.left = '';
    productImage.style.top = '';
    productImage.style.width = '';
    productImage.style.height = '';
    productImage.style.maxWidth = '';
    productImage.style.maxHeight = '';
    productImage.style.objectFit = '';
    productImage.style.transform = `translate(${dx}%, ${dy}%) scale(${zoom})`;
  }

  let media = {
    front:
      stage?.dataset.frontImage || '',

    back:
      stage?.dataset.backImage || '',

    leftSleeve:
      stage?.dataset.leftSleeveImage ||
      stage?.dataset.frontImage ||
      '',

    rightSleeve:
      stage?.dataset.rightSleeveImage ||
      stage?.dataset.frontImage ||
      ''
  };

  const classes = [
    'is-left-chest',
    'is-center-chest',
    'is-right-chest',
    'is-full-front',
    'is-full-back',
    'is-upper-back',
    'is-back-collar',
    'is-back-name-number',
    'is-left-sleeve',
    'is-right-sleeve'
  ];

  const placements = {
    'Left Chest': {
      className: 'is-left-chest',
      view: 'front',
      adult: [4.5, 4.5],
      youth: [3.5, 3.5],
      guide:
        'Approximately 4 inches down from the collar, aligned with the outer collar edge.'
    },

    'Center Chest': {
      className: 'is-center-chest',
      view: 'front',
      adult: [10, 8],
      youth: [8, 6],
      guide:
        'Approximately 3 to 4 inches down from the collar, centered on the garment.'
    },

    'Right Chest': {
      className: 'is-right-chest',
      view: 'front',
      adult: [4.5, 4.5],
      youth: [3.5, 3.5],
      guide:
        'Approximately 4 inches down from the collar, aligned with the outer collar edge.'
    },

    'Full Front': {
      className: 'is-full-front',
      view: 'front',
      adult: [10, 13],
      youth: [8, 10],
      guide:
        'Approximately 2 to 3 inches down from the collar and 1 to 1.5 inches in from the side seams.'
    },

    'Full Back': {
      className: 'is-full-back',
      view: 'back',
      adult: [12, 16],
      youth: [9, 12],
      guide:
        'Centered on the back, approximately 2 to 3 inches down from the collar and 1 to 1.5 inches in from the side seams.'
    },

    'Upper Back': {
      className: 'is-upper-back',
      view: 'back',
      adult: [10, 4],
      youth: [8, 3],
      guide:
        'Approximately 2 to 3 inches down from the back collar, centered between the shoulder seams.'
    },

    'Back Collar': {
      className: 'is-back-collar',
      view: 'back',
      adult: [4, 2],
      youth: [3, 1.5],
      guide:
        'Centered directly below the back collar seam, approximately 0.5 to 1 inch down.'
    },

    'Back Name': {
      className: 'is-back-name-number',
      view: 'back',
      adult: [10, 4],
      youth: [8, 3],
      guide:
        'Upper-back name placement, approximately 2 to 3 inches down from the collar.'
    },

    'Back Number': {
      className: 'is-back-name-number',
      view: 'back',
      adult: [12, 15],
      youth: [9, 12],
      guide:
        'Large full-back number placement, centered below the upper-back area.'
    },

    'Back Name + Number': {
      className: 'is-back-name-number',
      view: 'back',
      adult: [12, 15],
      youth: [9, 12],
      guide:
        'Two production zones: an upper-back name and a centered full-back number.'
    },

    'Left Sleeve': {
      className: 'is-left-sleeve',
      view: 'leftSleeve',
      adult: [3, 3],
      youth: [2.5, 2.5],
      guide:
        'Centered on the sleeve approximately 1 inch above the hem.'
    },

    'Right Sleeve': {
      className: 'is-right-sleeve',
      view: 'rightSleeve',
      adult: [3, 3],
      youth: [2.5, 2.5],
      guide:
        'Centered on the sleeve approximately 1 inch above the hem.'
    },

    'Custom Neck Label': {
      className: 'is-back-collar',
      view: 'neckLabel',
      adult: [3, 2],
      youth: [2.5, 1.75],
      guide:
        'Printed inside the back neck after removal of the tearaway manufacturer label. Template preview only; final appearance may vary by garment color and product information.'
    }
  };

  function setPlacement(
    placementName,
    artworkUrl = '',
    nameNumber = null
  ) {
    const placement =
      placements[placementName] ||
      placements['Left Chest'];

    const dimensions =
      placement[customerGroup] ||
      placement.adult;

    boundary?.classList.remove(
      ...classes
    );

    boundary?.classList.add(
      placement.className
    );

    applyPlacementCalibration(placementName);

    const templateEnabled = stage?.dataset.meTemplateEnabled === 'true';
    const requiresBackView = placement.view === 'back';
    const requiresNeckView = placement.view === 'neckLabel';
    const hasRequestedView = requiresNeckView ? (templateEnabled || Boolean(media.back)) : (!requiresBackView || templateEnabled || Boolean(media.back));
    const imageUrl = hasRequestedView
      ? (placement.view === 'neckLabel' ? (media.back || media.front) : (media[placement.view] || media.front))
      : '';

    if (unavailableState) {
      unavailableState.hidden = hasRequestedView;
      if (!hasRequestedView) {
        unavailableState.querySelector('strong').textContent = 'Back preview not available yet';
        unavailableState.querySelector('small').textContent =
          'Add a true back-view product image to preview back printing and names or numbers. Your entered details will still be saved for production.';
      }
    }

    if (productImage) {
      productImage.hidden = !hasRequestedView;
    }
    if (boundary) {
      boundary.hidden = !hasRequestedView;
    }

    if (window.MEGarmentTemplates && hasRequestedView) {
      window.MEGarmentTemplates.setView(placement.view);
    } else if (hasRequestedView && productImage && imageUrl) {
      productImage.src = imageUrl;
      productImage.srcset = '';
    }

    applyProductFraming(placement.view);

    if (placementLabel) {
      placementLabel.textContent =
        placementName;
    }

    if (guideName) {
      guideName.textContent =
        placementName;
    }

    if (guideDimensions) {
      guideDimensions.textContent =
        `${dimensions[0]}″ × ${dimensions[1]}″`;
    }

    if (guidePlacement) {
      guidePlacement.textContent =
        placement.guide;
    }

    if (nameNumberPreview) {
      const isNameNumberPlacement = ['Back Name', 'Back Number', 'Back Name + Number'].includes(placementName);
      const showNameNumber = hasRequestedView && isNameNumberPlacement && nameNumber;
      nameNumberPreview.hidden = !showNameNumber;
      if (showNameNumber) {
        const familyMap = {
          'Varsity': 'Impact, Haettenschweiler, Arial Narrow Bold, sans-serif',
          'Collegiate': 'Georgia, Times New Roman, serif',
          'Athletic Block': 'Arial Black, Impact, sans-serif',
          'Classic Serif': 'Georgia, Times New Roman, serif',
          'Clean Sans': 'Arial, Helvetica, sans-serif'
        };
        nameNumberPreview.style.color = nameNumber.color || '#ffffff';
        nameNumberPreview.style.fontFamily = familyMap[nameNumber.font] || familyMap.Varsity;
        nameNumberPreview.classList.toggle('is-small', nameNumber.size === 'Small');
        if (namePreview) {
          namePreview.textContent = nameNumber.includeName ? (nameNumber.name || 'NAME') : '';
          namePreview.hidden = !nameNumber.includeName;
        }
        if (numberPreview) {
          numberPreview.textContent = nameNumber.includeNumber ? (nameNumber.number || '00') : '';
          numberPreview.hidden = !nameNumber.includeNumber;
        }
        if (emptyState) emptyState.hidden = true;
        if (artworkImage) { artworkImage.src = ''; artworkImage.hidden = true; }
        if (previewStatus) previewStatus.textContent = 'Previewing Back Name + Number';
      }
    }

    if (hasRequestedView && artworkUrl) {
      artworkImage.src = artworkUrl;
      artworkImage.hidden = false;

      if (emptyState) {
        emptyState.hidden = true;
      }

      if (previewStatus) {
        previewStatus.textContent =
          `Previewing ${placementName}`;
      }
    } else if (!(['Back Name', 'Back Number', 'Back Name + Number'].includes(placementName) && nameNumber)) {
      artworkImage.src = '';
      artworkImage.hidden = true;

      if (emptyState) {
        emptyState.hidden = false;
      }

      if (previewStatus) {
        previewStatus.textContent =
          ['Back Name', 'Back Number', 'Back Name + Number'].includes(placementName)
            ? 'Enter the selected back personalization to preview'
            : `Upload artwork for ${placementName}`;
      }
    }
  }

  window.addEventListener(
    'me:preview-placement',
    (event) => {
      setPlacement(
        event.detail?.placement ||
        'Left Chest',

        event.detail?.artworkUrl ||
        '',

        event.detail?.nameNumber || null
      );
    }
  );

  window.addEventListener(
    'me:product-media-changed',
    (event) => {
      media = {
        front:
          event.detail?.frontImage ||
          media.front,

        back:
          event.detail?.backImage ||
          media.back ||
          '',

        leftSleeve:
          event.detail
            ?.leftSleeveImage ||
          event.detail?.frontImage ||
          media.front,

        rightSleeve:
          event.detail
            ?.rightSleeveImage ||
          event.detail?.frontImage ||
          media.front
      };

      const currentPlacement =
        placementLabel?.textContent ||
        'Left Chest';

      setPlacement(
        currentPlacement,
        artworkImage?.hidden
          ? ''
          : artworkImage?.src || ''
      );
    }
  );

  if (stage && coordinateCanvas && 'ResizeObserver' in window) {
    const meCalibrationResizeObserver = new ResizeObserver(() => {
      syncCalibrationCoordinateCanvas();
      const activePlacement = placementLabel?.textContent || getSelectedPlacement?.() || 'Left Chest';
      applyPlacementCalibration(activePlacement);
    });
    meCalibrationResizeObserver.observe(stage);
  }

  // v15.4.5.6 — initialize from the actual selected placement instead of
  // hard-resetting the preview to Left Chest. This avoids DOMContentLoaded
  // ordering races with the Studio controller and keeps calibration in sync.
  const getSelectedPlacement = () => {
    const checked = document.querySelector('[data-me-designer] [data-me-placement-checkbox]:checked');
    return checked?.value || 'Left Chest';
  };

  const syncSelectedPlacement = (artworkUrl = '') => {
    const selected = getSelectedPlacement();
    setPlacement(selected, artworkUrl);
  };

  document.querySelectorAll('[data-me-designer] [data-me-placement-checkbox]').forEach((input) => {
    input.addEventListener('change', () => {
      if (!input.checked) return;
      setPlacement(input.value || getSelectedPlacement());
    });
  });

  // Run after the other DOMContentLoaded listeners have hydrated saved Studio state.
  window.requestAnimationFrame(() => {
    window.requestAnimationFrame(() => syncSelectedPlacement());
  });
});
/* ===== END assets/me-live-preview.js ===== */


/* ===== BEGIN assets/me-placement-artwork.js ===== */
document.addEventListener('DOMContentLoaded', () => {
  'use strict';

  const designer = document.querySelector('[data-me-designer]');

  const container = document.querySelector(
    '[data-me-artwork-assignments]'
  );

  const navigator = document.querySelector(
    '[data-me-location-navigator]'
  );

  const activeLocationLabel = document.querySelector(
    '[data-me-designer-active-location]'
  );

  const viewStatus = document.querySelector(
    '[data-me-designer-view-status]'
  );

  if (!designer || !container) return;

  const rules =
    window.MEPlacementRules?.placements || {};

  const assignments = new Map();

  let activePlacement = 'Left Chest';

  function escapeHtml(value) {
    return String(value || '')
      .replaceAll('&', '&amp;')
      .replaceAll('<', '&lt;')
      .replaceAll('>', '&gt;')
      .replaceAll('"', '&quot;')
      .replaceAll("'", '&#039;');
  }

  function formatMoney(cents) {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD'
    }).format((Number(cents) || 0) / 100);
  }

  function selectedPlacements() {
    return Array.from(
      designer.querySelectorAll(
        '[data-me-placement-checkbox]:checked'
      )
    ).map((input) => input.value);
  }

  function assignmentType(placement) {
    return (
      rules[placement]?.assignmentType ||
      'artwork'
    );
  }

  function render() {
    const placements = selectedPlacements();

    for (const placement of assignments.keys()) {
      if (!placements.includes(placement)) {
        const assignment =
          assignments.get(placement);

        if (assignment?.objectUrl) {
          URL.revokeObjectURL(
            assignment.objectUrl
          );
        }

        assignments.delete(placement);
      }
    }

    if (!placements.includes(activePlacement)) {
      activePlacement =
        placements[0] || '';
    }

    if (!placements.length) {
      container.innerHTML = `
        <div class="me-artwork-assignments__empty">
          Select at least one print location before continuing.
        </div>
      `;

      renderNavigator();
      dispatchUpdate();
      return;
    }

    container.innerHTML = `
      <div class="me-artwork-assignments__grid">
        ${placements.map(createCard).join('')}
      </div>
    `;

    placements.forEach((placement) => {
      bindCard(placement);
    });

    renderNavigator();

    if (activePlacement) {
      activate(activePlacement);
    }

    dispatchUpdate();
  }

  function createCard(placement) {
    const rule = rules[placement] || {};
    const price = Number(rule.priceCents || 0);

    return `
      <article
        class="me-location-artwork"
        data-me-location-artwork="${escapeHtml(placement)}"
        tabindex="0"
      >
        <div class="me-location-artwork__topline">
          <div>
            <strong>${escapeHtml(placement)}</strong>

            <small>
              ${
                assignmentType(placement) === 'name-number'
                  ? '$3–$6 per item'
                  : price === 0
                    ? 'Included'
                    : `+${formatMoney(price)} per item`
              }
            </small>
          </div>

          <span class="me-location-artwork__state">
            Required
          </span>
        </div>

        <div class="me-location-artwork__body">
          ${
            assignmentType(placement) ===
            'name-number'
              ? createNameNumberFields(placement)
              : createUploadFields(placement)
          }
        </div>
      </article>
    `;
  }

  function createNameNumberFields(placement) {
    const existing =
      assignments.get(placement) || {};

    const mode = rules[placement]?.nameNumberMode || 'both';
    const includeName = mode === 'name' ? true : mode === 'number' ? false : existing.includeName !== false;
    const includeNumber = mode === 'number' ? true : mode === 'name' ? false : existing.includeNumber !== false;
    const font = existing.font || 'Varsity';
    const printSize = existing.printSize || 'Large';
    const textColor = existing.textColor || '#ffffff';

    return `
      <div class="me-name-number">
        ${mode === 'both' ? `
        <div class="me-name-number__toggles" role="group" aria-label="Back name and number bundle">
          <span>Includes both the upper-back name and full-back number.</span>
        </div>` : ''}
        <input type="checkbox" data-me-name-toggle="${escapeHtml(placement)}" ${includeName ? 'checked' : ''} hidden>
        <input type="checkbox" data-me-number-toggle="${escapeHtml(placement)}" ${includeNumber ? 'checked' : ''} hidden>

        <div class="me-name-number__field" data-me-name-field>
          <label for="me-back-name">Back name</label>
          <input
            id="me-back-name"
            type="text"
            maxlength="20"
            value="${escapeHtml(existing.backName || '')}"
            placeholder="Example: ALEX"
            data-me-back-name="${escapeHtml(placement)}"
          >
        </div>

        <div class="me-name-number__field" data-me-number-field>
          <label for="me-back-number">Back number</label>
          <input
            id="me-back-number"
            type="text"
            inputmode="numeric"
            maxlength="3"
            value="${escapeHtml(existing.backNumber || '')}"
            placeholder="Example: 23"
            data-me-back-number="${escapeHtml(placement)}"
          >
        </div>

        <div class="me-name-number__options">
          <label>
            <span>Font</span>
            <select data-me-name-number-font="${escapeHtml(placement)}">
              ${['Varsity','Collegiate','Athletic Block','Classic Serif','Clean Sans'].map(value => `<option value="${value}" ${font === value ? 'selected' : ''}>${value}</option>`).join('')}
            </select>
          </label>
          <label>
            <span>Print size</span>
            <select data-me-name-number-size="${escapeHtml(placement)}">
              <option value="Small" ${printSize === 'Small' ? 'selected' : ''}>Small</option>
              <option value="Large" ${printSize === 'Large' ? 'selected' : ''}>Large</option>
            </select>
          </label>
          <label>
            <span>Text color</span>
            <input type="color" value="${escapeHtml(textColor)}" data-me-name-number-color="${escapeHtml(placement)}">
          </label>
        </div>

        <div class="me-name-number__pricing" data-me-name-number-pricing>
          ${mode === 'name' ? '<strong>Back Name = $3.00 per item</strong>' : mode === 'number' ? '<strong>Back Number = $4.00 per item</strong>' : '<strong>Back Name + Number = $6.00 per item</strong>'}
        </div>

        <p class="me-name-number__note">
          ${mode === 'name' ? 'The name is centered across the upper back.' : mode === 'number' ? 'The number is centered in the full-back print area.' : 'The name is printed above the large jersey-style number.'}
        </p>
      </div>
    `;
  }

  function createUploadFields(placement) {
    return `
      <label
        class="me-location-artwork__upload"
        data-me-location-upload="${escapeHtml(placement)}"
      >
        <span class="me-location-artwork__upload-icon">
          ↑
        </span>

        <span>
          <strong>Upload PNG artwork</strong>
          <small>PNG only · Max 25 MB · 300 effective DPI preferred</small>
        </span>

        <input
          class="me-location-artwork__input"
          type="file"
          accept="image/png,.png"
          name="properties[_Artwork - ${escapeHtml(placement)}]"
          data-me-location-input="${escapeHtml(placement)}"
        >
      </label>


      <div
        class="me-location-artwork__result"
        data-me-location-result="${escapeHtml(placement)}"
        hidden
      >
        <div class="me-location-artwork__preview">
          <img
            src=""
            alt="${escapeHtml(placement)} artwork preview"
            data-me-location-preview="${escapeHtml(placement)}"
          >
        </div>

        <div class="me-location-artwork__details">
          <strong
            class="me-location-artwork__filename"
            data-me-location-filename="${escapeHtml(placement)}"
          ></strong>

          <span
            class="me-location-artwork__dimensions"
            data-me-location-dimensions="${escapeHtml(placement)}"
          ></span>

          <div class="me-location-artwork__actions">
            <button
              type="button"
              class="me-location-artwork__action"
              data-me-location-replace="${escapeHtml(placement)}"
            >
              Replace
            </button>

            <button
              type="button"
              class="me-location-artwork__action me-location-artwork__action--remove"
              data-me-location-remove="${escapeHtml(placement)}"
            >
              Remove
            </button>
          </div>
        </div>
      </div>

      <div
        class="me-location-artwork__quality"
        data-me-location-quality="${escapeHtml(placement)}"
        hidden
      ></div>

      <div
        class="me-location-artwork__summary"
        data-me-location-summary="${escapeHtml(placement)}"
        hidden
      ></div>

      <label
        class="me-location-artwork__quality-ack"
        data-me-location-quality-ack-wrap="${escapeHtml(placement)}"
        hidden
      >
        <input
          type="checkbox"
          data-me-location-quality-ack="${escapeHtml(placement)}"
        >
        <span>I understand this artwork is below the recommended resolution and may print softer than higher-resolution artwork.</span>
      </label>
    `;
  }

  function bindCard(placement) {
    const card = getCard(placement);

    card?.addEventListener('click', (event) => {
      if (
        event.target.closest(
          'button, input, label'
        )
      ) {
        return;
      }

      activate(placement);
    });

    card?.addEventListener('keydown', (event) => {
      if (
        event.key === 'Enter' ||
        event.key === ' '
      ) {
        event.preventDefault();
        activate(placement);
      }
    });

    if (
      assignmentType(placement) ===
      'name-number'
    ) {
      bindNameNumber(placement);
    } else {
      bindUpload(placement);
      restoreUpload(placement);
    }

    updateCardState(placement);
  }

  function bindNameNumber(placement) {
    const nameInput = container.querySelector(
      `[data-me-back-name="${CSS.escape(placement)}"]`
    );
    const numberInput = container.querySelector(
      `[data-me-back-number="${CSS.escape(placement)}"]`
    );
    const nameToggle = container.querySelector(
      `[data-me-name-toggle="${CSS.escape(placement)}"]`
    );
    const numberToggle = container.querySelector(
      `[data-me-number-toggle="${CSS.escape(placement)}"]`
    );
    const fontInput = container.querySelector(
      `[data-me-name-number-font="${CSS.escape(placement)}"]`
    );
    const sizeInput = container.querySelector(
      `[data-me-name-number-size="${CSS.escape(placement)}"]`
    );
    const colorInput = container.querySelector(
      `[data-me-name-number-color="${CSS.escape(placement)}"]`
    );
    const nameField = nameInput?.closest('[data-me-name-field]');
    const numberField = numberInput?.closest('[data-me-number-field]');

    if (!nameInput || !numberInput) return;

    function saveAssignment() {
      const mode = rules[placement]?.nameNumberMode || 'both';
      let includeName = mode === 'name' ? true : mode === 'number' ? false : Boolean(nameToggle?.checked);
      let includeNumber = mode === 'number' ? true : mode === 'name' ? false : Boolean(numberToggle?.checked);

      if (!includeName && !includeNumber) {
        includeName = true;
        if (nameToggle) nameToggle.checked = true;
      }

      const backName = nameInput.value.trim().toUpperCase();
      const backNumber = numberInput.value.trim().replace(/[^0-9]/g, '').slice(0, 3);
      if (numberInput.value !== backNumber) numberInput.value = backNumber;

      nameField?.toggleAttribute('hidden', !includeName);
      numberField?.toggleAttribute('hidden', !includeNumber);

      const font = fontInput?.value || 'Varsity';
      const printSize = sizeInput?.value || 'Large';
      const textColor = colorInput?.value || '#ffffff';
      const completeName = !includeName || Boolean(backName);
      const completeNumber = !includeNumber || Boolean(backNumber);
      const parts = [];
      if (includeName && backName) parts.push(backName);
      if (includeNumber && backNumber) parts.push(`#${backNumber}`);

      assignments.set(placement, {
        placement,
        type: 'name-number',
        includeName,
        includeNumber,
        backName,
        backNumber,
        font,
        printSize,
        textColor,
        priceCents: includeName && includeNumber ? 600 : includeName ? 300 : 400,
        complete: completeName && completeNumber,
        summary: parts.length ? parts.join(' · ') : 'Name and number incomplete'
      });

      updateCardState(placement);
      renderNavigator();
      activate(placement);
      dispatchUpdate();
    }

    [nameInput, numberInput, nameToggle, numberToggle, fontInput, sizeInput, colorInput]
      .filter(Boolean)
      .forEach((input) => input.addEventListener('input', saveAssignment));
    [fontInput, sizeInput, colorInput]
      .filter(Boolean)
      .forEach((input) => input.addEventListener('change', saveAssignment));

    saveAssignment();
  }

  function bindUpload(placement) {
    const input = getInput(placement);
    const upload = getUpload(placement);

    const replaceButton = container.querySelector(
      `[data-me-location-replace="${CSS.escape(placement)}"]`
    );

    const removeButton = container.querySelector(
      `[data-me-location-remove="${CSS.escape(placement)}"]`
    );

    input?.addEventListener('change', () => {
      const file = input.files?.[0];

      if (file) {
        validateFile(
          placement,
          file,
          input
        );
      }
    });

    const removalToggle = container.querySelector(
      `[data-me-remove-background="${CSS.escape(placement)}"]`
    );

    removalToggle?.addEventListener('change', async () => {
      const existing = assignments.get(placement);
      const originalFile = existing?.originalFile || existing?.file || input?.files?.[0];
      if (!originalFile || !input) return;

      try {
        const nextFile = removalToggle.checked
          ? await removeLightBackground(originalFile)
          : originalFile;
        const transfer = new DataTransfer();
        transfer.items.add(nextFile);
        input.files = transfer.files;
        await validateFile(placement, nextFile, input, originalFile);
      } catch (error) {
        console.warn('Automatic background removal failed.', error);
        removalToggle.checked = false;
        showFileError(placement, 'The light background could not be removed safely. The original artwork was restored.');
        const transfer = new DataTransfer();
        transfer.items.add(originalFile);
        input.files = transfer.files;
        await validateFile(placement, originalFile, input, originalFile);
      }
    });

    replaceButton?.addEventListener(
      'click',
      (event) => {
        event.stopPropagation();
        input?.click();
      }
    );

    removeButton?.addEventListener(
      'click',
      (event) => {
        event.stopPropagation();

        const existing =
          assignments.get(placement);

        if (existing?.objectUrl) {
          URL.revokeObjectURL(
            existing.objectUrl
          );
        }

        assignments.delete(placement);
        render();
      }
    );

    if (upload) {
      ['dragenter', 'dragover'].forEach(
        (eventName) => {
          upload.addEventListener(
            eventName,
            (event) => {
              event.preventDefault();

              upload.classList.add(
                'is-dragging'
              );
            }
          );
        }
      );

      ['dragleave', 'drop'].forEach(
        (eventName) => {
          upload.addEventListener(
            eventName,
            (event) => {
              event.preventDefault();

              upload.classList.remove(
                'is-dragging'
              );
            }
          );
        }
      );

      upload.addEventListener(
        'drop',
        (event) => {
          const file =
            event.dataTransfer?.files?.[0];

          if (!file || !input) return;

          try {
            const transfer =
              new DataTransfer();

            transfer.items.add(file);
            input.files = transfer.files;
          } catch (error) {
            console.warn(
              'Unable to attach dropped artwork.',
              error
            );
          }

          validateFile(
            placement,
            file,
            input
          );
        }
      );
    }
  }

  async function validateFile(
    placement,
    file,
    input,
    originalFileOverride = null
  ) {
    const removalToggle = container.querySelector(
      `[data-me-remove-background="${CSS.escape(placement)}"]`
    );

    const originalFile = originalFileOverride || file;
    if (removalToggle?.checked && !file.name.includes('-background-removed')) {
      try {
        file = await removeLightBackground(originalFile);
        const transfer = new DataTransfer();
        transfer.items.add(file);
        input.files = transfer.files;
      } catch (error) {
        console.warn('Automatic background removal failed.', error);
      }
    }
    const maxBytes =
      50 * 1024 * 1024;

    const isPng =
      file.type === 'image/png' ||
      file.name
        .toLowerCase()
        .endsWith('.png');

    if (!isPng) {
      input.value = '';

      showFileError(
        placement,
        'Please upload a PNG file.'
      );

      return;
    }

    if (file.size > maxBytes) {
      input.value = '';

      showFileError(
        placement,
        'Please upload a PNG smaller than 50 MB.'
      );

      return;
    }

    const previous =
      assignments.get(placement);

    if (previous?.objectUrl) {
      URL.revokeObjectURL(
        previous.objectUrl
      );
    }

    const objectUrl =
      URL.createObjectURL(file);

    const image = new Image();

    image.onload = () => {
      const width =
        image.naturalWidth;

      const height =
        image.naturalHeight;

      const printWidth =
        Number(rules[placement]?.width || 4);

      const printHeight =
        Number(rules[placement]?.height || 0);

      /* Effective DPI is based on the artwork pixels available at the
         selected print area's physical size. Do not trust embedded DPI
         metadata: pixel dimensions at the intended print size are what
         determine usable print resolution. When a placement has both a
         width and height limit, use the more conservative axis. */
      const dpiWidth = width / Math.max(printWidth, 0.01);
      const dpiHeight = printHeight > 0
        ? height / Math.max(printHeight, 0.01)
        : dpiWidth;

      const dpi =
        Math.round(Math.min(dpiWidth, dpiHeight));

      const qualityLevel =
        dpi >= 300 ? 'print-ready'
          : dpi >= 200 ? 'good'
            : dpi >= 150 ? 'warning'
              : 'blocked';

      const transparent =
        detectTransparency(
          image,
          width,
          height
        );

      assignments.set(placement, {
        placement,
        type: 'artwork',
        file,
        originalFile,
        backgroundRemoved: Boolean(removalToggle?.checked),
        fileName: file.name,
        objectUrl,
        width,
        height,
        dpi,
        printWidth,
        printHeight,
        qualityLevel,
        transparent,
        qualityAcknowledged: false,
        summary: file.name
      });

      showUpload(placement);
      renderNavigator();
      activate(placement);
      dispatchUpdate();
    };

    image.onerror = () => {
      input.value = '';
      URL.revokeObjectURL(objectUrl);

      showFileError(
        placement,
        'This PNG could not be read.'
      );
    };

    image.src = objectUrl;
  }

  function detectTransparency(
    image,
    width,
    height
  ) {
    try {
      const canvas =
        document.createElement('canvas');

      const context =
        canvas.getContext(
          '2d',
          { willReadFrequently: true }
        );

      if (!context) return false;

      const sampleWidth =
        Math.min(width, 500);

      const sampleHeight =
        Math.max(
          1,
          Math.round(
            height *
            (sampleWidth / width)
          )
        );

      canvas.width = sampleWidth;
      canvas.height = sampleHeight;

      context.drawImage(
        image,
        0,
        0,
        sampleWidth,
        sampleHeight
      );

      const pixels =
        context.getImageData(
          0,
          0,
          sampleWidth,
          sampleHeight
        ).data;

      for (
        let index = 3;
        index < pixels.length;
        index += 4
      ) {
        if (pixels[index] < 250) {
          return true;
        }
      }
    } catch (error) {
      console.warn(
        'Transparency validation failed.',
        error
      );
    }

    return false;
  }

  function showUpload(placement) {
    const assignment =
      assignments.get(placement);

    if (!assignment) return;

    const card =
      getCard(placement);

    const upload =
      getUpload(placement);

    const result = container.querySelector(
      `[data-me-location-result="${CSS.escape(placement)}"]`
    );

    const preview = container.querySelector(
      `[data-me-location-preview="${CSS.escape(placement)}"]`
    );

    const filename = container.querySelector(
      `[data-me-location-filename="${CSS.escape(placement)}"]`
    );

    const dimensions = container.querySelector(
      `[data-me-location-dimensions="${CSS.escape(placement)}"]`
    );

    const quality = container.querySelector(
      `[data-me-location-quality="${CSS.escape(placement)}"]`
    );

    const summary = container.querySelector(
      `[data-me-location-summary="${CSS.escape(placement)}"]`
    );

    card?.classList.remove('has-error');
    card?.classList.add('has-artwork');

    if (upload) upload.hidden = true;
    if (result) result.hidden = false;

    if (preview) {
      preview.src =
        assignment.objectUrl;
    }

    if (filename) {
      filename.textContent =
        assignment.fileName;
    }

    if (dimensions) {
      dimensions.textContent =
        `${assignment.width.toLocaleString()} × ` +
        `${assignment.height.toLocaleString()} px`;
    }

    if (quality) {
      quality.hidden = false;

      const printSizeLabel = assignment.printHeight > 0
        ? `at up to ${assignment.printWidth}\" × ${assignment.printHeight}\"`
        : `at up to ${assignment.printWidth}\" wide`;

      const dpiClass = assignment.dpi >= 300
        ? 'is-success'
        : assignment.dpi >= 200
          ? 'is-warning'
          : 'is-error';

      const dpiIcon = assignment.dpi >= 300
        ? '✓'
        : assignment.dpi >= 150
          ? '!'
          : '×';

      quality.innerHTML = `
        <span class="me-location-artwork__quality-row is-success">
          <span class="me-location-artwork__quality-icon">✓</span>
          PNG · ${assignment.width.toLocaleString()} × ${assignment.height.toLocaleString()} px
        </span>

        <span class="me-location-artwork__quality-row ${
          assignment.transparent ? 'is-success' : 'is-warning'
        }">
          <span class="me-location-artwork__quality-icon">
            ${assignment.transparent ? '✓' : '!'}
          </span>
          ${assignment.transparent ? 'Transparent background' : 'Background detected — prints as shown'}
        </span>

        <span class="me-location-artwork__quality-row ${dpiClass}">
          <span class="me-location-artwork__quality-icon">${dpiIcon}</span>
          ${assignment.dpi} effective DPI ${printSizeLabel}
        </span>
      `;
    }

    const ackWrap = container.querySelector(
      `[data-me-location-quality-ack-wrap="${CSS.escape(placement)}"]`
    );
    const ackInput = container.querySelector(
      `[data-me-location-quality-ack="${CSS.escape(placement)}"]`
    );

    if (ackWrap && ackInput) {
      const requiresAck = assignment.qualityLevel === 'warning';
      ackWrap.hidden = !requiresAck;
      ackInput.checked = Boolean(assignment.qualityAcknowledged);
      ackInput.onchange = () => {
        assignment.qualityAcknowledged = ackInput.checked;
        updateCardState(placement);
        renderNavigator();
        dispatchUpdate();
      };
    }

    if (summary) {
      summary.hidden = false;

      if (assignment.qualityLevel === 'print-ready') {
        summary.className = 'me-location-artwork__summary is-success';
        summary.textContent = assignment.transparent
          ? 'Print Ready — excellent resolution and transparent background.'
          : 'Print Ready resolution — background detected and will print as shown.';
      } else if (assignment.qualityLevel === 'good') {
        summary.className = 'me-location-artwork__summary is-warning';
        summary.textContent = assignment.transparent
          ? 'Good print resolution. 300 DPI is preferred when available.'
          : 'Good print resolution. Background detected and will print as shown.';
      } else if (assignment.qualityLevel === 'warning') {
        summary.className = 'me-location-artwork__summary is-warning';
        summary.textContent = 'Quality warning — 150–199 effective DPI. Higher-resolution artwork is recommended.';
      } else {
        summary.className = 'me-location-artwork__summary is-error';
        summary.textContent = 'Resolution too low for this print size. Upload a higher-resolution file or choose a smaller print area.';
      }
    }

    card?.classList.toggle('has-preflight-block', assignment.qualityLevel === 'blocked');
    card?.classList.toggle('has-preflight-warning', assignment.qualityLevel === 'warning');

    updateCardState(placement);
  }

  function restoreUpload(placement) {
    const assignment =
      assignments.get(placement);

    if (
      assignment?.type !== 'artwork'
    ) {
      return;
    }

    const input =
      getInput(placement);

    if (input) {
      try {
        const transfer =
          new DataTransfer();

        transfer.items.add(
          assignment.file
        );

        input.files =
          transfer.files;
      } catch (error) {
        console.warn(
          'Unable to restore artwork input.',
          error
        );
      }
    }

    showUpload(placement);
  }

  function showFileError(
    placement,
    message
  ) {
    const card =
      getCard(placement);

    const summary = container.querySelector(
      `[data-me-location-summary="${CSS.escape(placement)}"]`
    );

    card?.classList.add('has-error');

    if (summary) {
      summary.hidden = false;
      summary.className =
        'me-location-artwork__summary is-error';

      summary.textContent = message;
    }
  }

  function getPlacementReadiness(placement) {
    const assignment = assignments.get(placement);
    const complete = hasAssignment(placement);

    // v15.4.7.22 — an existing cart project can take a moment to download and
    // reattach Shopify-hosted artwork. Do not mislabel those placements as
    // REQUIRED while hydration is still in progress.
    if (designer.dataset.meEditRestorePending === 'true') {
      return { complete, status: 'Restoring', state: 'restoring' };
    }

    if (!complete) {
      return { complete: false, status: 'Required', state: 'required' };
    }

    if (assignment?.type === 'artwork') {
      const needsAttention =
        assignment.qualityLevel === 'blocked' ||
        (assignment.qualityLevel === 'warning' && !assignment.qualityAcknowledged);

      if (needsAttention) {
        return { complete: true, status: 'Needs attention', state: 'attention' };
      }
    }

    return { complete: true, status: 'Complete', state: 'complete' };
  }

  function updateCardState(placement) {
    const card = getCard(placement);
    const state = card?.querySelector('.me-location-artwork__state');
    const readiness = getPlacementReadiness(placement);

    card?.classList.toggle('has-artwork', readiness.complete);
    card?.classList.toggle('has-status-required', readiness.state === 'required');
    card?.classList.toggle('has-status-restoring', readiness.state === 'restoring');
    card?.classList.toggle('has-status-attention', readiness.state === 'attention');
    card?.classList.toggle('has-status-complete', readiness.state === 'complete');

    if (state) {
      state.textContent = readiness.status;
      state.setAttribute('aria-label', `${placement} status: ${readiness.status}`);
    }
  }

  function renderNavigator() {
    if (!navigator) return;

    navigator.innerHTML =
      selectedPlacements()
        .map((placement) => {
          const assignment =
            assignments.get(placement);

          const complete =
            hasAssignment(placement);

          return `
            <button
              type="button"
              class="me-designer-location-nav__item
                ${placement === activePlacement ? 'is-active' : ''}
                ${complete ? 'has-artwork' : ''}"
              data-me-navigator-placement="${escapeHtml(placement)}"
            >
              <span class="me-designer-location-nav__icon">
                ${complete ? '✓' : '＋'}
              </span>

              <span class="me-designer-location-nav__content">
                <strong>${escapeHtml(placement)}</strong>

                <small>
                  ${
                    assignment?.summary
                      ? `${escapeHtml(assignment.summary)} · ${assignment.dpi || 0} DPI`
                      : 'Artwork needed'
                  }
                </small>
                <em class="me-designer-location-nav__status ${complete ? 'is-ready' : 'is-needed'}">
                  ${
                    complete
                      ? (assignment?.dpi >= 250 ? 'Ready to print' : 'Review recommended')
                      : 'Required'
                  }
                </em>
              </span>
            </button>
          `;
        })
        .join('');

    navigator
      .querySelectorAll(
        '[data-me-navigator-placement]'
      )
      .forEach((button) => {
        button.addEventListener(
          'click',
          () => {
            activate(
              button.dataset
                .meNavigatorPlacement
            );
          }
        );
      });
  }

  function activate(placement) {
    activePlacement = placement;

    container
      .querySelectorAll(
        '[data-me-location-artwork]'
      )
      .forEach((card) => {
        card.classList.toggle(
          'is-active',
          card.dataset
            .meLocationArtwork === placement
        );
      });

    navigator
      ?.querySelectorAll(
        '[data-me-navigator-placement]'
      )
      .forEach((button) => {
        button.classList.toggle(
          'is-active',
          button.dataset
            .meNavigatorPlacement === placement
        );
      });

    if (activeLocationLabel) {
      activeLocationLabel.textContent =
        placement;
    }

    if (viewStatus) {
      const view =
        rules[placement]?.view ||
        'front';

      viewStatus.textContent =
        view === 'back'
          ? 'Back view'
          : view.includes('sleeve')
            ? 'Sleeve view'
            : 'Front view';
    }

    const assignment =
      assignments.get(placement);

    window.dispatchEvent(
      new CustomEvent(
        'me:preview-placement',
        {
          detail: {
            placement,
            artworkUrl:
              assignment?.type ===
              'artwork'
                ? assignment.objectUrl
                : '',
            nameNumber:
              assignment?.type === 'name-number'
                ? {
                    includeName: assignment.includeName,
                    includeNumber: assignment.includeNumber,
                    name: assignment.backName,
                    number: assignment.backNumber,
                    font: assignment.font,
                    size: assignment.printSize,
                    color: assignment.textColor
                  }
                : null
          }
        }
      )
    );
  }

  function hasAssignment(placement) {
    const assignment =
      assignments.get(placement);

    if (!assignment) return false;

    if (
      assignment.type ===
      'name-number'
    ) {
      const nameComplete = !assignment.includeName || Boolean(assignment.backName);
      const numberComplete = !assignment.includeNumber || Boolean(assignment.backNumber);
      return Boolean((assignment.includeName || assignment.includeNumber) && nameComplete && numberComplete);
    }

    return Boolean(
      assignment.file
    );
  }

  function getSummary() {
    return selectedPlacements()
      .map((placement) => {
        const assignment =
          assignments.get(placement);

        if (!assignment) return null;

        return {
          placement,
          type: assignment.type,
          summary: assignment.summary,
          priceCents: assignment.priceCents || 0
        };
      })
      .filter(Boolean);
  }

  function appendProperties(formData) {
    for (
      const [placement, assignment]
      of assignments.entries()
    ) {
      if (
        assignment.type ===
        'name-number'
      ) {
        formData.set(
          'properties[Back Name]',
          assignment.includeName ? assignment.backName : 'Not included'
        );

        formData.set(
          'properties[Back Number]',
          assignment.includeNumber ? assignment.backNumber : 'Not included'
        );
        formData.set('properties[Back Name Included]', assignment.includeName ? 'Yes' : 'No');
        formData.set('properties[Back Number Included]', assignment.includeNumber ? 'Yes' : 'No');
        formData.set('properties[Name + Number Font]', assignment.font || 'Varsity');
        formData.set('properties[Name + Number Size]', assignment.printSize || 'Large');
        formData.set('properties[Name + Number Color]', assignment.textColor || '#ffffff');
      }
    }
  }

  function dispatchUpdate() {
    window.dispatchEvent(new CustomEvent('me:artwork-updated', { detail: { assignments: getSummary() } }));
    window.dispatchEvent(
      new CustomEvent(
        'me:artwork-updated',
        {
          detail: {
            assignments:
              getSummary()
          }
        }
      )
    );
  }

  function getPreflightState() {
    // v15.4.7.22 — restoration is a temporary busy state, not a customer error.
    // Hold Step 3 validation until the saved files finish hydrating.
    if (designer.dataset.meEditRestorePending === 'true') {
      return { ok: false, issues: [], restoring: true };
    }

    const issues = [];

    selectedPlacements().forEach((placement) => {
      if (!hasAssignment(placement)) {
        issues.push({
          placement,
          type: 'missing',
          message: `${placement}: customization is required before continuing.`
        });
        return;
      }

      if (assignmentType(placement) !== 'artwork') return;
      const assignment = assignments.get(placement);
      if (!assignment) return;

      if (assignment.qualityLevel === 'blocked') {
        issues.push({
          placement,
          type: 'blocked',
          message: `${placement}: artwork resolution is below 150 effective DPI.`
        });
      } else if (
        assignment.qualityLevel === 'warning' &&
        !assignment.qualityAcknowledged
      ) {
        issues.push({
          placement,
          type: 'acknowledgment',
          message: `${placement}: acknowledge the low-resolution warning to continue.`
        });
      }
    });

    return {
      ok: issues.length === 0,
      issues
    };
  }

  function focusFirstPreflightIssue() {
    const state = getPreflightState();
    const first = state.issues[0];
    if (!first) return true;

    activate(first.placement);
    const card = getCard(first.placement);
    card?.scrollIntoView?.({ behavior: 'smooth', block: 'center' });

    const ack = card?.querySelector('[data-me-location-quality-ack]');
    if (first.type === 'acknowledgment' && ack) ack.focus();
    else card?.querySelector('[data-me-location-input]')?.focus();

    return false;
  }

  function getCard(placement) {
    return container.querySelector(
      `[data-me-location-artwork="${CSS.escape(placement)}"]`
    );
  }

  function getInput(placement) {
    return container.querySelector(
      `[data-me-location-input="${CSS.escape(placement)}"]`
    );
  }

  function getUpload(placement) {
    return container.querySelector(
      `[data-me-location-upload="${CSS.escape(placement)}"]`
    );
  }

  window.MEArtworkManager = {
    hasAssignment,
    getSummary,
    getPreflightState,
    focusFirstPreflightIssue,
    activate,
    appendProperties,
    render
  };

  window.addEventListener(
    'me:placements-updated',
    render
  );

  // v15.4.7.22 — refresh every selected card when cart-project restore enters
  // or leaves its busy state. This converts RESTORING -> COMPLETE/REQUIRED
  // immediately after hydration instead of waiting for another customer action.
  window.addEventListener('me:edit-project-restore-state', () => {
    selectedPlacements().forEach((placement) => updateCardState(placement));
    renderNavigator();
    dispatchUpdate();
  });

  render();
});
/* ===== END assets/me-placement-artwork.js ===== */


/* ===== BEGIN assets/me-product-designer.js ===== */
document.addEventListener('DOMContentLoaded', () => {
  'use strict';

  const designer = document.querySelector('[data-me-designer]');
  const openButton = document.querySelector('[data-me-designer-open]');
  const closeButtons = document.querySelectorAll('[data-me-designer-close]');
  const productForm = document.querySelector('.me-main-product__form');

  if (!designer || !openButton || !productForm) {
    return;
  }

  const placementData =
    window.MEPlacementRules?.placements || {};

  const stepOrder = ['design', 'artwork', 'review'];

  const stepButtons = Array.from(
    designer.querySelectorAll('[data-me-step-button]')
  );

  const stepPanels = Array.from(
    designer.querySelectorAll('[data-me-step-panel]')
  );

  const placementInputs = Array.from(
    designer.querySelectorAll('[data-me-placement-checkbox]')
  );

  const selectedPlacementProperty = designer.querySelector(
    '[data-me-selected-placement-property]'
  );

  const placementError = designer.querySelector(
    '[data-me-placement-error]'
  );

  const sizePicker = designer.querySelector('[data-me-size-picker]');
  const sizeProperty = designer.querySelector('[data-me-size-property]');
  const sizeMessage = designer.querySelector('[data-me-size-message]');
  const quantityInput = designer.querySelector('[data-me-quantity-input]');

  const basePriceElement = designer.querySelector('[data-me-price-base]');
  const addOnPriceElement = designer.querySelector('[data-me-price-addons]');
  const unitPriceElement = designer.querySelector('[data-me-price-unit]');
  const totalPriceElement = designer.querySelector('[data-me-price-total]');

  const addOnListElement = designer.querySelector(
    '[data-me-price-addon-list]'
  );

  const primaryAction = designer.querySelector(
    '[data-me-designer-primary-action]'
  );

  const primaryActionLabel = designer.querySelector(
    '[data-me-primary-action-label]'
  );

  const reviewSubmit = designer.querySelector('[data-me-review-submit]');

  const cartStatus = designer.querySelector(
    '[data-me-designer-cart-status]'
  );

  const reviewAlert = designer.querySelector('[data-me-review-alert]');

  const rightsCheckbox = designer.querySelector(
    '[data-me-rights-checkbox]'
  );

  let currentStep = 'design';
  const dynamicPlacementPrices = new Map();

  let basePriceCents = Number(
    designer.dataset.meBasePriceCents || 0
  );

  let lastFocusedElement = null;

  function formatMoney(cents) {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD'
    }).format((Number(cents) || 0) / 100);
  }

  function escapeHtml(value) {
    return String(value || '')
      .replaceAll('&', '&amp;')
      .replaceAll('<', '&lt;')
      .replaceAll('>', '&gt;')
      .replaceAll('"', '&quot;')
      .replaceAll("'", '&#039;');
  }

  function createDesignGroupId() {
    // Edit Personalization restores the original reference directly onto the
    // designer. A fresh customization must generate a new reference instead of
    // reading a previous project from sessionStorage, which could merge separate
    // products/colors into one unified cart project.
    if (designer.dataset.meProjectReference) {
      return designer.dataset.meProjectReference;
    }

    const reference = window.crypto?.randomUUID
      ? `me-${window.crypto.randomUUID()}`
      : [
          'me',
          Date.now().toString(36),
          Math.random().toString(36).slice(2, 11)
        ].join('-');

    designer.dataset.meProjectReference = reference;
    return reference;
  }

  function getQuantity() {
    if (isMultiSizeMode()) {
      return getMultiSizeTotal();
    }

    const quantity = Number.parseInt(
      quantityInput?.value || '1',
      10
    );

    return Number.isFinite(quantity) && quantity > 0
      ? quantity
      : 1;
  }

  function getSelectedPlacements() {
    return placementInputs
      .filter((input) => input.checked)
      .map((input) => input.value);
  }

  function getPlacementGroup(placement) {
    return placementData[placement]?.group || '';
  }

  function getCurrentColor() {
    const label = designer.querySelector('[data-me-selected-color]');

    const value = String(label?.textContent || '')
      .replace(/^Selected:\s*/i, '')
      .trim();

    if (!value || value.toLowerCase() === 'select a color') {
      return '';
    }

    return value;
  }

  function getCurrentSize() {
    if (isMultiSizeMode()) return '';
    return String(sizeProperty?.value || '').trim();
  }

  function isMultiSizeMode() {
    const button = designer.querySelector('[data-me-order-mode="multi"]');
    return Boolean(button && (button.classList.contains('is-active') || button.getAttribute('aria-pressed') === 'true'));
  }

  function getMultiSizeTotal() {
    return Array.from(designer.querySelectorAll('[data-me-size-quantity]')).reduce((total, input) => total + Math.max(0, Number.parseInt(input.value || '0', 10) || 0), 0);
  }

  function getMultiSizeSummary() {
    return Array.from(designer.querySelectorAll('[data-me-size-quantity]'))
      .map((input) => ({
        size: String(input.dataset.meSizeValue || '').trim(),
        quantity: Math.max(0, Number.parseInt(input.value || '0', 10) || 0)
      }))
      .filter((entry) => entry.size && entry.quantity > 0)
      .map((entry) => `${entry.size}: ${entry.quantity}`)
      .join(', ');
  }


  function normalizeVariantSize(value) {
    return String(value || '').trim().toUpperCase().replace(/[^A-Z0-9]/g, '');
  }

  function getProductData() {
    if (window.MomentsCurrentProduct?.variants) return window.MomentsCurrentProduct;
    try {
      return JSON.parse(designer.querySelector('[data-me-initial-product-json]')?.textContent || 'null');
    } catch (_) {
      return null;
    }
  }

  function getVariantPriceForSize(size) {
    const product = getProductData();
    const normalized = normalizeVariantSize(size);
    const variant = product?.variants?.find((candidate) =>
      (candidate.options || []).some((option) => normalizeVariantSize(option) === normalized)
    ) || product?.variants?.find((candidate) => normalizeVariantSize(candidate.title) === normalized);
    return Number(variant?.price ?? basePriceCents ?? 0);
  }

  function getGarmentSubtotalCents() {
    if (!isMultiSizeMode()) {
      const selectedSize = getCurrentSize();
      return (selectedSize ? getVariantPriceForSize(selectedSize) : basePriceCents) * getQuantity();
    }

    return Array.from(designer.querySelectorAll('[data-me-size-quantity]')).reduce((total, input) => {
      const quantity = Math.max(0, Number.parseInt(input.value || '0', 10) || 0);
      if (!quantity) return total;
      return total + (getVariantPriceForSize(input.dataset.meSizeValue) * quantity);
    }, 0);
  }

  function getArtworkSummary() {
    return window.MEArtworkManager?.getSummary() || [];
  }

  // v15.4.7.32 — these helpers must live in the product-designer scope.
  // A separate copy exists later in me-save-design.js, but that copy is not
  // visible to updatePricing(), updateProjectIntelligence(), or addToCart().
  function getNeckLabelChoice() {
    return String(
      designer.querySelector('[data-me-neck-label-choice]:checked')?.value || 'original'
    );
  }

  function getBrandingCreditCents() {
    return getNeckLabelChoice() === 'me-branding'
      ? Math.max(0, Number(designer.dataset.meBrandingCreditCents || 200))
      : 0;
  }

  function hasRequiredFrontPlacement() {
    return getSelectedPlacements().some(
      (placement) => getPlacementGroup(placement) === 'front'
    );
  }

  function isDesignComplete() {
    // v15 guided flow intentionally collects size after artwork.
    return Boolean(getCurrentColor() && hasRequiredFrontPlacement());
  }

  function isArtworkComplete() {
    const placements = getSelectedPlacements();
    const manager = window.MEArtworkManager;

    if (!manager || !placements.length) {
      return false;
    }

    return placements.every((placement) =>
      manager.hasAssignment(placement)
    );
  }


  function getMissingAction() {
    if (!getCurrentColor()) return 'Select a garment color to continue.';
    if (!hasRequiredFrontPlacement()) return 'Choose a front print location to continue.';
    if (currentStep === 'review') {
      if (isMultiSizeMode()) {
        if (getMultiSizeTotal() < 1) return 'Enter at least one size quantity to continue.';
      } else if (!getCurrentSize()) {
        return 'Select a garment size to continue.';
      }
    }
    const missingArtwork = getSelectedPlacements().find((placement) =>
      !window.MEArtworkManager?.hasAssignment(placement)
    );
    if (currentStep !== 'design' && missingArtwork) return `Upload artwork for ${missingArtwork}.`;
    if (currentStep === 'review' && !rightsCheckbox?.checked) return 'Confirm the artwork authorization to add this project.';
    return '';
  }

  function updateProjectIntelligence() {
    const color = getCurrentColor();
    const placements = getSelectedPlacements();
    const quantity = getQuantity();
    const size = isMultiSizeMode()
      ? (getMultiSizeSummary() || 'No quantities entered')
      : (getCurrentSize() || 'Not selected');
    const artwork = getArtworkSummary();

    const colorEl = designer.querySelector('[data-me-project-color]');
    const sizeEl = designer.querySelector('[data-me-project-size]');
    const quantityEl = designer.querySelector('[data-me-project-quantity]');
    const locationsEl = designer.querySelector('[data-me-project-locations]');
    const totalEl = designer.querySelector('[data-me-project-total]');
    const statusEl = designer.querySelector('[data-me-project-status]');

    if (colorEl) colorEl.textContent = color || 'Not selected';
    if (sizeEl) sizeEl.textContent = size;
    if (quantityEl) quantityEl.textContent = String(quantity);
    if (locationsEl) locationsEl.textContent = placements.length ? placements.join(', ') : 'None selected';
    if (totalEl) {
      const paidAddOnCents = placements.reduce((sum, placement) => sum + Number(dynamicPlacementPrices.has(placement) ? dynamicPlacementPrices.get(placement) : placementData[placement]?.priceCents || 0), 0);
      const garmentSubtotalCents = getGarmentSubtotalCents();
      const brandingCreditTotalCents = getBrandingCreditCents() * Math.max(quantity, 0);
      const discountedGarmentBaseCents = Math.max(0, garmentSubtotalCents - brandingCreditTotalCents);
      const volumePercent = quantity >= 21 ? 0 : quantity >= 11 ? 10 : quantity >= 6 ? 5 : 0;
      const volumeDiscountCents = Math.round(discountedGarmentBaseCents * (volumePercent / 100));
      const projectTotalCents = Math.max(0, discountedGarmentBaseCents - volumeDiscountCents + (paidAddOnCents * Math.max(quantity, 0)));
      totalEl.textContent = formatMoney(projectTotalCents);
    }

    const checks = [
      { label: 'Garment color selected', complete: Boolean(color) },
      { label: isMultiSizeMode() ? 'Size quantities entered' : 'Garment size selected', complete: isMultiSizeMode() ? getMultiSizeTotal() > 0 : Boolean(getCurrentSize()) },
      { label: 'Print location selected', complete: placements.length > 0 && hasRequiredFrontPlacement() },
      { label: 'Artwork assigned to every location', complete: placements.length > 0 && isArtworkComplete() },
      { label: 'Artwork authorization confirmed', complete: Boolean(rightsCheckbox?.checked) }
    ];
    const completeCount = checks.filter((item) => item.complete).length;
    const score = Math.round((completeCount / checks.length) * 100);
    const hasLowQuality = artwork.some((item) => Number(item.dpi || 999) < 250);
    const ready = score === 100;
    const readinessStatus = ready
      ? (hasLowQuality ? 'Ready for review' : 'Ready to print')
      : score >= 60 ? 'Needs attention' : 'Getting started';

    const scoreEl = designer.querySelector('[data-me-readiness-score]');
    const readinessStatusEl = designer.querySelector('[data-me-readiness-status]');
    const barEl = designer.querySelector('[data-me-readiness-bar]');
    const checklistEl = designer.querySelector('[data-me-readiness-checklist]');
    const readinessEl = designer.querySelector('[data-me-readiness]');

    if (scoreEl) scoreEl.textContent = `${score}%`;
    if (readinessStatusEl) readinessStatusEl.textContent = readinessStatus;
    if (barEl) barEl.style.width = `${score}%`;
    if (readinessEl) {
      readinessEl.classList.toggle('is-ready', ready && !hasLowQuality);
      readinessEl.classList.toggle('needs-review', ready && hasLowQuality);
    }
    if (checklistEl) {
      checklistEl.innerHTML = checks.map((item) => `
        <li class="${item.complete ? 'is-complete' : ''}">
          <span aria-hidden="true">${item.complete ? '✓' : '•'}</span>
          ${escapeHtml(item.label)}
        </li>
      `).join('');
    }
    if (statusEl) statusEl.textContent = ready ? readinessStatus : 'In progress';

    const proofStatus = designer.querySelector('[data-me-review-proof-status]');
    const rightsStatus = designer.querySelector('[data-me-review-rights-status]');
    const proofChecked = Boolean(designer.querySelector('[data-me-proof-checkbox]')?.checked);
    if (proofStatus) {
      proofStatus.classList.toggle('is-complete', proofChecked);
      const icon = proofStatus.querySelector(':scope > span');
      const copy = proofStatus.querySelector('p');
      if (icon) icon.textContent = proofChecked ? '✓' : '•';
      if (copy) copy.textContent = proofChecked ? 'Requested — approval required before production' : 'Not requested';
    }
    if (rightsStatus) {
      rightsStatus.classList.toggle('is-complete', Boolean(rightsCheckbox?.checked));
      const icon = rightsStatus.querySelector(':scope > span');
      const copy = rightsStatus.querySelector('p');
      if (icon) icon.textContent = rightsCheckbox?.checked ? '✓' : '•';
      if (copy) copy.textContent = rightsCheckbox?.checked ? 'Confirmed' : 'Required before adding to cart';
    }

    const missing = getMissingAction();
    if (primaryActionLabel) {
      if (missing) primaryActionLabel.textContent = missing;
      else if (currentStep === 'design') primaryActionLabel.textContent = 'Ready for Artwork Review →';
      else if (currentStep === 'artwork') primaryActionLabel.textContent = 'Continue to Project Review →';
      else if (getQuantity() >= 21) primaryActionLabel.textContent = 'Request Bulk Quote';
      else primaryActionLabel.textContent = designer.dataset.meEditingCartProject === 'true' ? 'Confirm & Update Item' : 'Confirm & Add to Cart';
    }
    if (cartStatus && missing && currentStep !== 'review') cartStatus.textContent = missing;
    else if (cartStatus && !missing && currentStep !== 'review') cartStatus.textContent = '';
  }

  function removeDuplicatePreviewPrompts() {
    designer
      .querySelectorAll('.me-live-preview__empty')
      .forEach((prompt) => prompt.remove());
  }

  function openDesigner() {
    lastFocusedElement = document.activeElement;

    removeDuplicatePreviewPrompts();

    designer.classList.add('is-open');
    designer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('me-designer-open');

    setStep('design');

    designer.querySelector('.me-designer__close')?.focus();
  }

  function closeDesigner() {
    designer.classList.remove('is-open');
    designer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('me-designer-open');

    lastFocusedElement?.focus?.();
  }

  function setStep(step) {
    if (!stepOrder.includes(step)) {
      return;
    }

    currentStep = step;
    designer.dataset.meCurrentStep = step;

    // v9.6.4: keep the visible progress caption synchronized at the source.
    const progressCopy = designer.querySelector('[data-me-builder-progress-copy]');
    const progressFill = designer.querySelector('[data-me-builder-progress-fill]');
    const progressLabels = {
      design: 'Step 1 of 3 · Configure your project',
      artwork: 'Step 2 of 3 · Assign your artwork',
      review: 'Step 3 of 3 · Review and add to cart'
    };
    const progressIndex = stepOrder.indexOf(step);
    if (progressCopy) progressCopy.textContent = progressLabels[step] || progressLabels.design;
    if (progressFill) progressFill.style.width = `${((progressIndex + 1) / stepOrder.length) * 100}%`;

    const reviewPurchase = designer.querySelector('[data-me-review-purchase]');
    if (reviewPurchase) reviewPurchase.hidden = step !== 'review';

    stepPanels.forEach((panel) => {
      const active = panel.dataset.meStepPanel === step;

      panel.classList.toggle('is-active', active);
      panel.hidden = !active;
    });

    updateStepStates();

    if (primaryActionLabel) {
      if (step === 'design') {
        primaryActionLabel.textContent = 'Continue to Artwork';
      } else if (step === 'artwork') {
        primaryActionLabel.textContent = 'Continue to Review';
      } else {
        primaryActionLabel.textContent = getQuantity() >= 21
          ? 'Request Bulk Quote'
          : designer.dataset.meEditingCartProject === 'true'
            ? 'Confirm & Update Item'
            : 'Confirm & Add to Cart';
      }
    }

    if (step === 'review') {
      renderReview();
    }

    designer
      .querySelector('.me-designer__controls')
      ?.scrollTo({
        top: 0,
        behavior: 'smooth'
      });

    updatePrimaryActionState();
  }

  function updateStepStates() {
    stepButtons.forEach((button) => {
      const step = button.dataset.meStepButton;
      const active = step === currentStep;

      let complete = false;

      if (step === 'design') {
        complete = isDesignComplete();
      }

      if (step === 'artwork') {
        complete = isArtworkComplete();
      }

      if (step === 'review') {
        complete =
          Boolean(rightsCheckbox?.checked) &&
          isDesignComplete() &&
          isArtworkComplete();
      }

      button.classList.toggle('is-active', active);
      button.classList.toggle(
        'is-complete',
        complete && !active
      );

      if (active) {
        button.setAttribute('aria-current', 'step');
      } else {
        button.removeAttribute('aria-current');
      }
    });

    updateProjectIntelligence();
  }

  function enforcePlacementConflicts(changedInput) {
    if (changedInput?.checked) {
      const group = getPlacementGroup(changedInput.value);

      placementInputs.forEach((input) => {
        if (input === changedInput) {
          return;
        }

        if (
          group &&
          getPlacementGroup(input.value) === group
        ) {
          input.checked = false;
        }
      });
    }

    if (!hasRequiredFrontPlacement()) {
      const fallback = placementInputs.find(
        (input) => input.value === 'Left Chest'
      );

      if (fallback) {
        fallback.checked = true;
      }
    }

    updatePlacementCards();
    updatePlacementState();
  }

  function updatePlacementCards() {
    placementInputs.forEach((input) => {
      const card = input.closest('[data-me-placement-card]');

      card?.classList.toggle(
        'is-selected',
        input.checked
      );
    });
  }

  function updatePlacementState() {
    const placements = getSelectedPlacements();

    if (selectedPlacementProperty) {
      selectedPlacementProperty.value = placements.join(', ');
    }

    if (placementError) {
      placementError.textContent =
        hasRequiredFrontPlacement()
          ? ''
          : 'Select one included front print location.';
    }

    updatePricing();

    window.dispatchEvent(
      new CustomEvent('me:placements-updated', {
        detail: {
          placements
        }
      })
    );

    updateStepStates();
    updatePrimaryActionState();
  }

  window.addEventListener('me:artwork-updated', updateProjectIntelligence);
  window.addEventListener('me:placements-updated', () => window.setTimeout(updateProjectIntelligence, 0));
  window.addEventListener('me:neck-label-updated', () => { updatePricing(); updateProjectIntelligence(); });

  function updatePricing() {
    const placements = getSelectedPlacements();

    const paidAddOnCents = placements.reduce(
      (total, placement) =>
        total +
        Number(
          dynamicPlacementPrices.has(placement)
            ? dynamicPlacementPrices.get(placement)
            : placementData[placement]?.priceCents || 0
        ),
      0
    );

    const brandingCreditCents = getBrandingCreditCents();
    const quantity = getQuantity();
    const garmentSubtotalCents = getGarmentSubtotalCents();
    const addOnSubtotalCents = paidAddOnCents * Math.max(quantity, 0);
    const brandingCreditTotalCents = brandingCreditCents * Math.max(quantity, 0);
    const discountedGarmentBaseCents = quantity > 0
      ? Math.max(0, garmentSubtotalCents - brandingCreditTotalCents)
      : 0;
    const isBulkQuantity = quantity >= 21;
    const volumePercent = quantity >= 21 ? 0 : quantity >= 11 ? 10 : quantity >= 6 ? 5 : 0;
    /* Group savings apply to garments after the ME branding credit, never to paid print add-ons. */
    const volumeDiscountCents = Math.round(discountedGarmentBaseCents * (volumePercent / 100));
    const totalCents = Math.max(0, discountedGarmentBaseCents - volumeDiscountCents + addOnSubtotalCents);
    const unitPriceCents = quantity > 0
      ? Math.round(totalCents / quantity)
      : Math.max(0, basePriceCents + paidAddOnCents - brandingCreditCents);

    const volumePricing = designer.querySelector('[data-me-volume-pricing]');
    const volumeMessage = designer.querySelector('[data-me-volume-message]');
    const volumeBulkCta = designer.querySelector('[data-me-volume-bulk-cta]');

    const activeTier = isBulkQuantity
      ? 21
      : volumePercent === 10
        ? 11
        : volumePercent === 5
          ? 6
          : 0;

    volumePricing?.querySelectorAll('[data-tier]').forEach((tier) => {
      const tierValue = Number(tier.dataset.tier);
      const isActive = tierValue === activeTier;

      tier.classList.toggle('is-active', isActive);
      tier.classList.toggle('is-bulk-active', isBulkQuantity && tierValue === 21);
    });

    if (volumeBulkCta) {
      volumeBulkCta.hidden = !isBulkQuantity;
    }

    if (volumeMessage) {
      if (isBulkQuantity) {
        volumeMessage.textContent = '21+ bulk pricing available. Submit a quote request for final pricing based on your order details.';
      } else if (volumePercent === 10) {
        volumeMessage.textContent = '10% group-order savings estimated. Orders of 21+ use custom bulk pricing.';
      } else if (volumePercent === 5) {
        volumeMessage.textContent = `5% group-order savings estimated. Add ${11 - quantity} more item${11 - quantity === 1 ? '' : 's'} to reach 10% savings.`;
      } else {
        volumeMessage.textContent = `Add ${6 - quantity} more item${6 - quantity === 1 ? '' : 's'} to save 5%.`;
      }
    }

    if (basePriceElement) {
      basePriceElement.textContent =
        formatMoney(basePriceCents);
    }

    if (addOnPriceElement) {
      /* Paid add-ons are shown independently; credits/savings have their own rows. */
      addOnPriceElement.textContent = formatMoney(paidAddOnCents);
    }

    if (unitPriceElement) {
      unitPriceElement.textContent =
        formatMoney(unitPriceCents);
    }

    if (totalPriceElement) {
      totalPriceElement.textContent =
        formatMoney(totalCents);
    }

    if (addOnListElement) {
      addOnListElement.innerHTML = placements
        .map((placement) => {
          const price = Number(
            dynamicPlacementPrices.has(placement)
              ? dynamicPlacementPrices.get(placement)
              : placementData[placement]?.priceCents || 0
          );

          return `
            <div class="me-price-summary__addon">
              <span>${escapeHtml(placement)}</span>

              <strong>
                ${
                  price === 0
                    ? 'Included'
                    : `+${formatMoney(price)}`
                }
              </strong>
            </div>
          `;
        })
        .join('');

      if (brandingCreditCents > 0) {
        addOnListElement.insertAdjacentHTML('beforeend', `
          <div class="me-price-summary__addon me-price-summary__addon--branding-credit">
            <span>Moments Etched branding credit</span>
            <strong>−${formatMoney(brandingCreditCents)} each</strong>
          </div>
        `);
      }

      if (volumeDiscountCents > 0) {
        addOnListElement.insertAdjacentHTML('beforeend', `
          <div class="me-price-summary__addon me-price-summary__addon--discount">
            <span>Quantity discount (${volumePercent}%)</span>
            <strong>−${formatMoney(volumeDiscountCents / Math.max(quantity, 1))} each</strong>
          </div>
        `);
      }
    }

    const discountProperty = designer.querySelector('[data-me-volume-discount-property]');
    if (discountProperty) {
      discountProperty.value = isBulkQuantity
        ? 'Custom bulk pricing pending review'
        : volumePercent
          ? `${volumePercent}%`
          : 'None';
    }

    const reviewTotal = designer.querySelector(
      '[data-me-review-total]'
    );

    if (reviewTotal) {
      reviewTotal.textContent = formatMoney(totalCents);
    }
  }

  function getDesignValidationMessage() {
    if (!getCurrentColor()) {
      return 'Select a garment color to continue.';
    }

    // v15: garment size is intentionally collected after artwork.
    if (!hasRequiredFrontPlacement()) {
      return 'Select one included front print location.';
    }

    return '';
  }

  function updatePrimaryActionState() {
    if (!primaryAction) {
      return;
    }

    let disabled = false;
    let message = '';

    if (currentStep === 'design') {
      disabled = !isDesignComplete();
      message = getDesignValidationMessage();
    }

    if (currentStep === 'artwork') {
      disabled = !isArtworkComplete();

      if (disabled) {
        message =
          'Complete the customization for every selected location.';
      }
    }

    if (currentStep === 'review') {
      if ((isMultiSizeMode() && getMultiSizeTotal() < 1) || (!isMultiSizeMode() && !getCurrentSize())) {
        disabled = true;
        message = isMultiSizeMode()
          ? 'Enter at least one size quantity before adding the project.'
          : 'Select a garment size before adding the project.';
      } else if (!rightsCheckbox?.checked) {
        // Keep the final action clickable so it can guide the customer directly
        // to the required authorization control.
        disabled = false;
        message = 'Confirm the artwork authorization before adding this item.';
      }
    }

    primaryAction.disabled = disabled;

    if (cartStatus) {
      cartStatus.textContent = message;
    }
  }

  function validateDesignStep() {
    const message = getDesignValidationMessage();

    if (!message) {
      return true;
    }

    if (cartStatus) {
      cartStatus.textContent = message;
    }

    if (!isMultiSizeMode() && !getCurrentSize()) {
      sizePicker?.scrollIntoView({
        behavior: 'smooth',
        block: 'center'
      });

      if (sizeMessage) {
        sizeMessage.textContent = 'Select a garment size to continue.';
        sizeMessage.classList.remove('is-complete');
        sizeMessage.classList.add('is-required');
      }
    }

    return false;
  }

  function validateArtworkStep() {
    const placements = getSelectedPlacements();
    const manager = window.MEArtworkManager;

    if (!manager) {
      if (cartStatus) {
        cartStatus.textContent =
          'Artwork controls are still loading.';
      }

      return false;
    }

    const missing = placements.filter(
      (placement) =>
        !manager.hasAssignment(placement)
    );

    if (!missing.length) {
      if (cartStatus) {
        cartStatus.textContent = '';
      }

      return true;
    }

    manager.activate(missing[0]);

    if (cartStatus) {
      cartStatus.textContent =
        `Complete ${missing[0]} before continuing.`;
    }

    return false;
  }

  function renderReview() {
    const placements = getSelectedPlacements();
    const artworkSummary = getArtworkSummary();

    const productTitle = designer.querySelector(
      '[data-me-review-product-title]'
    );

    const color = designer.querySelector(
      '[data-me-review-color]'
    );

    const size = designer.querySelector(
      '[data-me-review-size]'
    );

    const quantity = designer.querySelector(
      '[data-me-review-quantity]'
    );

    const placementList = designer.querySelector(
      '[data-me-review-placements]'
    );

    const artworkList = designer.querySelector(
      '[data-me-review-artwork]'
    );

    if (productTitle) {
      productTitle.textContent =
        designer.dataset.meProductTitle || '';
    }

    if (color) {
      color.textContent = getCurrentColor() || 'Not selected';
    }

    if (size) {
      size.textContent = isMultiSizeMode()
        ? (getMultiSizeSummary() || 'Add size quantities')
        : (getCurrentSize() || 'Not selected');
    }

    if (quantity) {
      quantity.textContent = String(getQuantity());
    }

    if (placementList) {
      placementList.innerHTML = placements
        .map((placement) => {
          const price = Number(
            dynamicPlacementPrices.has(placement)
              ? dynamicPlacementPrices.get(placement)
              : placementData[placement]?.priceCents || 0
          );

          return `
            <div class="me-review-list__item">
              <span>${escapeHtml(placement)}</span>

              <strong>
                ${
                  price === 0
                    ? 'Included'
                    : `+${formatMoney(price)} each`
                }
              </strong>
            </div>
          `;
        })
        .join('');
    }

    if (artworkList) {
      artworkList.innerHTML = placements
        .map((placement) => {
          const assignment = artworkSummary.find(
            (item) => item.placement === placement
          );

          return `
            <div class="me-review-list__item ${
              assignment ? '' : 'is-missing'
            }">
              <span>${escapeHtml(placement)}</span>

              <strong>
                ${
                  assignment
                    ? escapeHtml(assignment.summary)
                    : 'Customization missing'
                }
              </strong>
            </div>
          `;
        })
        .join('');
    }

    updatePricing();
    clearReviewAlert();
    updateStepStates();
  }

  function showReviewAlert(message, type = 'error') {
    if (!reviewAlert) {
      return;
    }

    reviewAlert.hidden = false;
    reviewAlert.className =
      `me-review-alert is-${type}`;
    reviewAlert.textContent = message;

    // Keep the customer at the final action instead of unexpectedly moving
    // the left review panel. The same message is mirrored beside the button.
    if (cartStatus) {
      cartStatus.textContent = message;
    }
  }

  function clearReviewAlert() {
    if (!reviewAlert) {
      return;
    }

    reviewAlert.hidden = true;
    reviewAlert.textContent = '';
    reviewAlert.className = 'me-review-alert';
  }

  async function rollbackBaseLine(baseLineKey) {
    if (!baseLineKey) {
      return;
    }

    try {
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({
          id: baseLineKey,
          quantity: 0
        })
      });
    } catch (error) {
      console.warn(
        'Unable to roll back garment after add-on failure.',
        error
      );
    }
  }

  function readDesignerProductJson() {
    const selectedProduct = window.MomentsSelectedColor?.product;
    if (selectedProduct && Array.isArray(selectedProduct.variants)) return selectedProduct;
    const projectProduct = window.MomentsProjectState?.product?.selectedColorProduct;
    if (projectProduct && Array.isArray(projectProduct.variants)) return projectProduct;
    if (window.MomentsCurrentProduct && Array.isArray(window.MomentsCurrentProduct.variants)) return window.MomentsCurrentProduct;
    const node = designer.querySelector('[data-me-initial-product-json]') || document.querySelector('[data-me-initial-product-json]');
    if (!node) return null;
    try {
      return JSON.parse(node.textContent || '{}');
    } catch (error) {
      console.warn('[Moments Project Builder] Product JSON could not be parsed for cart generation.', error);
      return null;
    }
  }

  function normalizeCartSize(value) {
    const normalized = String(value || '')
      .trim()
      .toUpperCase()
      .replace(/[._-]+/g, ' ')
      .replace(/\b(YOUTH|ADULT|WOMEN|WOMENS|MEN|MENS|UNISEX|SIZE|SIZES)\b/g, ' ')
      .replace(/\s+/g, '')
      .replace(/^EXTRASMALL$/, 'XS')
      .replace(/^SMALL$/, 'S')
      .replace(/^MEDIUM$/, 'M')
      .replace(/^LARGE$/, 'L')
      .replace(/^EXTRALARGE$/, 'XL')
      .replace(/^([2-9])X$/, '$1XL')
      .replace(/^([2-9])XLARGE$/, '$1XL');

    const youthAliases = {
      YXS: 'XS', YS: 'S', YM: 'M', YL: 'L', YXL: 'XL',
      YOUTHXS: 'XS', YOUTHS: 'S', YOUTHM: 'M', YOUTHL: 'L', YOUTHXL: 'XL'
    };
    return youthAliases[normalized] || normalized;
  }

  function getVariantOptionValues(variant) {
    const values = Array.isArray(variant?.options) ? [...variant.options] : [];
    ['option1', 'option2', 'option3'].forEach((key) => {
      if (variant?.[key] != null && !values.includes(variant[key])) values.push(variant[key]);
    });
    if (variant?.title && variant.title !== 'Default Title') {
      String(variant.title).split(' / ').forEach((value) => values.push(value));
    }
    return values.map((value) => String(value || '').trim()).filter(Boolean);
  }

  function resolveVariantBySize(product, size) {
    if (!product || !Array.isArray(product.variants)) return null;
    const normalizedSize = normalizeCartSize(size);
    const sizeIndex = findProductOptionIndex(product, 'size');
    const variants = product.variants.filter((variant) => variant && variant.id);

    const optionValue = (variant, index) =>
      variant?.options?.[index] ?? variant?.[`option${index + 1}`] ?? '';

    // Resolve dynamically from the actual Shopify option named Size/Sizes,
    // regardless of whether it is option1, option2, or option3.
    if (sizeIndex >= 0) {
      const direct = variants.find((variant) =>
        normalizeCartSize(optionValue(variant, sizeIndex)) === normalizedSize
      );
      if (direct) return direct;
    }

    // Single-option color products often expose size only as option1 or title.
    const valueMatch = variants.find((variant) =>
      getVariantOptionValues(variant).some((value) => normalizeCartSize(value) === normalizedSize)
    );
    if (valueMatch) return valueMatch;

    // Last-resort token match handles titles such as “Youth M” or “Medium”.
    const titleMatch = variants.find((variant) => {
      const tokens = String(variant.title || '')
        .split(/\s*\/\s*|,|\|/)
        .map(normalizeCartSize)
        .filter(Boolean);
      return tokens.includes(normalizedSize);
    });
    if (titleMatch) return titleMatch;

    const visibleSizes = Array.from(designer.querySelectorAll('[data-me-size-button]'))
      .map((button) => normalizeCartSize(button.dataset.sizeValue || button.textContent))
      .filter(Boolean);
    const index = visibleSizes.indexOf(normalizedSize);
    return index >= 0 ? variants[index] || null : null;
  }

  function findProductOptionIndex(product, keyword) {
    const options = Array.isArray(product?.options) ? product.options : [];
    return options.findIndex((option) => {
      const name = String(typeof option === 'string' ? option : option?.name || '').trim().toLowerCase();
      return name.includes(keyword);
    });
  }

  function getMultiSizeDistribution() {
    return Array.from(designer.querySelectorAll('[data-me-size-quantity]')).reduce((distribution, input) => {
      const size = String(input.dataset.meSizeValue || '').trim();
      const quantity = Math.max(0, Number.parseInt(input.value || '0', 10) || 0);
      if (size && quantity > 0) distribution[size] = quantity;
      return distribution;
    }, {});
  }

  function collectArtworkProperties() {
    const formData = new FormData();
    window.MEArtworkManager?.appendProperties(formData);
    const properties = {};
    for (const [key, value] of formData.entries()) {
      const match = String(key).match(/^properties\[(.+)\]$/);
      if (match && typeof value === 'string') properties[match[1]] = value;
    }
    return properties;
  }

  function resolveMultiSizeCartLines(product, color, distribution) {
    if (!product || !Array.isArray(product.variants)) {
      throw new Error('Product variant data is unavailable. Refresh the page and try again.');
    }

    const lines = [];
    const missing = [];

    Object.entries(distribution).forEach(([size, quantity]) => {
      const input = Array.from(designer.querySelectorAll('[data-me-size-quantity]')).find(
        (node) => normalizeCartSize(node.dataset.meSizeValue) === normalizeCartSize(size)
      );
      const normalizedSize = normalizeCartSize(size);
      // Resolve from the currently selected color product every time. IDs stored
      // on distribution inputs can belong to the color that originally opened
      // the designer and must not override the active product.
      let variant = resolveVariantBySize(product, size);

      if (!variant?.id) missing.push(size);
      else {
        if (input) input.dataset.meVariantId = String(variant.id);
        lines.push({ variant, size, quantity });
      }
    });

    if (missing.length) {
      throw new Error(`These sizes could not be matched to available ${color || 'selected color'} variants: ${missing.join(', ')}. Reselect the garment color and try again.`);
    }
    return lines;
  }

  const ME_CART_LINE_MAX = 50;

  function chunkCartItem(item, label) {
    const quantity = Math.max(0, Number.parseInt(item.quantity, 10) || 0);
    if (!quantity) return [];

    const chunks = [];
    let remaining = quantity;
    let index = 1;
    const totalChunks = Math.ceil(quantity / ME_CART_LINE_MAX);

    while (remaining > 0) {
      const chunkQuantity = Math.min(ME_CART_LINE_MAX, remaining);
      chunks.push({
        ...item,
        quantity: chunkQuantity,
        properties: {
          ...(item.properties || {}),
          '_ME Quantity Chunk': `${label} ${index}/${totalChunks}`
        }
      });
      remaining -= chunkQuantity;
      index += 1;
    }

    return chunks;
  }

  async function removeExistingProjectLines(projectReference) {
    if (!projectReference) return 0;

    const root = window.Shopify?.routes?.root || '/';
    const cartResponse = await fetch(`${root}cart.js`, {
      headers: { Accept: 'application/json' },
      cache: 'no-store'
    });

    if (!cartResponse.ok) return 0;

    const cart = await cartResponse.json();
    const updates = {};

    (cart.items || []).forEach((item) => {
      const properties = item.properties || {};
      if (properties['_ME Design Group'] === projectReference) {
        updates[item.key] = 0;
      }
    });

    const count = Object.keys(updates).length;
    if (!count) return 0;

    const updateResponse = await fetch(`${root}cart/update.js`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({ updates })
    });

    if (!updateResponse.ok) {
      const data = await updateResponse.json().catch(() => ({}));
      throw new Error(data.description || data.message || 'The existing project could not be updated in the cart.');
    }

    return count;
  }

  async function addMultiSizeProjectToCart({ placements, artworkSummary, designGroupId }) {
    // Commit the latest review quantities and rebuild their exact Shopify
    // variant IDs immediately before checkout. This prevents a stale project
    // snapshot from leaving the final button active but unable to submit.
    try {
      window.MomentsProject?.refresh?.('pre-cart');
    } catch (error) {
      console.warn('[Moments v6.0.19] Project refresh before cart failed.', error);
    }

    const product = readDesignerProductJson();
    const color = getCurrentColor();
    const distribution = getMultiSizeDistribution();

    if (window.MomentsProject?.buildDistributionVariantMap && product) {
      const freshMap = window.MomentsProject.buildDistributionVariantMap(product) || {};
      window.MomentsDistributionVariantMap = {
        ...(window.MomentsDistributionVariantMap || {}),
        ...freshMap
      };

      Array.from(designer.querySelectorAll('[data-me-size-quantity]')).forEach((input) => {
        const size = normalizeCartSize(input.dataset.meSizeValue || '');
        const variantId = Number(freshMap[size] || 0);
        if (variantId) input.dataset.meVariantId = String(variantId);
      });
    }
    const lines = resolveMultiSizeCartLines(product, color, distribution);
    const totalQuantity = lines.reduce((sum, line) => sum + line.quantity, 0);
    if (!lines.length || totalQuantity < 1) throw new Error('Enter at least one size quantity before adding the project.');

    const artworkProperties = collectArtworkProperties();
    const distributionSummary = lines.map((line) => `${line.size}: ${line.quantity}`).join(', ');
    const activeNeckMode = getNeckLabelChoice();
    const sharedProperties = {
      'Order Type': 'Multiple Sizes',
      'Garment Color': color,
      'Size Distribution': distributionSummary,
      'Selected Print Locations': placements.join(', '),
      'Artwork File Count': String(artworkSummary.length),
      'Inside Neck Label': activeNeckMode === 'me-branding' ? 'Moments Etched Branding — $2 credit' : activeNeckMode === 'custom' ? 'Your Custom Branding' : 'Keep Original Tag',
      ...(activeNeckMode === 'me-branding' ? {
        '_ME Branding Credit Requested': '$2.00 per garment',
        '_ME Branding Credit Eligible': 'true'
      } : {}),
      '_ME Neck Label Mode': activeNeckMode,
      '_ME Design Group': designGroupId,
      '_ME Project Version': '6.0.19',
      ...artworkProperties
    };

    const baseItems = lines.flatMap(({ variant, size, quantity }) =>
      chunkCartItem({
        id: Number(variant.id),
        quantity,
        properties: {
          ...sharedProperties,
          'Garment Size': size,
          '_ME Line Type': 'garment',
          '_ME Size Quantity': String(quantity)
        }
      }, `Garment ${size}`)
    );

    const paidPlacements = placements.filter((placement) => Number(placementData[placement]?.priceCents || 0) > 0);
    const missingAddOn = paidPlacements.find((placement) => !Number(placementData[placement]?.variantId));
    if (missingAddOn) throw new Error(`${missingAddOn} is missing its Shopify add-on variant ID.`);

    const addOnItems = paidPlacements.flatMap((placement) =>
      chunkCartItem({
        id: Number(placementData[placement].variantId),
        quantity: totalQuantity,
        properties: {
          Customization: placement,
          'For Product': designer.dataset.meProductTitle,
          'Garment Color': color,
          'Size Distribution': distributionSummary,
          '_ME Design Group': designGroupId,
          '_ME Line Type': 'addon',
          '_ME Project Version': '6.0.19'
        }
      }, `Add-on ${placement}`)
    );

    const root = window.Shopify?.routes?.root || '/';
    const removedLines = await removeExistingProjectLines(designGroupId);

    if (removedLines && reviewSubmit) {
      const label = reviewSubmit.querySelector('span:first-child');
      if (label) label.textContent = 'Updating Project…';
    }
    const response = await fetch(`${root}cart/add.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [...baseItems, ...addOnItems] })
    });

    if (!response.ok) {
      const data = await response.json().catch(() => ({}));
      const details = data.description || data.message || data.errors;
      const message = typeof details === 'string'
        ? details
        : 'The multi-size project could not be added to cart. Check variant availability and try again.';
      throw new Error(
        response.status === 422 && /maximum quantity/i.test(message)
          ? `${message} Quantities above ${ME_CART_LINE_MAX} are split automatically; clear older test lines from the cart and try again.`
          : message
      );
    }

    window.location.assign(`${root}cart`);
  }


  // v7.6.3: create Shopify-hosted customer-approved mockups for single-size orders.
  // Multi-size orders already use the equivalent workflow in me-multisize-cart-rebuild.js.
  function meWaitForPreviewPaint() {
    return new Promise((resolve) => requestAnimationFrame(() => requestAnimationFrame(resolve)));
  }

  function meWaitForPreviewImage(image) {
    if (!image || (image.complete && image.naturalWidth)) return Promise.resolve();
    return new Promise((resolve) => {
      const done = () => resolve();
      image?.addEventListener?.('load', done, { once: true });
      image?.addEventListener?.('error', done, { once: true });
      setTimeout(done, 2500);
    });
  }

  async function meLocalizePreviewImage(sourceImage) {
    if (!sourceImage?.src) return null;
    try {
      const response = await fetch(sourceImage.currentSrc || sourceImage.src, {
        credentials: 'same-origin',
        cache: 'force-cache'
      });
      if (!response.ok) throw new Error(`Image fetch failed (${response.status})`);
      const blob = await response.blob();
      const objectUrl = URL.createObjectURL(blob);
      const image = new Image();
      image.decoding = 'async';
      image.src = objectUrl;
      await meWaitForPreviewImage(image);
      if (!image.naturalWidth) {
        URL.revokeObjectURL(objectUrl);
        return null;
      }
      return { image, objectUrl };
    } catch (error) {
      console.warn('[Moments v7.6.3] Preview image could not be localized.', error);
      return null;
    }
  }

  async function meCaptureSingleSizePreview(placement) {
    const stage = designer.querySelector('[data-me-preview-stage]');
    const productImage = designer.querySelector('[data-me-preview-product-image]');
    const artworkImage = designer.querySelector('[data-me-preview-artwork]');
    if (!stage || !productImage?.src) return null;

    await Promise.all([meWaitForPreviewImage(productImage), meWaitForPreviewImage(artworkImage)]);
    await meWaitForPreviewPaint();

    const stageRect = stage.getBoundingClientRect();
    if (!stageRect.width || !stageRect.height) return null;

    const localizedProduct = await meLocalizePreviewImage(productImage);
    const artworkVisible = artworkImage && !artworkImage.hidden && getComputedStyle(artworkImage).display !== 'none';
    const localizedArtwork = artworkVisible ? await meLocalizePreviewImage(artworkImage) : null;
    if (!localizedProduct) return null;

    const scale = Math.min(2, Math.max(1, 1200 / Math.max(stageRect.width, stageRect.height)));
    const canvas = document.createElement('canvas');
    canvas.width = Math.max(1, Math.round(stageRect.width * scale));
    canvas.height = Math.max(1, Math.round(stageRect.height * scale));
    const context = canvas.getContext('2d');
    if (!context) return null;

    context.fillStyle = '#ffffff';
    context.fillRect(0, 0, canvas.width, canvas.height);

    const drawLocalized = (localized, sourceElement) => {
      if (!localized?.image?.naturalWidth || !sourceElement) return;
      const rect = sourceElement.getBoundingClientRect();
      const x = (rect.left - stageRect.left) * scale;
      const y = (rect.top - stageRect.top) * scale;
      const width = rect.width * scale;
      const height = rect.height * scale;
      if (width > 0 && height > 0) context.drawImage(localized.image, x, y, width, height);
    };

    try {
      drawLocalized(localizedProduct, productImage);
      if (localizedArtwork) drawLocalized(localizedArtwork, artworkImage);
    } catch (error) {
      console.warn('[Moments v7.6.3] Single-size production preview could not be rendered.', error);
      return null;
    } finally {
      if (localizedProduct?.objectUrl) URL.revokeObjectURL(localizedProduct.objectUrl);
      if (localizedArtwork?.objectUrl) URL.revokeObjectURL(localizedArtwork.objectUrl);
    }

    const blob = await new Promise((resolve) => canvas.toBlob(resolve, 'image/png', 0.96));
    if (!blob) return null;
    const safePlacement = String(placement || 'Preview').replace(/[^a-z0-9]+/gi, '-').replace(/^-|-$/g, '') || 'Preview';
    return new File([blob], `ME-${safePlacement}-Production-Preview.png`, { type: 'image/png' });
  }

  async function meAppendSingleSizeProductionPreviews(formData, placements) {
    const cards = Array.from(designer.querySelectorAll('[data-me-navigator-placement]'));
    const activeCard = cards.find((card) => card.classList.contains('is-active') || card.getAttribute('aria-current') === 'true');

    for (const placement of placements) {
      const card = cards.find((candidate) => String(candidate.dataset.meNavigatorPlacement || '').trim() === placement);
      if (card) {
        card.click();
        await meWaitForPreviewPaint();
      }
      const file = await meCaptureSingleSizePreview(placement);
      if (file) formData.set(`properties[_Production Preview - ${placement}]`, file, file.name);
    }

    if (activeCard && !activeCard.classList.contains('is-active')) {
      activeCard.click();
      await meWaitForPreviewPaint();
    }
  }

  async function addToCart() {
    // v15.4.7.40 — defense-in-depth guard. No 21+ custom-apparel project may
    // enter Shopify cart mutation code, regardless of which submit path called
    // addToCart() (visible CTA, hidden review submit, form submit, or legacy UI).
    if (getQuantity() >= 21) {
      const quoteOpener = designer.querySelector(
        '[data-me-volume-bulk-cta] [data-me-quote-open], [data-me-quote-header], [data-me-quote-open]'
      );

      if (quoteOpener?.click) {
        quoteOpener.click();
      } else if (window.MomentsQuoteHandoff?.open) {
        window.MomentsQuoteHandoff.open(designer);
      } else {
        showReviewAlert('21+ custom apparel projects require a bulk quote. Please use Request Bulk Quote.');
      }
      return;
    }

    if (!validateDesignStep()) {
      setStep('design');
      return;
    }

    if (!validateArtworkStep()) {
      setStep('artwork');
      return;
    }

    if ((isMultiSizeMode() && getMultiSizeTotal() < 1) || (!isMultiSizeMode() && !getCurrentSize())) {
      setStep('review');
      const sizeMessageText = isMultiSizeMode()
        ? 'Enter at least one size quantity before adding the project.'
        : 'Select a garment size before adding the project.';
      if (cartStatus) cartStatus.textContent = sizeMessageText;
      sizePicker?.scrollIntoView({ behavior: 'smooth', block: 'center' });
      return;
    }

    setStep('review');

    if (!rightsCheckbox?.checked) {
      showReviewAlert(
        'Confirm the copyright and artwork authorization before adding this item to cart.'
      );

      const authorizationCard = designer.querySelector('[data-me-authorization-card]');
      authorizationCard?.classList.remove('is-attention');
      authorizationCard?.scrollIntoView({ behavior: 'smooth', block: 'center' });
      window.setTimeout(() => {
        authorizationCard?.classList.add('is-attention');
        rightsCheckbox?.focus({ preventScroll: true });
        window.setTimeout(() => authorizationCard?.classList.remove('is-attention'), 1800);
      }, 300);
      updateStepStates();
      return;
    }

    if (!window.MomentsCustomAgreement?.validate?.(designer, { focus: true, announce: true })) {
      showReviewAlert('Complete the required Custom Product Agreement before adding this item to cart.');
      return;
    }

    const placements = getSelectedPlacements();
    const quantity = getQuantity();
    const artworkSummary = getArtworkSummary();
    const designGroupId = createDesignGroupId();

    const paidPlacements = placements.filter(
      (placement) =>
        Number(
          placementData[placement]?.priceCents || 0
        ) > 0
    );

    const missingVariant = paidPlacements.find(
      (placement) =>
        !Number(
          placementData[placement]?.variantId
        )
    );

    if (missingVariant) {
      showReviewAlert(
        `${missingVariant} is missing its Shopify add-on variant ID.`
      );

      return;
    }

    clearReviewAlert();

    if (reviewSubmit) {
      reviewSubmit.disabled = true;

      const label = reviewSubmit.querySelector(
        'span:first-child'
      );

      if (label) {
        label.textContent = 'Adding to Cart…';
      }
    }

    if (primaryAction) {
      primaryAction.disabled = true;
    }

    let baseLineKey = '';

    try {
      if (isMultiSizeMode()) {
        await addMultiSizeProjectToCart({ placements, artworkSummary, designGroupId });
        return;
      }
      // The color/size controller writes the exact selected Shopify variant to
      // the hidden form field whenever either selection changes. Treat that
      // field as the source of truth at checkout. Re-resolving from product JSON
      // here caused valid selections to fail when the asynchronous color-product
      // state lagged behind the visible designer state.
      const activeVariantInput = productForm.querySelector('[data-me-variant-id]');
      if (!activeVariantInput) {
        throw new Error('The selected garment variant field is unavailable. Refresh the page and try again.');
      }

      let activeVariantId = Number.parseInt(String(activeVariantInput.value || ''), 10);

      // Defensive fallback for restored projects or unusually slow storefronts:
      // resolve from the currently loaded product only when the authoritative
      // hidden field is genuinely empty or invalid.
      if (!Number.isFinite(activeVariantId) || activeVariantId <= 0) {
        const activeProduct = readDesignerProductJson();
        const activeSize = getCurrentSize();
        const activeVariant = resolveVariantBySize(activeProduct, activeSize);
        activeVariantId = Number(activeVariant?.id || 0);
      }

      if (!Number.isFinite(activeVariantId) || activeVariantId <= 0) {
        throw new Error('The selected garment color and size could not be confirmed. Reselect the size, then try again.');
      }

      activeVariantInput.value = String(activeVariantId);

      const baseFormData = new FormData(productForm);
      const activeNeckMode = getNeckLabelChoice();
      baseFormData.set('properties[Inside Neck Label]', activeNeckMode === 'me-branding' ? 'Moments Etched Branding — $2 credit' : activeNeckMode === 'custom' ? 'Your Custom Branding' : 'Keep Original Tag');
      baseFormData.set('properties[_ME Neck Label Mode]', activeNeckMode);
      baseFormData.delete('properties[_ME Branding Credit Requested]');
      baseFormData.delete('properties[_ME Branding Credit Eligible]');
      if (activeNeckMode === 'me-branding') {
        baseFormData.set('properties[_ME Branding Credit Requested]', '$2.00 per garment');
        baseFormData.set('properties[_ME Branding Credit Eligible]', 'true');
      }
      baseFormData.set('id', String(activeVariantId));
      baseFormData.set('quantity', String(quantity));

      baseFormData.set(
        'properties[Garment Size]',
        getCurrentSize()
      );

      baseFormData.set(
        'properties[Garment Color]',
        getCurrentColor()
      );

      baseFormData.set(
        'properties[Selected Print Locations]',
        placements.join(', ')
      );

      baseFormData.set(
        'properties[_Artwork File Count]',
        String(artworkSummary.length)
      );

      baseFormData.set(
        'properties[_ME Design Group]',
        designGroupId
      );

      baseFormData.set(
        'properties[_ME Line Type]',
        'garment'
      );

      baseFormData.set(
        'properties[_ME Designer Version]',
        '2.0'
      );

      window.MEArtworkManager?.appendProperties(
        baseFormData
      );

      // Add the actual customer-approved decorated garment preview to the
      // Shopify line item. This keeps single-size and multi-size cart jobs
      // visually consistent and lets the cart lightbox/download tools work.
      await meAppendSingleSizeProductionPreviews(baseFormData, placements);

      const root =
        window.Shopify?.routes?.root || '/';

      if (designer.dataset.meEditingCartProject === 'true') {
        const removedLines = await removeExistingProjectLines(designGroupId);
        if (removedLines && reviewSubmit) {
          const updatingLabel = reviewSubmit.querySelector('span:first-child');
          if (updatingLabel) updatingLabel.textContent = 'Updating Project…';
        }
      }

      const baseResponse = await fetch(
        `${root}cart/add.js`,
        {
          method: 'POST',
          body: baseFormData,
          headers: {
            Accept: 'application/json'
          }
        }
      );

      if (!baseResponse.ok) {
        const responseData = await baseResponse
          .json()
          .catch(() => ({}));

        throw new Error(
          responseData.description ||
          'The personalized garment could not be added.'
        );
      }

      const baseItem = await baseResponse.json();
      baseLineKey = baseItem?.key || '';

      const addOnItems = paidPlacements.map(
        (placement) => ({
          id: Number(
            placementData[placement].variantId
          ),

          quantity,

          properties: {
            Customization: placement,

            'For Product':
              designer.dataset.meProductTitle,

            'Garment Color': getCurrentColor(),

            'Garment Size': getCurrentSize(),

            '_ME Design Group': designGroupId,

            '_ME Line Type': 'addon',

            '_ME Parent Line Key': baseLineKey,

            '_ME Parent Variant':
              productForm.querySelector(
                '[data-me-variant-id]'
              )?.value || ''
          }
        })
      );

      if (addOnItems.length) {
        const addOnResponse = await fetch(
          `${root}cart/add.js`,
          {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json'
            },
            body: JSON.stringify({
              items: addOnItems
            })
          }
        );

        if (!addOnResponse.ok) {
          const responseData = await addOnResponse
            .json()
            .catch(() => ({}));

          await rollbackBaseLine(baseLineKey);

          throw new Error(
            responseData.description ||
            'The paid customization add-ons could not be added.'
          );
        }
      }

      window.location.assign(`${root}cart`);
    } catch (error) {
      console.error('[Moments v6.0.19] Add personalized item failed.', error);
      const errorMessage = error?.message || 'Something went wrong while adding the order.';
      showReviewAlert(errorMessage);
      if (cartStatus) cartStatus.textContent = errorMessage;

      if (reviewSubmit) {
        reviewSubmit.disabled = false;

        const label = reviewSubmit.querySelector(
          'span:first-child'
        );

        if (label) {
          label.textContent =
            'Confirm & Add to Cart';
        }
      }

      updatePrimaryActionState();
    }
  }

  function handlePrimaryAction() {
    if (currentStep === 'design') {
      if (!validateDesignStep()) {
        return;
      }

      setStep('artwork');
      return;
    }

    if (currentStep === 'artwork') {
      if (!validateArtworkStep()) {
        return;
      }

      setStep('review');
      return;
    }

    if (getQuantity() >= 21) {
      const quoteOpener = designer.querySelector('[data-me-volume-bulk-cta] [data-me-quote-open], [data-me-quote-header], [data-me-quote-open]');
      if (quoteOpener?.click) quoteOpener.click();
      else window.MomentsQuoteHandoff?.open?.(designer);
      return;
    }

    addToCart();
  }

  designer.addEventListener('input', () => window.setTimeout(updateProjectIntelligence, 0));
  designer.addEventListener('change', () => window.setTimeout(updateProjectIntelligence, 0));

  openButton.addEventListener('click', openDesigner);

  closeButtons.forEach((button) => {
    button.addEventListener('click', closeDesigner);
  });

  stepButtons.forEach((button) => {
    button.addEventListener('click', () => {
      const targetStep = button.dataset.meStepButton;

      if (
        targetStep === 'artwork' &&
        !validateDesignStep()
      ) {
        return;
      }

      if (targetStep === 'review') {
        if (!validateDesignStep()) {
          return;
        }

        if (!validateArtworkStep()) {
          setStep('artwork');
          return;
        }
      }

      setStep(targetStep);
    });
  });

  placementInputs.forEach((input) => {
    input.addEventListener('change', () => {
      enforcePlacementConflicts(input);
    });
  });

  primaryAction?.addEventListener(
    'click',
    handlePrimaryAction
  );

  reviewSubmit?.addEventListener(
    'click',
    (event) => {
      event.preventDefault();
      addToCart();
    }
  );

  rightsCheckbox?.addEventListener(
    'change',
    () => {
      updateStepStates();
      updatePrimaryActionState();
      clearReviewAlert();
    }
  );

  quantityInput?.addEventListener(
    'input',
    () => {
      updatePricing();

      if (currentStep === 'review') {
        renderReview();
      }
    }
  );

  quantityInput?.addEventListener(
    'change',
    updatePricing
  );

  window.addEventListener(
    'me:designer-variant-changed',
    (event) => {
      const newPrice = Number(
        event.detail?.priceCents
      );

      if (Number.isFinite(newPrice)) {
        basePriceCents = newPrice;
      }

      updatePricing();
      updateStepStates();
      updatePrimaryActionState();
    }
  );

  window.addEventListener(
    'me:variant-selection-state',
    () => {
      updateStepStates();
      updatePrimaryActionState();

      if (currentStep === 'review') {
        renderReview();
      }
    }
  );

  window.addEventListener(
    'me:designer-color-changed',
    () => {
      updateStepStates();
      updatePrimaryActionState();
    }
  );

  document.addEventListener(
    'me:project:update',
    () => {
      updatePricing();
      updateStepStates();
      updatePrimaryActionState();

      if (currentStep === 'review') {
        renderReview();
      }
    }
  );

  window.addEventListener(
    'me:artwork-updated',
    (event) => {
      (event.detail?.assignments || []).forEach((assignment) => {
        if (['Back Name', 'Back Number', 'Back Name + Number'].includes(assignment?.placement)) {
          dynamicPlacementPrices.set(assignment.placement, Number(assignment.priceCents || 600));
        }
      });
      updatePricing();
      updateStepStates();
      updatePrimaryActionState();

      if (currentStep === 'review') {
        renderReview();
      }
    }
  );

  productForm.addEventListener(
    'submit',
    (event) => {
      event.preventDefault();

      if (currentStep !== 'review') {
        handlePrimaryAction();
        return;
      }

      addToCart();
    }
  );

  document.addEventListener(
    'keydown',
    (event) => {
      if (
        event.key === 'Escape' &&
        designer.classList.contains('is-open')
      ) {
        closeDesigner();
      }
    }
  );

  removeDuplicatePreviewPrompts();
  updatePlacementCards();
  updatePlacementState();
  updatePricing();
  setStep('design');
  window.setTimeout(updateProjectIntelligence, 0);
});
/* ===== END assets/me-product-designer.js ===== */


/* ===== BEGIN assets/me-save-design.js ===== */
document.addEventListener('DOMContentLoaded', () => {
  'use strict';

  const designer = document.querySelector(
    '[data-me-designer]'
  );

  if (!designer) {
    return;
  }

  const designerOpenButton = document.querySelector(
    '[data-me-designer-open]'
  );

  const saveButton = designer.querySelector(
    '[data-me-save-design]'
  );

  const restoreButton = designer.querySelector(
    '[data-me-restore-design]'
  );

  const deleteButton = designer.querySelector(
    '[data-me-delete-design]'
  );

  const authModal = designer.querySelector(
    '[data-me-save-auth-modal]'
  );

  const authModalCloseButtons = designer.querySelectorAll(
    '[data-me-save-auth-close]'
  );

  const authContinueButton = designer.querySelector(
    '[data-me-save-auth-continue]'
  );

  const status = designer.querySelector(
    '[data-me-save-design-status]'
  );

  const headerStatus = designer.querySelector(
    '[data-me-header-save-status]'
  );

  const customerId = String(
    designer.dataset.meCustomerId || ''
  );

  const productHandle = String(
    designer.dataset.meProductHandle || ''
  );

  const loginPath = String(
    designer.dataset.meLoginPath ||
    '/customer_authentication/login'
  );

  const customerStorageKey =
    customerId && productHandle
      ? `me-design:${customerId}:${productHandle}`
      : '';

  const pendingStorageKey =
    `me-design:pending:${productHandle}`;

  const restoreNoticeSessionKey =
    `me-design:restore-notice:${productHandle}`;

  let mainStatusTimer = null;
  let headerStatusTimer = null;

  function escapeHtml(value) {
    return String(value || '')
      .replaceAll('&', '&amp;')
      .replaceAll('<', '&lt;')
      .replaceAll('>', '&gt;')
      .replaceAll('"', '&quot;')
      .replaceAll("'", '&#039;');
  }

  function hideMainStatus() {
    if (!status) {
      return;
    }

    window.clearTimeout(mainStatusTimer);
    mainStatusTimer = null;

    status.hidden = true;
    status.classList.remove(
      'is-success',
      'is-error',
      'is-warning'
    );

    status.innerHTML = '';
  }

  function hideHeaderStatus() {
    if (!headerStatus) {
      return;
    }

    window.clearTimeout(headerStatusTimer);
    headerStatusTimer = null;

    headerStatus.hidden = true;
    headerStatus.textContent = '';
  }

  function showStatus(
    message,
    type = 'success',
    options = {}
  ) {
    const {
      duration = 6000,
      showMain = true,
      showHeader = true
    } = options;

    if (showMain && status) {
      window.clearTimeout(mainStatusTimer);

      status.hidden = false;

      status.classList.remove(
        'is-success',
        'is-error',
        'is-warning'
      );

      status.classList.add(`is-${type}`);

      status.innerHTML = `
        <span
          class="me-save-design__status-message"
        >
          ${escapeHtml(message)}
        </span>

        <button
          type="button"
          class="me-save-design__status-close"
          data-me-save-status-close
          aria-label="Close notification"
          title="Close notification"
        >
          ×
        </button>
      `;

      const closeButton = status.querySelector(
        '[data-me-save-status-close]'
      );

      if (closeButton) {
        closeButton.style.cssText = `
          position: absolute;
          top: 7px;
          right: 8px;
          display: flex;
          width: 24px;
          height: 24px;
          align-items: center;
          justify-content: center;
          padding: 0;
          border: 0;
          border-radius: 999px;
          background: rgba(255, 255, 255, 0.66);
          color: currentColor;
          font-family: Arial, sans-serif;
          font-size: 18px;
          line-height: 1;
          cursor: pointer;
        `;

        closeButton.addEventListener(
          'click',
          hideMainStatus
        );
      }

      status.style.position = 'absolute';
      status.style.paddingRight = '42px';

      if (duration > 0) {
        mainStatusTimer = window.setTimeout(
          hideMainStatus,
          duration
        );
      }
    }

    if (showHeader && headerStatus) {
      window.clearTimeout(headerStatusTimer);

      headerStatus.textContent = message;
      headerStatus.hidden = false;

      if (duration > 0) {
        headerStatusTimer = window.setTimeout(
          hideHeaderStatus,
          Math.min(duration, 5000)
        );
      }
    }
  }

  function getSelectedColor() {
    const label = designer.querySelector(
      '[data-me-selected-color]'
    );

    return String(
      label?.textContent || ''
    )
      .replace(/^Selected:\s*/i, '')
      .trim();
  }

  function getSelectedSize() {
    return String(
      designer.querySelector(
        '[data-me-size-property]'
      )?.value || ''
    ).trim();
  }

  function getQuantity() {
    const value = Number.parseInt(
      designer.querySelector(
        '[data-me-quantity-input]'
      )?.value || '1',
      10
    );

    return Number.isFinite(value) && value > 0
      ? value
      : 1;
  }

  function getPlacements() {
    return Array.from(
      designer.querySelectorAll(
        '[data-me-placement-checkbox]:checked'
      )
    ).map((input) => input.value);
  }

  function getNotes() {
    return (
      designer.querySelector(
        '#me-product-notes'
      )?.value || ''
    );
  }

  function getProofPreference() {
    const proof =
      designer.querySelector(
        '[data-me-proof-checkbox]'
      ) ||
      designer.querySelector(
        'input[name="properties[Digital Proof Requested]"]'
      );

    return Boolean(proof?.checked);
  }

  function getNeckLabelChoice() {
    return String(
      designer.querySelector('[data-me-neck-label-choice]:checked')?.value || 'original'
    );
  }

  function getBrandingCreditCents() {
    return getNeckLabelChoice() === 'me-branding'
      ? Math.max(0, Number(designer.dataset.meBrandingCreditCents || 200))
      : 0;
  }

  function getBackName() {
    return (
      designer.querySelector(
        '[data-me-back-name]'
      )?.value ||
      designer.querySelector(
        'input[name="properties[Back Name]"]'
      )?.value ||
      ''
    );
  }

  function getBackNumber() {
    return (
      designer.querySelector(
        '[data-me-back-number]'
      )?.value ||
      designer.querySelector(
        'input[name="properties[Back Number]"]'
      )?.value ||
      ''
    );
  }

  function getArtworkSummary() {
    return (
      window.MEArtworkManager
        ?.getSummary?.() || []
    ).map((assignment) => ({
      placement:
        assignment.placement || '',

      type:
        assignment.type || '',

      summary:
        assignment.summary || ''
    }));
  }

  function collectDraft() {
    return {
      version: 2,
      savedAt: new Date().toISOString(),

      product: {
        title:
          designer.dataset.meProductTitle || '',

        handle: productHandle,

        variantId:
          document.querySelector(
            '[data-me-variant-id]'
          )?.value || ''
      },

      selections: {
        color: getSelectedColor(),
        size: getSelectedSize(),
        quantity: getQuantity(),
        placements: getPlacements()
      },

      customization: {
        notes: getNotes(),

        proofRequested:
          getProofPreference(),

        backName:
          getBackName(),

        backNumber:
          getBackNumber()
      },

      artworkSummary:
        getArtworkSummary()
    };
  }

  function writeDraft(key, draft) {
    if (!key) {
      return false;
    }

    localStorage.setItem(
      key,
      JSON.stringify(draft)
    );

    return true;
  }

  function readDraft(key) {
    if (!key) {
      return null;
    }

    try {
      const stored =
        localStorage.getItem(key);

      return stored
        ? JSON.parse(stored)
        : null;
    } catch (error) {
      console.error(
        'Unable to read saved design.',
        error
      );

      return null;
    }
  }

  function removeDraft(key) {
    if (!key) {
      return;
    }

    localStorage.removeItem(key);
  }

  function openAuthModal() {
    if (!authModal) {
      return;
    }

    authModal.hidden = false;

    window.requestAnimationFrame(() => {
      authModal.classList.add('is-open');
      authContinueButton?.focus();
    });
  }

  function closeAuthModal() {
    if (!authModal) {
      return;
    }

    authModal.classList.remove('is-open');

    window.setTimeout(() => {
      authModal.hidden = true;
    }, 180);
  }

  function saveLoggedInDesign() {
    if (!customerStorageKey) {
      return;
    }

    try {
      writeDraft(
        customerStorageKey,
        collectDraft()
      );

      updateControls();

      showStatus(
        'Design saved. Artwork files will still need to be re-uploaded until the permanent artwork library is connected.',
        'success'
      );

      saveButton?.classList.add('is-saved');

      const label = saveButton?.querySelector(
        '[data-me-save-button-label]'
      );

      if (label) {
        label.textContent = 'Saved';
      }
    } catch (error) {
      console.error(
        'Unable to save design.',
        error
      );

      showStatus(
        'This design could not be saved. Check your browser storage settings and try again.',
        'error'
      );
    }
  }

  function handleSaveClick() {
    if (customerId) {
      saveLoggedInDesign();
      return;
    }

    openAuthModal();
  }

  function continueToLogin() {
    try {
      writeDraft(
        pendingStorageKey,
        collectDraft()
      );

      sessionStorage.setItem(
        `me-design:return:${productHandle}`,
        '1'
      );

      sessionStorage.removeItem(
        restoreNoticeSessionKey
      );
    } catch (error) {
      console.warn(
        'Unable to preserve pending design.',
        error
      );
    }

    const currentUrl = new URL(
      window.location.href
    );

    currentUrl.searchParams.set(
      'me_restore',
      '1'
    );

    const returnPath =
      `${currentUrl.pathname}` +
      `${currentUrl.search}`;

    const loginUrl =
      `${loginPath}?return_to=${encodeURIComponent(returnPath)}`;

    window.location.assign(loginUrl);
  }

  function clickMatchingColor(colorName) {
    if (!colorName) {
      return;
    }

    const colorButton = Array.from(
      designer.querySelectorAll(
        '[data-me-designer-color]'
      )
    ).find((button) => {
      return String(
        button.dataset.colorName || ''
      ).toLowerCase() ===
        colorName.toLowerCase();
    });

    colorButton?.click();
  }

  function clickMatchingSize(sizeValue) {
    if (!sizeValue) {
      return false;
    }

    const sizeButton = Array.from(
      designer.querySelectorAll(
        '[data-me-size-button]'
      )
    ).find((button) => {
      return String(
        button.dataset.sizeValue || ''
      ).toLowerCase() ===
        sizeValue.toLowerCase();
    });

    if (!sizeButton || sizeButton.disabled) {
      return false;
    }

    sizeButton.click();
    return true;
  }

  function restorePlacements(placements) {
    const selected =
      Array.isArray(placements)
        ? placements
        : [];

    const inputs = Array.from(
      designer.querySelectorAll(
        '[data-me-placement-checkbox]'
      )
    );

    inputs.forEach((input) => {
      if (
        input.checked &&
        !selected.includes(input.value)
      ) {
        input.checked = false;

        input.dispatchEvent(
          new Event('change', {
            bubbles: true
          })
        );
      }
    });

    selected.forEach((placement) => {
      const input = inputs.find(
        (candidate) =>
          candidate.value === placement
      );

      if (!input || input.disabled) {
        return;
      }

      if (!input.checked) {
        input.checked = true;

        input.dispatchEvent(
          new Event('change', {
            bubbles: true
          })
        );
      }
    });
  }

  function restoreQuantity(quantity) {
    const input = designer.querySelector(
      '[data-me-quantity-input]'
    );

    if (!input) {
      return;
    }

    input.value = String(
      Math.max(
        1,
        Number(quantity) || 1
      )
    );

    input.dispatchEvent(
      new Event('input', {
        bubbles: true
      })
    );

    input.dispatchEvent(
      new Event('change', {
        bubbles: true
      })
    );
  }

  function restoreTextFields(draft) {
    const notes = designer.querySelector(
      '#me-product-notes'
    );

    if (notes) {
      notes.value =
        draft.customization?.notes || '';

      notes.dispatchEvent(
        new Event('input', {
          bubbles: true
        })
      );
    }

    const proof =
      designer.querySelector(
        '[data-me-proof-checkbox]'
      ) ||
      designer.querySelector(
        'input[name="properties[Digital Proof Requested]"]'
      );

    if (proof) {
      proof.checked = Boolean(
        draft.customization
          ?.proofRequested
      );

      proof.dispatchEvent(
        new Event('change', {
          bubbles: true
        })
      );
    }
  }

  function restoreNameNumber(draft) {
    const backName =
      draft.customization?.backName || '';

    const backNumber =
      draft.customization?.backNumber || '';

    const nameInput =
      designer.querySelector(
        '[data-me-back-name]'
      ) ||
      designer.querySelector(
        'input[name="properties[Back Name]"]'
      );

    const numberInput =
      designer.querySelector(
        '[data-me-back-number]'
      ) ||
      designer.querySelector(
        'input[name="properties[Back Number]"]'
      );

    if (nameInput) {
      nameInput.value = backName;

      nameInput.dispatchEvent(
        new Event('input', {
          bubbles: true
        })
      );
    }

    if (numberInput) {
      numberInput.value = backNumber;

      numberInput.dispatchEvent(
        new Event('input', {
          bubbles: true
        })
      );
    }
  }

  function restoreDraft(
    draft = null,
    options = {}
  ) {
    const {
      isPostLoginRestore = false
    } = options;

    const savedDraft =
      draft ||
      readDraft(customerStorageKey) ||
      readDraft(pendingStorageKey);

    if (!savedDraft) {
      showStatus(
        'No saved design was found for this product.',
        'warning'
      );

      return;
    }

    clickMatchingColor(
      savedDraft.selections?.color || ''
    );

    window.setTimeout(() => {
      const sizeRestored =
        clickMatchingSize(
          savedDraft.selections?.size || ''
        );

      restorePlacements(
        savedDraft.selections?.placements || []
      );

      restoreQuantity(
        savedDraft.selections?.quantity || 1
      );

      restoreTextFields(savedDraft);

      window.setTimeout(() => {
        restoreNameNumber(savedDraft);
      }, 300);

      let message =
        'Your saved design selections were restored. Please re-upload the artwork files before adding the item to cart.';

      if (
        savedDraft.selections?.size &&
        !sizeRestored
      ) {
        message +=
          ' The previously selected size is not currently available.';
      }

      const noticeAlreadyShown =
        sessionStorage.getItem(
          restoreNoticeSessionKey
        ) === '1';

      if (
        !isPostLoginRestore ||
        !noticeAlreadyShown
      ) {
        showStatus(
          message,
          'warning',
          {
            duration: 6000
          }
        );

        if (isPostLoginRestore) {
          sessionStorage.setItem(
            restoreNoticeSessionKey,
            '1'
          );
        }
      }

      updateControls();
    }, 900);
  }

  function deleteSavedDesign() {
    removeDraft(customerStorageKey);
    removeDraft(pendingStorageKey);

    sessionStorage.removeItem(
      restoreNoticeSessionKey
    );

    updateControls();

    showStatus(
      'Saved design removed.',
      'success'
    );
  }

  function updateControls() {
    const hasDraft = Boolean(
      readDraft(customerStorageKey) ||
      readDraft(pendingStorageKey)
    );

    if (restoreButton) {
      restoreButton.hidden = !hasDraft;
    }

    if (deleteButton) {
      deleteButton.hidden = !hasDraft;
    }
  }

  function removeRestoreParameter() {
    const url = new URL(
      window.location.href
    );

    if (!url.searchParams.has('me_restore')) {
      return;
    }

    url.searchParams.delete('me_restore');

    window.history.replaceState(
      {},
      '',
      `${url.pathname}${url.search}${url.hash}`
    );
  }

  function handlePostLoginReturn() {
    const params = new URLSearchParams(
      window.location.search
    );

    if (
      params.get('me_restore') !== '1'
    ) {
      return;
    }

    const pendingDraft =
      readDraft(pendingStorageKey);

    /*
     * Remove the restore flag immediately so a page reload
     * cannot trigger the restore workflow again.
     */
    removeRestoreParameter();

    if (
      customerId &&
      pendingDraft &&
      customerStorageKey
    ) {
      writeDraft(
        customerStorageKey,
        pendingDraft
      );

      removeDraft(pendingStorageKey);
    }

    window.setTimeout(() => {
      designerOpenButton?.click();

      window.setTimeout(() => {
        const draftToRestore =
          customerId
            ? readDraft(customerStorageKey)
            : pendingDraft;

        restoreDraft(
          draftToRestore,
          {
            isPostLoginRestore: true
          }
        );
      }, 800);
    }, 350);
  }

  saveButton?.addEventListener(
    'click',
    handleSaveClick
  );

  restoreButton?.addEventListener(
    'click',
    () => {
      restoreDraft(
        null,
        {
          isPostLoginRestore: false
        }
      );
    }
  );

  deleteButton?.addEventListener(
    'click',
    deleteSavedDesign
  );

  authModalCloseButtons.forEach((button) => {
    button.addEventListener(
      'click',
      closeAuthModal
    );
  });

  authContinueButton?.addEventListener(
    'click',
    continueToLogin
  );

  document.addEventListener(
    'keydown',
    (event) => {
      if (
        event.key === 'Escape' &&
        authModal &&
        !authModal.hidden
      ) {
        closeAuthModal();
      }

      if (
        event.key === 'Escape' &&
        status &&
        !status.hidden
      ) {
        hideMainStatus();
      }
    }
  );

  updateControls();
  handlePostLoginReturn();
});
/* ===== END assets/me-save-design.js ===== */


/* =========================================================
   ME Designer v2 — validation icon enhancer
========================================================= */
document.addEventListener('DOMContentLoaded', () => {
  'use strict';

  const icons = {
    check: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 12.5 9.2 17 19 7"></path></svg>',
    image: '<svg viewBox="0 0 24 24" aria-hidden="true"><rect x="3" y="4" width="18" height="16" rx="2"></rect><circle cx="8.5" cy="9" r="1.5"></circle><path d="m4 17 5-5 4 4 3-3 4 4"></path></svg>',
    transparent: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 3v3M12 18v3M3 12h3M18 12h3"></path><path d="m5.6 5.6 2.1 2.1M16.3 16.3l2.1 2.1M18.4 5.6l-2.1 2.1M7.7 16.3l-2.1 2.1"></path><circle cx="12" cy="12" r="3.5"></circle></svg>',
    ruler: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 16 16 4l4 4L8 20H4v-4Z"></path><path d="m13 7 4 4M10 10l2 2M7 13l2 2"></path></svg>',
    warning: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 4 21 20H3L12 4Z"></path><path d="M12 9v5M12 17.5h.01"></path></svg>',
    star: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="m12 3 2.7 5.5 6.1.9-4.4 4.3 1 6.1-5.4-2.9-5.4 2.9 1-6.1-4.4-4.3 6.1-.9L12 3Z"></path></svg>'
  };

  function classify(text) {
    const value = String(text || '').toLowerCase().replace(/\\s+/g, ' ').trim();
    if (!value) return null;
    if (value === 'png' || value.includes('png file')) return { icon: 'image', state: 'success' };
    if (value.includes('transparent')) return { icon: 'transparent', state: 'success' };
    if (value.includes('background found') || value.includes('background detected')) return { icon: 'warning', state: 'warning' };
    const dpiMatch = value.match(/(\\d+)\\s*(?:effective\\s*)?dpi/);
    if (dpiMatch) {
      const dpi = Number(dpiMatch[1]);
      return { icon: dpi >= 250 ? 'ruler' : 'warning', state: dpi >= 250 ? 'success' : dpi >= 150 ? 'warning' : 'error' };
    }
    if (value.includes('excellent print quality') || value.includes('very good for this placement')) return { icon: 'star', state: 'success', quality: true };
    if (value.includes('review required')) return { icon: 'warning', state: 'error', quality: true };
    return null;
  }

  function enhance(element) {
    if (!(element instanceof HTMLElement) || element.dataset.meV2Icon === 'true') return;
    if (element.children.length > 0) return;
    const result = classify(element.textContent);
    if (!result) return;
    element.dataset.meV2Icon = 'true';
    element.classList.add('me-v2-validation-chip', `is-${result.state}`);
    if (result.quality) element.classList.add('is-quality');
    const icon = document.createElement('span');
    icon.className = 'me-v2-validation-chip__icon';
    icon.setAttribute('aria-hidden', 'true');
    icon.innerHTML = icons[result.icon];
    element.prepend(icon);
  }

  function scan(root = document) {
    const selectors = [
      '.me-location-artwork__quality-row',
      '.me-location-artwork__summary',
      '.me-artwork-validation__text',
      '.me-artwork-validation__summary',
      '.me-print-quality__score strong'
    ].join(',');
    if (root instanceof Element && root.matches(selectors)) enhance(root);
    root.querySelectorAll?.(selectors).forEach(enhance);
  }

  scan();
  new MutationObserver((mutations) => {
    mutations.forEach((mutation) => mutation.addedNodes.forEach((node) => {
      if (node instanceof Element) scan(node);
    }));
  }).observe(document.body, { childList: true, subtree: true });
});


/* ===== BEGIN Moments Etched v3.7.0 bulk quote workflow ===== */
document.addEventListener('DOMContentLoaded', () => {
  'use strict';

  const designer = document.querySelector('[data-me-designer]');
  if (!designer) return;

  const modal = designer.querySelector('[data-me-quote-modal]');
  if (!modal) return;

  const openers = Array.from(designer.querySelectorAll('[data-me-quote-open]'));
  const closers = Array.from(modal.querySelectorAll('[data-me-quote-close]'));
  const formView = modal.querySelector('[data-me-quote-form-view]');
  const successView = modal.querySelector('[data-me-quote-success]');
  const summaryEl = modal.querySelector('[data-me-quote-summary]');
  const submitButton = modal.querySelector('[data-me-quote-submit]');
  const statusEl = modal.querySelector('[data-me-quote-status]');
  const referenceEl = modal.querySelector('[data-me-quote-reference]');

  const fields = {
    name: modal.querySelector('[data-me-quote-name]'),
    company: modal.querySelector('[data-me-quote-company]'),
    email: modal.querySelector('[data-me-quote-email]'),
    phone: modal.querySelector('[data-me-quote-phone]'),
    neededBy: modal.querySelector('[data-me-quote-needed-by]'),
    quantity: modal.querySelector('[data-me-quote-quantity]'),
    notes: modal.querySelector('[data-me-quote-notes]'),
    consent: modal.querySelector('[data-me-quote-consent]'),
    website: modal.querySelector('[data-me-quote-website]'),
    organizationWrap: modal.querySelector('[data-me-quote-organization-wrap]'),
    role: modal.querySelector('[data-me-quote-role]'),
    organizationType: modal.querySelector('[data-me-quote-organization-type]'),
    taxStatuses: Array.from(modal.querySelectorAll('[data-me-quote-tax-status]')),
    taxDocuments: modal.querySelector('[data-me-quote-tax-documents]'),
    certificateType: modal.querySelector('[data-me-quote-certificate-type]'),
    taxFile: modal.querySelector('[data-me-quote-tax-file]'),
    taxFileStatus: modal.querySelector('[data-me-quote-tax-file-status]')
  };

  let lastFocused = null;
  let latestManifest = null;
  let quoteOpenedAt = 0;

  const text = (selector) => String(designer.querySelector(selector)?.textContent || '').trim();
  const value = (selector) => String(designer.querySelector(selector)?.value || '').trim();
  const moneyText = (selector) => text(selector) || 'Not available';

  function escapeHtml(input) {
    return String(input ?? '')
      .replaceAll('&', '&amp;')
      .replaceAll('<', '&lt;')
      .replaceAll('>', '&gt;')
      .replaceAll('"', '&quot;')
      .replaceAll("'", '&#039;');
  }

  function quoteReference() {
    const now = new Date();
    const date = [now.getFullYear(), String(now.getMonth() + 1).padStart(2, '0'), String(now.getDate()).padStart(2, '0')].join('');
    const random = Math.random().toString(36).slice(2, 7).toUpperCase();
    return `MEQ-${date}-${random}`;
  }

  function getSizeBreakdown() {
    return Array.from(designer.querySelectorAll('[data-me-size-quantity]')).map((input) => ({
      size: String(input.dataset.meSizeValue || input.closest('[data-me-distribution-row]')?.querySelector('[data-me-size-label]')?.textContent || '').trim(),
      quantity: Math.max(0, Number.parseInt(input.value || '0', 10) || 0)
    })).filter((row) => row.quantity > 0);
  }

  function getQuantity() {
    const sizeBreakdown = getSizeBreakdown();
    const matrixQuantity = sizeBreakdown.reduce((sum, row) => sum + row.quantity, 0);
    if (matrixQuantity > 0) return matrixQuantity;
    const quantity = Number.parseInt(value('[data-me-quantity-input]') || '1', 10);
    return Number.isFinite(quantity) && quantity > 0 ? quantity : 1;
  }

  function getPlacements() {
    return Array.from(designer.querySelectorAll('[data-me-placement-checkbox]:checked')).map((input) => input.value);
  }

  function getArtwork() {
    const summary = window.MEArtworkManager?.getSummary?.() || [];
    const placements = new Set(getPlacements());
    return summary.filter((item) => placements.has(item.placement)).map((item) => ({
      placement: item.placement || '',
      type: item.type || '',
      summary: typeof item.summary === 'string' ? item.summary : JSON.stringify(item.summary || {}),
      priceCents: Number(item.priceCents || 0)
    }));
  }

  function getNameNumber() {
    const nameInput = designer.querySelector('[data-me-back-name]');
    const numberInput = designer.querySelector('[data-me-back-number]');
    const nameToggle = designer.querySelector('[data-me-name-toggle]');
    const numberToggle = designer.querySelector('[data-me-number-toggle]');
    return {
      includeName: Boolean(nameToggle?.checked),
      includeNumber: Boolean(numberToggle?.checked),
      name: String(nameInput?.value || '').trim(),
      number: String(numberInput?.value || '').trim(),
      font: value('[data-me-name-number-font]'),
      printSize: value('[data-me-name-number-size]'),
      textColor: value('[data-me-name-number-color]')
    };
  }

  function buildManifest({ includeCustomer = false } = {}) {
    const color = text('[data-me-selected-color]').replace(/^Selected:\s*/i, '') || 'Not selected';
    const quantity = getQuantity();
    const manifest = {
      schemaVersion: '1.0',
      quoteReference: latestManifest?.quoteReference || quoteReference(),
      submittedAt: new Date().toISOString(),
      status: 'Quote requested',
      responseWindow: '24–48 business hours',
      product: {
        title: designer.dataset.meProductTitle || document.title,
        handle: designer.dataset.meProductHandle || '',
        variantId: value('[data-me-variant-id]'),
        color,
        size: value('[data-me-size-property]') || 'Mixed / see size breakdown',
        sizeBreakdown: getSizeBreakdown(),
        quantity
      },
      pricingEstimate: {
        unitPrice: moneyText('[data-me-price-unit]'),
        estimatedTotal: moneyText('[data-me-price-total]'),
        discount: quantity >= 21 ? 'Custom bulk pricing pending review' : value('[data-me-volume-discount-property]') || 'None'
      },
      placements: getPlacements(),
      artwork: getArtwork(),
      nameAndNumber: getNameNumber(),
      personalizationNotes: String(designer.querySelector('#me-product-notes')?.value || '').trim(),
      proofRequested: Boolean(designer.querySelector('[data-me-proof-checkbox]')?.checked),
      artworkAuthorization: Boolean(designer.querySelector('[data-me-rights-checkbox]')?.checked),
      sourceUrl: window.location.href
    };

    if (includeCustomer) {
      manifest.customer = {
        name: fields.name.value.trim(),
        company: fields.company.value.trim(),
        email: fields.email.value.trim(),
        phone: fields.phone.value.trim(),
        neededBy: fields.neededBy.value,
        notes: fields.notes.value.trim(),
        role: fields.role?.value || '',
        organizationType: fields.organizationType?.value || '',
        taxExemptRequested: fields.taxStatuses?.some((input) => input.checked && input.value === 'exempt') || false,
        taxExemptStatus: fields.taxStatuses?.some((input) => input.checked && input.value === 'exempt') ? 'Pending verification' : 'Not requested',
        certificateType: fields.certificateType?.value || '',
        certificateFileName: fields.taxFile?.files?.[0]?.name || '',
        certificateFileSize: fields.taxFile?.files?.[0]?.size || 0
      };
      manifest.product.quantity = Number.parseInt(fields.quantity.value || String(quantity), 10) || quantity;
    }

    return manifest;
  }

  function renderSummary() {
    latestManifest = buildManifest();
    fields.quantity.value = String(Math.max(21, latestManifest.product.quantity));
    summaryEl.innerHTML = `
      <div><span>Product</span><strong>${escapeHtml(latestManifest.product.title)}</strong></div>
      <div><span>Color</span><strong>${escapeHtml(latestManifest.product.color)}</strong></div>
      <div><span>Size breakdown</span><strong>${escapeHtml(latestManifest.product.sizeBreakdown?.length ? latestManifest.product.sizeBreakdown.map((row) => `${row.size}: ${row.quantity}`).join(' · ') : latestManifest.product.size)}</strong></div>
      <div><span>Quantity</span><strong>${escapeHtml(fields.quantity.value)} shirts</strong></div>
      <div><span>Print locations</span><strong>${escapeHtml(latestManifest.placements.join(', ') || 'Not selected')}</strong></div>
      <div><span>Artwork</span><strong>${latestManifest.artwork.length} file${latestManifest.artwork.length === 1 ? '' : 's'} listed</strong></div>
      <div><span>Pre-tax estimate</span><strong>${escapeHtml(latestManifest.pricingEstimate.estimatedTotal)}</strong></div>
    `;
  }

  function openModal(event) {
    event?.preventDefault?.();

    const activeStep = designer.dataset.meCurrentStep || 'design';
    const artworkCount = getArtwork().length;
    if (activeStep !== 'review' || artworkCount === 0) {
      const message = activeStep !== 'review'
        ? 'Finish the Design and Artwork steps before requesting a quote so all selections and files are included.'
        : 'Upload the required artwork before requesting a quote.';
      const cartStatus = designer.querySelector('[data-me-designer-cart-status]');
      if (cartStatus) cartStatus.textContent = message;
      designer.querySelector('[data-me-designer-primary-action]')?.focus?.();
      return;
    }

    lastFocused = document.activeElement;
    renderSummary();
    quoteOpenedAt = Date.now();
    if (fields.website) fields.website.value = '';
    formView.hidden = false;
    successView.hidden = true;
    statusEl.textContent = '';
    modal.hidden = false;
    document.documentElement.style.overflow = 'hidden';
    window.setTimeout(() => fields.name.focus(), 30);
  }

  function closeModal() {
    modal.hidden = true;
    document.documentElement.style.overflow = '';
    lastFocused?.focus?.();
  }

  function validate() {
    statusEl.textContent = '';
    if (fields.website?.value.trim()) return 'We could not submit this request.';
    if (quoteOpenedAt && Date.now() - quoteOpenedAt < 3000) return 'Please review your quote details before submitting.';
    if (!fields.name.value.trim()) return 'Enter your name.';
    if (!fields.email.validity.valid || !fields.email.value.trim()) return 'Enter a valid email address.';
    if (!fields.phone.value.trim()) return 'Enter a phone number.';
    const hasCompany = Boolean(fields.company.value.trim());
    const taxExemptRequested = fields.taxStatuses?.some((input) => input.checked && input.value === 'exempt');
    if (hasCompany && !fields.role?.value) return 'Select your role for the organization.';
    if (hasCompany && !fields.organizationType?.value) return 'Select the organization type.';
    if (taxExemptRequested && !hasCompany) return 'Enter the company or organization requesting tax-exempt status.';
    if (taxExemptRequested && !fields.certificateType?.value) return 'Select the certificate type for tax-exempt pricing.';
    if (fields.taxFile?.files?.[0]?.size > 20 * 1024 * 1024) return 'The certificate document must be 20 MB or smaller.';
    const quantity = Number.parseInt(fields.quantity.value || '0', 10);
    if (!Number.isFinite(quantity) || quantity < 21) return 'Custom apparel quote requests require an estimated quantity of 21 or more shirts.';
    if (!fields.consent.checked) return 'Confirm that you understand this is a quote request.';
    return '';
  }

  function plainTextSummary(manifest) {
    const artworkLines = manifest.artwork.length
      ? manifest.artwork.map((item) => `- ${item.placement}: ${item.summary || 'Artwork assigned'}`).join('\n')
      : '- No artwork filenames available';
    const nn = manifest.nameAndNumber;
    return [
      `BULK QUOTE REQUEST ${manifest.quoteReference}`,
      '',
      `Customer: ${manifest.customer.name}`,
      `Company/Organization: ${manifest.customer.company || 'Not provided'}`,
      `Role: ${manifest.customer.role || 'Not provided'}`,
      `Organization Type: ${manifest.customer.organizationType || 'Not provided'}`,
      `Email: ${manifest.customer.email}`,
      `Phone: ${manifest.customer.phone || 'Not provided'}`,
      `Needed By: ${manifest.customer.neededBy || 'Not provided'}`,
      `Tax Exemption Requested: ${manifest.customer.taxExemptRequested ? 'Yes — pending verification' : 'No'}`,
      `Certificate Type: ${manifest.customer.certificateType || 'Not provided'}`,
      `Certificate File Selected: ${manifest.customer.certificateFileName || 'No file selected'}`,
      '',
      `Product: ${manifest.product.title}`,
      `Color: ${manifest.product.color}`,
      `Size: ${manifest.product.size}`,
      `Size Breakdown: ${manifest.product.sizeBreakdown?.length ? manifest.product.sizeBreakdown.map((row) => `${row.size}: ${row.quantity}`).join(', ') : 'Not provided'}`,
      `Estimated Quantity: ${manifest.product.quantity}`,
      `Print Locations: ${manifest.placements.join(', ') || 'Not selected'}`,
      `Current Designer Estimate: ${manifest.pricingEstimate.estimatedTotal}`,
      `Discount Display: ${manifest.pricingEstimate.discount}`,
      '',
      'Artwork / customization:',
      artworkLines,
      `Back Name: ${nn.includeName ? nn.name || 'Enabled, text not entered' : 'Not included'}`,
      `Back Number: ${nn.includeNumber ? nn.number || 'Enabled, number not entered' : 'Not included'}`,
      `Name/Number Font: ${nn.font || 'Not selected'}`,
      `Name/Number Size: ${nn.printSize || 'Not selected'}`,
      `Name/Number Color: ${nn.textColor || 'Not selected'}`,
      '',
      `Designer Notes: ${manifest.personalizationNotes || 'None'}`,
      `Quote Form Notes: ${manifest.customer.notes || 'None'}`,
      `Digital Proof Requested: ${manifest.proofRequested ? 'Yes' : 'No'}`,
      `Artwork Authorization Confirmed: ${manifest.artworkAuthorization ? 'Yes' : 'No'}`,
      `Source: ${manifest.sourceUrl}`,
      '',
      'Expected response: 24–48 business hours.'
    ].join('\n');
  }

  async function submitQuote() {
    const error = validate();
    if (error) {
      statusEl.textContent = error;
      statusEl.setAttribute('role', 'alert');
      const fieldMap = [
        [/name/i, fields.name],
        [/email/i, fields.email],
        [/phone/i, fields.phone],
        [/role/i, fields.role],
        [/organization type/i, fields.organizationType],
        [/company|organization requesting/i, fields.company],
        [/certificate type/i, fields.certificateType],
        [/certificate document/i, fields.taxFile],
        [/quantity|31 or more/i, fields.quantity],
        [/confirm/i, fields.consent]
      ];
      Object.values(fields).flat?.().forEach?.((field) => field?.removeAttribute?.('aria-invalid'));
      const invalidField = fieldMap.find(([pattern, field]) => field && pattern.test(error))?.[1];
      if (invalidField) {
        invalidField.setAttribute('aria-invalid', 'true');
        invalidField.focus({ preventScroll: true });
        invalidField.scrollIntoView({ block: 'center' });
      } else {
        statusEl.setAttribute('tabindex', '-1');
        statusEl.focus({ preventScroll: true });
      }
      return;
    }

    submitButton.disabled = true;
    submitButton.querySelector('span:first-child').textContent = 'Submitting…';
    statusEl.textContent = '';

    latestManifest = buildManifest({ includeCustomer: true });
    const body = plainTextSummary(latestManifest);
    const formData = new FormData();
    formData.set('form_type', 'contact');
    formData.set('utf8', '✓');
    formData.set('contact[name]', latestManifest.customer.name);
    formData.set('contact[email]', latestManifest.customer.email);
    formData.set('contact[phone]', latestManifest.customer.phone);
    formData.set('contact[company]', latestManifest.customer.company);
    formData.set('contact[role]', latestManifest.customer.role);
    formData.set('contact[organization_type]', latestManifest.customer.organizationType);
    formData.set('contact[quote_reference]', latestManifest.quoteReference);
    formData.set('contact[estimated_quantity]', String(latestManifest.product.quantity));
    formData.set('contact[needed_by]', latestManifest.customer.neededBy);
    formData.set('contact[tax_exempt_requested]', latestManifest.customer.taxExemptRequested ? 'Yes — pending verification' : 'No');
    formData.set('contact[certificate_type]', latestManifest.customer.certificateType);
    formData.set('contact[certificate_file_name]', latestManifest.customer.certificateFileName);
    formData.set('contact[subject]', `New Bulk Quote Request — ${latestManifest.quoteReference}`);
    formData.set('contact[body]', body);

    try {
      const response = await fetch('/contact', {
        method: 'POST',
        body: formData,
        credentials: 'same-origin',
        headers: { Accept: 'text/html' }
      });
      if (response.redirected && /\/challenge(?:\?|$)/i.test(response.url)) {
        window.open(response.url, '_blank', 'noopener');
        throw new Error('Shopify verification required. Complete the verification tab, then submit again.');
      }
      if (!response.ok) throw new Error(`Contact request failed (${response.status})`);

      try {
        localStorage.setItem(`me-bulk-quote:${latestManifest.quoteReference}`, JSON.stringify(latestManifest));
      } catch (_) {}

      referenceEl.textContent = latestManifest.quoteReference;
      formView.hidden = true;
      successView.hidden = false;
      successView.querySelector('button')?.focus();
    } catch (err) {
      console.error('[ME Quote]', err);
      statusEl.textContent = /verification required/i.test(String(err?.message || ''))
        ? 'Shopify requested a human verification. Complete the verification tab, then submit again.'
        : 'We could not submit the quote request. Please try again or use the Business Services contact page.';
    } finally {
      submitButton.disabled = false;
      submitButton.querySelector('span:first-child').textContent = 'Submit Quote Request';
    }
  }


  function isTaxExemptRequested() {
    return fields.taxStatuses?.some((input) => input.checked && input.value === 'exempt') || false;
  }

  function updateOrganizationVisibility() {
    const hasCompany = Boolean(fields.company?.value.trim());
    if (fields.organizationWrap) fields.organizationWrap.hidden = !hasCompany;
    if (!hasCompany) {
      if (fields.role) fields.role.value = '';
      if (fields.organizationType) fields.organizationType.value = '';
      fields.taxStatuses?.forEach((input) => { input.checked = input.value === 'taxable'; });
      if (fields.certificateType) fields.certificateType.value = '';
      if (fields.taxFile) fields.taxFile.value = '';
    }
    if (fields.taxDocuments) fields.taxDocuments.hidden = !hasCompany || !isTaxExemptRequested();
  }

  function updateTaxFileStatus() {
    if (!fields.taxFileStatus) return;
    const file = fields.taxFile?.files?.[0];
    if (!file) {
      fields.taxFileStatus.textContent = 'PDF, JPG, or PNG up to 20 MB.';
      return;
    }
    const sizeMb = (file.size / (1024 * 1024)).toFixed(file.size >= 1024 * 1024 ? 1 : 2);
    fields.taxFileStatus.textContent = file.size > 20 * 1024 * 1024
      ? `${file.name} is too large. Maximum size is 20 MB.`
      : `${file.name} selected (${sizeMb} MB). The filename will be recorded with the quote.`;
  }

  fields.company?.addEventListener('input', updateOrganizationVisibility);
  fields.taxStatuses?.forEach((input) => input.addEventListener('change', updateOrganizationVisibility));
  fields.taxFile?.addEventListener('change', updateTaxFileStatus);
  updateOrganizationVisibility();
  updateTaxFileStatus();

  fields.quantity?.addEventListener('blur', () => {
    const quantity = Number.parseInt(fields.quantity.value || '0', 10);
    if (!Number.isFinite(quantity) || quantity < 21) fields.quantity.value = '21';
    renderSummary();
  });

  fields.quantity?.addEventListener('input', () => {
    fields.quantity.setCustomValidity(
      Number.parseInt(fields.quantity.value || '0', 10) >= 21
        ? ''
        : 'Custom apparel quote requests require at least 21 shirts.'
    );
  });


  openers.forEach((opener) => {
    opener.addEventListener('click', openModal);
    opener.addEventListener('keydown', (event) => {
      if (event.key === 'Enter' || event.key === ' ') openModal(event);
    });
  });
  closers.forEach((closer) => closer.addEventListener('click', closeModal));
  submitButton.addEventListener('click', submitQuote);

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && !modal.hidden) closeModal();
  });
});
/* ===== END Moments Etched v3.7.0 bulk quote workflow ===== */

function updateStickyBar(totalQty, totalPrice) {
  let bar = document.getElementById('me-sticky-bar');

  if (!bar) {
    bar = document.createElement('div');
    bar.id = 'me-sticky-bar';
    bar.innerHTML = `
      <div class="me-sticky-inner">
        <span id="me-sticky-summary"></span>
        <button id="me-sticky-btn">Add to Cart →</button>
      </div>
    `;
    document.body.appendChild(bar);

    document.getElementById('me-sticky-btn').onclick = () => {
      document.querySelector('.add-to-cart-button')?.click();
    };
  }

  bar.style.display = totalQty > 0 ? 'flex' : 'none';
  document.getElementById('me-sticky-summary').innerText =
    `${totalQty} items | $${totalPrice.toFixed(2)}`;
}
